'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */
var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
}

/**
 * 兼容 SSR、react native、worker 等非浏览器场景
 */
var commonGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
(function () {
    if (typeof commonGlobal.window === 'undefined') {
        console.log('weblogger is running in non-browser env');
        commonGlobal.window = {
            addEventListener: function () { },
            removeEventListener: function () { },
            setTimeout: function () { },
            setInterval: function () { },
            _WEBLOGGER_MOCKED_WINDOW_: true,
            global: commonGlobal
        };
    }
    if (typeof commonGlobal.document === 'undefined') {
        commonGlobal.document = commonGlobal.window.document || {
            cookie: '',
            addEventListener: function () { },
            removeEventListener: function () { },
            querySelector: function () { },
            querySelectorAll: function () { },
        };
        if (typeof commonGlobal.window.document === 'undefined') {
            commonGlobal.window.document = commonGlobal.document;
        }
    }
    if (typeof commonGlobal.navigator === 'undefined') {
        commonGlobal.navigator = commonGlobal.window.navigator || {
            userAgent: ''
        };
        if (typeof commonGlobal.window.navigator === 'undefined') {
            commonGlobal.window.navigator = commonGlobal.navigator;
        }
    }
    if (typeof commonGlobal.screen === 'undefined') {
        commonGlobal.screen = commonGlobal.window.screen || {};
        if (typeof commonGlobal.window.screen === 'undefined') {
            commonGlobal.window.screen = commonGlobal.screen;
        }
    }
    if (typeof commonGlobal.history === 'undefined') {
        commonGlobal.history = commonGlobal.window.history || {};
        if (typeof commonGlobal.window.history === 'undefined') {
            commonGlobal.window.history = commonGlobal.history;
        }
    }
    if (typeof commonGlobal.location === 'undefined') {
        commonGlobal.location = commonGlobal.window.location || {
            hostname: '',
            search: '',
            href: '',
            origin: ''
        };
        if (typeof commonGlobal.window.location === 'undefined') {
            commonGlobal.window.location = commonGlobal.location;
        }
    }
    try {
        if (typeof commonGlobal.localStorage === 'undefined') {
            commonGlobal.localStorage = commonGlobal.window.localStorage || {
                getItem: function () { },
                setItem: function () { }
            };
            if (typeof commonGlobal.window.localStorage === 'undefined') {
                commonGlobal.window.localStorage = commonGlobal.localStorage;
            }
        }
    }
    catch (err) { }
})();

/**
 * Object.defineProperty 容错暂时处理
 */
if (!Object.defineProperty) {
    Object.defineProperty = function (target, key, descriptor) {
        target[key] = Object.prototype.toString.call(descriptor) === '[object Object]'
            && descriptor.hasOwnProperty('value')
            ? descriptor.value
            : descriptor;
    };
}
/**
 * Object.assign polyfill
 */
if (!Object.assign) {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, 'assign', {
        value: function (target) {
            if (target === null) { // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }
            var to = Object(target);
            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];
                if (nextSource !== null) { // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true,
    });
}
/**
 * bind polyfill
 */
if (!Function.prototype.bind) {
    Function.prototype.bind = function (oThis) {
        if (typeof this !== 'function') {
            // closest thing possible to the ECMAScript 5
            // internal IsCallable function
            throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
        }
        var aArgs = Array.prototype.slice.call(arguments, 1);
        /* tslint:disable no-this-assignment */
        var fToBind = this;
        /* tslint:enable */
        var FNOP = /** @class */ (function () {
            function FNOP() {
            }
            return FNOP;
        }());
        var fBound = function () {
            var currentThis = this instanceof FNOP
                ? this
                : oThis;
            // this instanceof FNOP === true时,说明返回的fBound被当做new的构造函数调用
            return fToBind.apply(currentThis, 
            // 获取调用时(fBound)的传参.bind 返回的函数入参往往是这么传递的
            aArgs.concat(Array.prototype.slice.call(arguments)));
        };
        // 维护原型关系
        if (this.prototype) {
            // Function.prototype doesn't have a prototype property
            FNOP.prototype = this.prototype;
        }
        // 下行的代码使fBound.prototype是FNOP的实例,因此
        // 返回的fBound若作为new的构造函数,new生成的新对象作为this传入fBound,新对象的__proto__就是FNOP的实例
        fBound.prototype = new FNOP();
        return fBound;
    };
}
/**
 * indexOf polyfill
 */
// Production steps of ECMA-262, Edition 5, 15.4.4.14
// Reference: http://es5.github.io/#x15.4.4.14
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement, fromIndex) {
        var k;
        // 1. Let O be the result of calling ToObject passing
        //    the this value as the argument.
        if (this == null) {
            throw new TypeError('"this" is null or not defined');
        }
        var O = Object(this);
        // 2. Let lenValue be the result of calling the Get
        //    internal method of O with the argument "length".
        // 3. Let len be ToUint32(lenValue).
        var len = O.length >>> 0;
        // 4. If len is 0, return -1.
        if (len === 0) {
            return -1;
        }
        // 5. If argument fromIndex was passed let n be
        //    ToInteger(fromIndex); else let n be 0.
        var n = +fromIndex || 0;
        if (Math.abs(n) === Infinity) {
            n = 0;
        }
        // 6. If n >= len, return -1.
        if (n >= len) {
            return -1;
        }
        // 7. If n >= 0, then Let k be n.
        // 8. Else, n<0, Let k be len - abs(n).
        //    If k is less than 0, then let k be 0.
        k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
        // 9. Repeat, while k < len
        while (k < len) {
            // a. Let Pk be ToString(k).
            //   This is implicit for LHS operands of the in operator
            // b. Let kPresent be the result of calling the
            //    HasProperty internal method of O with argument Pk.
            //   This step can be combined with c
            // c. If kPresent is true, then
            //    i.  Let elementK be the result of calling the Get
            //        internal method of O with the argument ToString(k).
            //   ii.  Let same be the result of applying the
            //        Strict Equality Comparison Algorithm to
            //        searchElement and elementK.
            //  iii.  If same is true, return k.
            if (k in O && O[k] === searchElement) {
                return k;
            }
            k++;
        }
        return -1;
    };
}
if (!Object.keys) {
    Object.keys = (function () {
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString');
        var dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor',
        ];
        return function (obj) {
            if (typeof obj !== 'object' && typeof obj !== 'function' || obj === null) {
                throw new TypeError('Object.keys called on non-object');
            }
            var result = [];
            for (var prop in obj) {
                if (hasOwnProperty.call(obj, prop))
                    result.push(prop);
            }
            if (hasDontEnumBug) {
                for (var _i = 0, dontEnums_1 = dontEnums; _i < dontEnums_1.length; _i++) {
                    var key = dontEnums_1[_i];
                    if (hasOwnProperty.call(obj, key)) {
                        result.push(key);
                    }
                }
            }
            return result;
        };
    })();
}
// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.io/#x15.4.4.18
if (!Array.prototype.forEach) {
    Array.prototype.forEach = function (callback, thisArg) {
        var T;
        var k;
        if (this == null) {
            throw new TypeError(' this is null or not defined');
        }
        // 1. Let O be the result of calling toObject() passing the
        // |this| value as the argument.
        var O = Object(this);
        // 2. Let lenValue be the result of calling the Get() internal
        // method of O with the argument "length".
        // 3. Let len be toUint32(lenValue).
        var len = O.length >>> 0;
        // 4. If isCallable(callback) is false, throw a TypeError exception.
        // See: http://es5.github.com/#x9.11
        if (typeof callback !== 'function') {
            throw new TypeError(callback + ' is not a function');
        }
        // 5. If thisArg was supplied, let T be thisArg; else let
        // T be undefined.
        if (arguments.length > 1) {
            T = thisArg;
        }
        // 6. Let k be 0
        k = 0;
        // 7. Repeat, while k < len
        while (k < len) {
            var kValue = void 0;
            // a. Let Pk be ToString(k).
            //    This is implicit for LHS operands of the in operator
            // b. Let kPresent be the result of calling the HasProperty
            //    internal method of O with argument Pk.
            //    This step can be combined with c
            // c. If kPresent is true, then
            if (k in O) {
                // i. Let kValue be the result of calling the Get internal
                // method of O with argument Pk.
                kValue = O[k];
                // ii. Call the Call internal method of callback with T as
                // the this value and argument list containing kValue, k, and O.
                callback.call(T, kValue, k, O);
            }
            // d. Increase k by 1.
            k++;
        }
        // 8. return undefined
    };
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var md5 = createCommonjsModule(function (module) {

  (function ($) {
    /**
     * Add integers, wrapping at 2^32.
     * This uses 16-bit operations internally to work around bugs in interpreters.
     *
     * @param {number} x First integer
     * @param {number} y Second integer
     * @returns {number} Sum
     */

    function safeAdd(x, y) {
      var lsw = (x & 0xffff) + (y & 0xffff);
      var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
      return msw << 16 | lsw & 0xffff;
    }
    /**
     * Bitwise rotate a 32-bit number to the left.
     *
     * @param {number} num 32-bit number
     * @param {number} cnt Rotation count
     * @returns {number} Rotated number
     */


    function bitRotateLeft(num, cnt) {
      return num << cnt | num >>> 32 - cnt;
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} q q
     * @param {number} a a
     * @param {number} b b
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */


    function md5cmn(q, a, b, x, s, t) {
      return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} a a
     * @param {number} b b
     * @param {number} c c
     * @param {number} d d
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */


    function md5ff(a, b, c, d, x, s, t) {
      return md5cmn(b & c | ~b & d, a, b, x, s, t);
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} a a
     * @param {number} b b
     * @param {number} c c
     * @param {number} d d
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */


    function md5gg(a, b, c, d, x, s, t) {
      return md5cmn(b & d | c & ~d, a, b, x, s, t);
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} a a
     * @param {number} b b
     * @param {number} c c
     * @param {number} d d
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */


    function md5hh(a, b, c, d, x, s, t) {
      return md5cmn(b ^ c ^ d, a, b, x, s, t);
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} a a
     * @param {number} b b
     * @param {number} c c
     * @param {number} d d
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */


    function md5ii(a, b, c, d, x, s, t) {
      return md5cmn(c ^ (b | ~d), a, b, x, s, t);
    }
    /**
     * Calculate the MD5 of an array of little-endian words, and a bit length.
     *
     * @param {Array} x Array of little-endian words
     * @param {number} len Bit length
     * @returns {Array<number>} MD5 Array
     */


    function binlMD5(x, len) {
      /* append padding */
      x[len >> 5] |= 0x80 << len % 32;
      x[(len + 64 >>> 9 << 4) + 14] = len;
      var i;
      var olda;
      var oldb;
      var oldc;
      var oldd;
      var a = 1732584193;
      var b = -271733879;
      var c = -1732584194;
      var d = 271733878;

      for (i = 0; i < x.length; i += 16) {
        olda = a;
        oldb = b;
        oldc = c;
        oldd = d;
        a = md5ff(a, b, c, d, x[i], 7, -680876936);
        d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5gg(b, c, d, a, x[i], 20, -373897302);
        a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5hh(d, a, b, c, x[i], 11, -358537222);
        c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = md5ii(a, b, c, d, x[i], 6, -198630844);
        d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = safeAdd(a, olda);
        b = safeAdd(b, oldb);
        c = safeAdd(c, oldc);
        d = safeAdd(d, oldd);
      }

      return [a, b, c, d];
    }
    /**
     * Convert an array of little-endian words to a string
     *
     * @param {Array<number>} input MD5 Array
     * @returns {string} MD5 string
     */


    function binl2rstr(input) {
      var i;
      var output = '';
      var length32 = input.length * 32;

      for (i = 0; i < length32; i += 8) {
        output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xff);
      }

      return output;
    }
    /**
     * Convert a raw string to an array of little-endian words
     * Characters >255 have their high-byte silently ignored.
     *
     * @param {string} input Raw input string
     * @returns {Array<number>} Array of little-endian words
     */


    function rstr2binl(input) {
      var i;
      var output = [];
      output[(input.length >> 2) - 1] = undefined;

      for (i = 0; i < output.length; i += 1) {
        output[i] = 0;
      }

      var length8 = input.length * 8;

      for (i = 0; i < length8; i += 8) {
        output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32;
      }

      return output;
    }
    /**
     * Calculate the MD5 of a raw string
     *
     * @param {string} s Input string
     * @returns {string} Raw MD5 string
     */


    function rstrMD5(s) {
      return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
    }
    /**
     * Calculates the HMAC-MD5 of a key and some data (raw strings)
     *
     * @param {string} key HMAC key
     * @param {string} data Raw input string
     * @returns {string} Raw MD5 string
     */


    function rstrHMACMD5(key, data) {
      var i;
      var bkey = rstr2binl(key);
      var ipad = [];
      var opad = [];
      var hash;
      ipad[15] = opad[15] = undefined;

      if (bkey.length > 16) {
        bkey = binlMD5(bkey, key.length * 8);
      }

      for (i = 0; i < 16; i += 1) {
        ipad[i] = bkey[i] ^ 0x36363636;
        opad[i] = bkey[i] ^ 0x5c5c5c5c;
      }

      hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
      return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
    }
    /**
     * Convert a raw string to a hex string
     *
     * @param {string} input Raw input string
     * @returns {string} Hex encoded string
     */


    function rstr2hex(input) {
      var hexTab = '0123456789abcdef';
      var output = '';
      var x;
      var i;

      for (i = 0; i < input.length; i += 1) {
        x = input.charCodeAt(i);
        output += hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f);
      }

      return output;
    }
    /**
     * Encode a string as UTF-8
     *
     * @param {string} input Input string
     * @returns {string} UTF8 string
     */


    function str2rstrUTF8(input) {
      return unescape(encodeURIComponent(input));
    }
    /**
     * Encodes input string as raw MD5 string
     *
     * @param {string} s Input string
     * @returns {string} Raw MD5 string
     */


    function rawMD5(s) {
      return rstrMD5(str2rstrUTF8(s));
    }
    /**
     * Encodes input string as Hex encoded string
     *
     * @param {string} s Input string
     * @returns {string} Hex encoded string
     */


    function hexMD5(s) {
      return rstr2hex(rawMD5(s));
    }
    /**
     * Calculates the raw HMAC-MD5 for the given key and data
     *
     * @param {string} k HMAC key
     * @param {string} d Input string
     * @returns {string} Raw MD5 string
     */


    function rawHMACMD5(k, d) {
      return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
    }
    /**
     * Calculates the Hex encoded HMAC-MD5 for the given key and data
     *
     * @param {string} k HMAC key
     * @param {string} d Input string
     * @returns {string} Raw MD5 string
     */


    function hexHMACMD5(k, d) {
      return rstr2hex(rawHMACMD5(k, d));
    }
    /**
     * Calculates MD5 value for a given string.
     * If a key is provided, calculates the HMAC-MD5 value.
     * Returns a Hex encoded string unless the raw argument is given.
     *
     * @param {string} string Input string
     * @param {string} [key] HMAC key
     * @param {boolean} [raw] Raw output switch
     * @returns {string} MD5 output
     */


    function md5(string, key, raw) {
      if (!key) {
        if (!raw) {
          return hexMD5(string);
        }

        return rawMD5(string);
      }

      if (!raw) {
        return hexHMACMD5(key, string);
      }

      return rawHMACMD5(key, string);
    }

    if (module.exports) {
      module.exports = md5;
    } else {
      $.md5 = md5;
    }
  })(commonjsGlobal);
});

/**
 * @file webLogger工具函数
 * @author <zhangshen@kuaishou.com>
 * @author 天翔Skyline(skyline0705@gmail.com)
 */
/**
 * 创建一个cookie字符串，可被赋值给document.cookie.
 * @param {string} name cookie名称.
 * @param {string} value cookie值.
 * @param {boolean} encode 是否对值进行编码.
 * @param {Object} options (Optional) 配置项.
 * @return {string} 返回 cookie 字符串.
 */
function createCookieString(name, value, encode, options) {
    if (options === void 0) { options = {}; }
    var text = encodeURIComponent(name) + "=" + (encode ? encodeURIComponent(value) : value);
    var expires = options.expires;
    var path = options.path || '/';
    var domain = options.domain || '';
    if (expires instanceof Date) {
        text += "; expires=" + expires.toUTCString();
    }
    if (typeof expires === 'number') {
        text += "; max-age==" + expires;
    }
    if (path !== '') {
        text += "; path=" + path;
    }
    if (domain !== '') {
        text += "; domain=" + domain;
    }
    if (options.secure === true) {
        text += '; secure';
    }
    return text;
}
/**
 * 将cookie序列化成对象.
 * @param {string} text cookie值.
 * @param {boolean=} shouldDecode cookie是否需要被解码. 默认为true.
 * @param {object=} options 如何读取cookie的配置.
 * @return {object} 可访问cookie的序列化结果
 */
function parseCookieString(text, shouldDecode, options) {
    var cookies = {};
    if (text.length > 0) {
        var decodeValue = !shouldDecode
            ? function (s) {
                return s;
            }
            : decodeURIComponent;
        var cookieParts = text.split(/;\s/g);
        var cookieName = null;
        var cookieValue = null;
        var cookieNameValue = null;
        for (var i = 0, len = cookieParts.length; i < len; i++) {
            cookieNameValue = cookieParts[i].match(/([^=]+)=/i);
            if (cookieNameValue !== null) {
                try {
                    cookieName = decodeURIComponent(cookieNameValue[1]);
                    cookieValue = decodeValue(cookieParts[i].substring(cookieNameValue[1].length + 1));
                }
                catch (ex) {
                    // 忽略
                }
            }
            else {
                // cookie 中没有 "=", 当成布尔值
                cookieName = decodeURIComponent(cookieParts[i]);
                cookieValue = '';
            }
            if (cookieName !== null) {
                // 默认后面的cookie覆盖前面的
                cookies[cookieName] = cookieValue;
            }
        }
    }
    return cookies;
}
var cookiesMap = {};
/**
 * 获取cookie值.
 * @param {string} name cookie名称.
 * @param {object=} options 配置项
 *                    raw: 是否进行编码，true则是未编码
 * @return {*} 不存在返回null.
 */
function getCookie(name, options, useCaches) {
    if (options === void 0) { options = {}; }
    if (useCaches === void 0) { useCaches = false; }
    try {
        if (typeof document === 'undefined' || !document.cookie) {
            return null;
        }
        if (useCaches && name in cookiesMap) {
            return cookiesMap[name];
        }
        var cookies = parseCookieString(document.cookie, !options.raw, options);
        cookiesMap = cookies;
        var cookie = cookies[name];
        if (cookie === void 0) {
            return null;
        }
        return cookie;
    }
    catch (err) {
        return null;
    }
}
/**
 * 给定的键值设置cookie
 * @param {string} name 名称.
 * @param {*} value cookie值.
 * @param {object=} options (Optional) 配置项:
 *      path 路径
 *      domain 域名
 *      expires 过期时间，一个Date对象
 *      secure 是否安全cookie
 *      raw (true/false). Setting raw to true indicates that the cookie should not be URI encoded before being set.
 */
function setCookie(name, value, options) {
    if (options === void 0) { options = {}; }
    try {
        document.cookie = createCookieString(name, value, !options.raw, options);
        return true;
    }
    catch (err) {
        return false;
    }
}
var cookieUtils = {
    getCookie: getCookie,
    setCookie: setCookie,
    parseCookieString: parseCookieString
};

/**
 * 生成nano id
 * @return {string} 16长度的字符串
 */
function nanoId() {
    var ts = ((Math.random() * 1e9) >>> 0);
    var randomer = [];
    var seed = '0123456789ABCDEF';
    for (var i = 0; i < 7; i++) {
        randomer.push(seed.charAt(Math.random() * 16));
    }
    return ts + randomer.join('');
}
/**
 * 提取顶级域名
 * @param {?string=} hostname
 * @return {string} 返回顶级域名
 */
function resolveTopLevelDomain(hostname) {
    if (hostname === void 0) { hostname = typeof location !== 'undefined' ? location.hostname : ''; }
    if (!hostname) {
        return '';
    }
    var ret = hostname.split('.');
    var len = ret.length;
    return (len <= 2 ? '' : "." + ret[len - 2] + "." + ret[len - 1]);
}
var didKey = 'did';
var did = '';
/**
 * 生成did
 * @return {string}
 */
function generateDID() {
    if (did)
        return did;
    try {
        // 兼容一下原下发的did逻辑，如果能从did获取，那么就走did
        // 如果不能，那就通过log sdk自行维护的_did来搞
        did = getCookie(didKey) || getCookie('_did');
        if (!did) {
            did = "web_" + nanoId();
            var expires = new Date();
            expires.setFullYear(expires.getFullYear() + 1);
            setCookie('_did', did, {
                expires: expires,
                domain: resolveTopLevelDomain(),
                path: '/',
            });
        }
        return did;
    }
    catch (err) {
        return '';
    }
}
/**
 * 生成唯一UUID
 */
var uuid = function (page) {
    var randomStr = page + new Date().getTime() + generateDID() + nanoId();
    var hash = md5(randomStr);
    return hash;
};

var GlobalConfig = {
    proto: 'v3',
    sessionId: '',
    isDebug: false,
    isBridge: false,
    get isV2() { return GlobalConfig.proto === 'v2'; },
};
var updateConfig = function (key, value) {
    GlobalConfig[key] = value;
};

/**
 * v2、v3 PB 相同部分
 */
var Base;
(function (Base) {
    (function (NetworkPackageType) {
        NetworkPackageType[NetworkPackageType["UNKNOWN_NETWORK"] = 0] = "UNKNOWN_NETWORK";
        NetworkPackageType[NetworkPackageType["NOT_CONNECTED"] = 1] = "NOT_CONNECTED";
        NetworkPackageType[NetworkPackageType["WIFI"] = 2] = "WIFI";
        NetworkPackageType[NetworkPackageType["MOBILE_4G"] = 3] = "MOBILE_4G";
        NetworkPackageType[NetworkPackageType["MOBILE_3G"] = 4] = "MOBILE_3G";
        NetworkPackageType[NetworkPackageType["MOBILE_2G"] = 5] = "MOBILE_2G";
        NetworkPackageType[NetworkPackageType["MOBILE_UNKNOWN"] = 6] = "MOBILE_UNKNOWN";
        NetworkPackageType[NetworkPackageType["MOBILE_5G"] = 7] = "MOBILE_5G";
    })(Base.NetworkPackageType || (Base.NetworkPackageType = {}));
    (function (AdditionalSeqIdPackageChannel) {
        AdditionalSeqIdPackageChannel[AdditionalSeqIdPackageChannel["UNKNOWN1"] = 0] = "UNKNOWN1";
        AdditionalSeqIdPackageChannel[AdditionalSeqIdPackageChannel["REALTIME"] = 1] = "REALTIME";
        AdditionalSeqIdPackageChannel[AdditionalSeqIdPackageChannel["HIGH_FREQ"] = 2] = "HIGH_FREQ";
        AdditionalSeqIdPackageChannel[AdditionalSeqIdPackageChannel["NORMAL"] = 3] = "NORMAL";
    })(Base.AdditionalSeqIdPackageChannel || (Base.AdditionalSeqIdPackageChannel = {}));
    (function (Platform) {
        Platform[Platform["UNKNOWN_PLATFORM"] = 0] = "UNKNOWN_PLATFORM";
        Platform[Platform["ANDROID_PHONE"] = 1] = "ANDROID_PHONE";
        Platform[Platform["ANDROID_PAD"] = 2] = "ANDROID_PAD";
        Platform[Platform["IPHONE"] = 3] = "IPHONE";
        Platform[Platform["IPAD"] = 4] = "IPAD";
        Platform[Platform["WINDOWS_PC"] = 5] = "WINDOWS_PC";
        // 注: 同上
        Platform[Platform["ANDROID_PHONE_H5"] = 6] = "ANDROID_PHONE_H5";
        Platform[Platform["IPHONE_H5"] = 7] = "IPHONE_H5";
        Platform[Platform["OUTSIDE_ANDROID_H5"] = 8] = "OUTSIDE_ANDROID_H5";
        Platform[Platform["OUTSIDE_IOS_H5"] = 9] = "OUTSIDE_IOS_H5";
        Platform[Platform["PC_WEB"] = 10] = "PC_WEB";
    })(Base.Platform || (Base.Platform = {}));
    (function (Container) {
        Container["NATIVE"] = "NATIVE";
        Container["REACT_NATIVE"] = "REACT_NATIVE";
        Container["H5"] = "H5";
        Container["MP_WECHAT"] = "MP_WECHAT";
        Container["MP_ALIPAY"] = "MP_ALIPAY";
        Container["MP_BAIDU"] = "MP_BAIDU";
        Container["WEB"] = "WEB";
    })(Base.Container || (Base.Container = {}));
    (function (PageType) {
        PageType[PageType["UNKNOWN_PAGE_TYPE"] = 0] = "UNKNOWN_PAGE_TYPE";
        PageType[PageType["NATIVE"] = 1] = "NATIVE";
        PageType[PageType["H5"] = 2] = "H5";
        PageType[PageType["MINA"] = 3] = "MINA";
    })(Base.PageType || (Base.PageType = {}));
    (function (ElementStatus) {
        ElementStatus[ElementStatus["UNKNOWN_STATUS"] = 0] = "UNKNOWN_STATUS";
        ElementStatus[ElementStatus["CHECKED"] = 1] = "CHECKED";
        ElementStatus[ElementStatus["UNCHECKED"] = 2] = "UNCHECKED";
    })(Base.ElementStatus || (Base.ElementStatus = {}));
    (function (PageShowAction) {
        PageShowAction[PageShowAction["UNKNOWN_ACTION"] = 0] = "UNKNOWN_ACTION";
        PageShowAction[PageShowAction["ENTER"] = 1] = "ENTER";
        PageShowAction[PageShowAction["LEAVE"] = 2] = "LEAVE";
        PageShowAction[PageShowAction["RESUME"] = 3] = "RESUME";
    })(Base.PageShowAction || (Base.PageShowAction = {}));
    (function (ActionStatus) {
        ActionStatus[ActionStatus["UNKNOWN_STATUS"] = 0] = "UNKNOWN_STATUS";
        ActionStatus[ActionStatus["SUCCESS"] = 1] = "SUCCESS";
        ActionStatus[ActionStatus["FAIL"] = 2] = "FAIL";
    })(Base.ActionStatus || (Base.ActionStatus = {}));
    (function (ActionType) {
        ActionType[ActionType["UNKNOWN_ACTION_TYPE"] = 0] = "UNKNOWN_ACTION_TYPE";
        ActionType[ActionType["CLICK"] = 1] = "CLICK";
        ActionType[ActionType["LEFT_PULL"] = 2] = "LEFT_PULL";
        ActionType[ActionType["RIGHT_PULL"] = 3] = "RIGHT_PULL";
        ActionType[ActionType["UP_PULL"] = 4] = "UP_PULL";
        ActionType[ActionType["DOWN_PULL"] = 5] = "DOWN_PULL";
    })(Base.ActionType || (Base.ActionType = {}));
    (function (SubAction) {
        SubAction[SubAction["UNKNOWN_SUB_ACTION"] = 0] = "UNKNOWN_SUB_ACTION";
        SubAction[SubAction["PAGE_ENTER"] = 1] = "PAGE_ENTER";
        SubAction[SubAction["PAGE_LEAVE"] = 2] = "PAGE_LEAVE";
        SubAction[SubAction["PAGE_RESUME"] = 3] = "PAGE_RESUME";
        SubAction[SubAction["PAGE_PAUSE"] = 4] = "PAGE_PAUSE";
    })(Base.SubAction || (Base.SubAction = {}));
    (function (Direction) {
        Direction[Direction["UNKNOWN2"] = 0] = "UNKNOWN2";
        Direction[Direction["UP"] = 1] = "UP";
        Direction[Direction["DOWN"] = 2] = "DOWN";
        Direction[Direction["LEFT"] = 3] = "LEFT";
        Direction[Direction["RIGHT"] = 4] = "RIGHT";
    })(Base.Direction || (Base.Direction = {}));
    (function (TaskStatus) {
        TaskStatus[TaskStatus["UNKNOWN_STATUS"] = 0] = "UNKNOWN_STATUS";
        TaskStatus[TaskStatus["START"] = 1] = "START";
        TaskStatus[TaskStatus["RETRY"] = 2] = "RETRY";
        TaskStatus[TaskStatus["PAUSE"] = 3] = "PAUSE";
        TaskStatus[TaskStatus["RESUME"] = 4] = "RESUME";
        TaskStatus[TaskStatus["PENDING"] = 5] = "PENDING";
        TaskStatus[TaskStatus["PROCESSING"] = 6] = "PROCESSING";
        TaskStatus[TaskStatus["SUCCESS"] = 7] = "SUCCESS";
        TaskStatus[TaskStatus["FAIL"] = 8] = "FAIL";
        TaskStatus[TaskStatus["CANCEL"] = 9] = "CANCEL";
        TaskStatus[TaskStatus["FINISH"] = 10] = "FINISH";
    })(Base.TaskStatus || (Base.TaskStatus = {}));
    (function (OperationType) {
        OperationType[OperationType["UNKNOWN_OPERATION"] = 0] = "UNKNOWN_OPERATION";
        OperationType[OperationType["CLICK"] = 1] = "CLICK";
        OperationType[OperationType["DOUBLE_CLICK"] = 2] = "DOUBLE_CLICK";
        OperationType[OperationType["TRIPLE_CLICK"] = 3] = "TRIPLE_CLICK";
        OperationType[OperationType["LONG_PRESS"] = 4] = "LONG_PRESS";
        OperationType[OperationType["PULL"] = 5] = "PULL";
        OperationType[OperationType["DRAG"] = 6] = "DRAG";
        OperationType[OperationType["SCALE"] = 7] = "SCALE";
        OperationType[OperationType["PULL_DOWN"] = 8] = "PULL_DOWN";
        OperationType[OperationType["PULL_UP"] = 9] = "PULL_UP";
        OperationType[OperationType["RIGHT_CLICK"] = 10] = "RIGHT_CLICK";
        OperationType[OperationType["AUTO"] = 10] = "AUTO";
    })(Base.OperationType || (Base.OperationType = {}));
})(Base || (Base = {}));

/**
 * 快手系应用UA标示
 */
// TODO 海外 APP List 要求不区分大小写判断
var ksOverseaAppList = ['UVideo', 'Vstatus', 'Kwaigo', 'MvMaster'];
// TODO这么加没个完了，后面想办法搞成自行传入吧
var ksAppList = [
    'Kwai',
    'Kwai_Lite',
    'Kwai_Pro',
    'livemate',
    'ksthanos',
    'ksNebula',
    'ksnebula',
    'kwaiying',
    'pearl',
    'kinder',
    'm2u',
    'LOLita',
    'XFunCore',
    'ACVideoCore',
    'ZIKZAK',
].concat(ksOverseaAppList);

/**
 * @file webLogger工具函数
 * @author <zhangshen@kuaishou.com>
 * @author 天翔Skyline(skyline0705@gmail.com)
 */
/**
 * 获取 localStorage 缓存
 */
function getLocalStorageItem(key) {
    try {
        if (window && window.localStorage) {
            var value = window.localStorage.getItem(key);
            if (value) {
                try {
                    return JSON.parse(value);
                }
                catch (err) {
                    return value;
                }
            }
        }
    }
    catch (err) {
        return null;
    }
    return null;
}
/**
 * 设置 localStorage 缓存
 */
function setLocalStorageItem(key, value) {
    try {
        if (window && window.localStorage) {
            window.localStorage.setItem(key, JSON.stringify(value));
            return true;
        }
    }
    catch (err) {
        return false;
    }
    return false;
}
/**
 * 从目标arr中删除item
 * @param {*} arr  目标数组
 * @param {*} item  item
 */
function deleteArray(arr, item) {
    var index = arr.indexOf(item);
    if (index > -1) {
        arr.splice(index, 1);
    }
}
/**
 * 事件监听兼容处理
 * @param {*} evtTarget  事件监听目标
 * @param {*} evtName   事件名
 * @param {*} callback  回调函数
 * @param {*} options  相关参数设置
 */
function addMonitor(evtTarget, evtName, callback, options) {
    if ('attachEvent' in evtTarget) {
        return evtTarget.attachEvent('on' + evtName, callback);
    }
    return evtTarget.addEventListener(evtName, callback, options);
}
/**
 * 事件监听解绑兼容处理
 * @param {*} evtTarget  事件监听目标
 * @param {*} evtName   事件名
 * @param {*} callback  事件回调
 */
function removeMonitor(evtTarget, evtName, callback, options) {
    if ('attachEvent' in evtTarget) {
        return evtTarget.detachEvent('on' + evtName, callback);
    }
    return evtTarget.removeEventListener(evtName, callback, options);
}
function leftPad(str, len, ch) {
    if (ch === void 0) { ch = ' '; }
    len = len - str.length;
    if (len <= 0) {
        return str;
    }
    var pad = '';
    while (len) {
        if (len & 1) {
            pad += ch;
        }
        len >>= 1;
        ch += ch;
    }
    return pad + str;
}
/**
 * 是否是快手系APP
 */
var isInApp = (function () {
    // 防止SSR出问题，所以需要给出方法而不是直接属性
    var inApp = null;
    return function () {
        try {
            if (inApp === null) {
                for (var i = 0; i < ksAppList.length; i++) {
                    var isOversea = ksOverseaAppList.indexOf(ksAppList[i]) > -1;
                    if (isOversea) {
                        if (window.navigator.userAgent.toLowerCase().indexOf(ksAppList[i].toLowerCase()) > -1) {
                            inApp = true;
                            break;
                        }
                    }
                    else {
                        if (window.navigator.userAgent.indexOf(ksAppList[i]) > -1) {
                            inApp = true;
                            break;
                        }
                    }
                }
            }
            return inApp;
        }
        catch (err) {
            return false;
        }
    };
})();
function fakeRaf(callback) {
    return setTimeout(callback, 1000 / 16);
}
var fakeCaf = clearTimeout;
var raf = function (callback) {
    var fn = window.requestAnimationFrame
        || window.mozRequestAnimationFrame
        || window.webkitRequestAnimationFrame
        || fakeRaf;
    return fn.call(this, callback);
};
var caf = function (handle) {
    var fn = window.cancelAnimationFrame
        || window.mozCancelAnimationFrame
        || window.webkitCancelAnimationFrame
        || fakeCaf;
    return fn.call(this, handle);
};
function parseQueryString(queryString) {
    var result = {};
    var queries = queryString.split('&');
    for (var _i = 0, queries_1 = queries; _i < queries_1.length; _i++) {
        var query = queries_1[_i];
        var _a = query.split('='), key = _a[0], value = _a[1];
        if (!(key in result)) {
            result[key] = value;
            continue;
        }
        if (result[key] instanceof Array) {
            result[key].push(value);
            continue;
        }
        result[key] = [result[key], value];
    }
    return result;
}
function stringifyQuery(paramsString) {
    var params = typeof paramsString === 'string' ? JSON.parse(paramsString) : paramsString;
    var queries = [];
    Object.keys(params).forEach(function (key) {
        if (params[key] instanceof Array) {
            for (var _i = 0, _a = params[key]; _i < _a.length; _i++) {
                var val = _a[_i];
                queries.push(key + "=" + val);
            }
        }
        else if (typeof params[key] === 'object' && params[key] !== null) {
            queries.push(key + "=" + JSON.stringify(params[key]));
        }
        else {
            queries.push(key + "=" + params[key]);
        }
    });
    return queries.join('&');
}
// 参考：https://codereview.stackexchange.com/questions/37512/count-byte-length-of-string
function getStringBytes(data) {
    var dataStr = '';
    // Force string type
    if (typeof data === 'string') {
        dataStr = data;
    }
    else {
        try {
            dataStr = JSON.stringify(data);
        }
        catch (e) {
            dataStr = String(data);
        }
    }
    var byteLen = 0;
    for (var i = 0; i < dataStr.length; i++) {
        var c = dataStr.charCodeAt(i);
        byteLen += c < (1 << 7) ? 1 :
            c < (1 << 11) ? 2 :
                c < (1 << 16) ? 3 :
                    c < (1 << 21) ? 4 :
                        c < (1 << 26) ? 5 :
                            c < (1 << 31) ? 6 : Number.NaN;
    }
    return byteLen;
}
/**
 * http://git.corp.kuaishou.com/ks-frontend/modules/web-util/blob/master/src/device.js
 */
var kpnFromUA = (function () {
    return function () {
        if (typeof window === 'undefined')
            return '';
        var ua = window.navigator.userAgent;
        // 注意顺序很重要
        var rules = [
            [/ wxwork\//, 'workWechat'],
            [/ MicroMessenger\//, 'wechat'],
            [/ Kwai\//, 'KUAISHOU'],
            [/ ksthanos\//, 'THANOS'],
            [/ ksNebula\//i, 'NEBULA'],
            [/ QQ\//, 'qq'],
            [/__weibo__([^_]+)/, 'weibo'],
            [/ livemate\//, 'livemate'],
            [/ baiduboxapp\//, 'baidu'],
            [/ MQQBrowser\//, 'qqBrowser'],
            [/\(MSIE ([^;]+);/, 'ie'],
        ];
        for (var i = 0; i < rules.length; i++) {
            var tmp = rules[i];
            var rule = tmp[0];
            var name_1 = tmp[1];
            var rRes = rule.exec(ua);
            if (rRes) {
                return name_1;
            }
        }
        return '';
    };
})();
/**
 * 获取默认的 KPN
 */
function getDefaultKpn() {
    var kpnInCookie = getCookie('kpn');
    var kpnInUA = kpnFromUA();
    return kpnInCookie || kpnInUA || '';
}
function getUrlAndQueryFromUrl(url) {
    if (url === void 0) { url = location.href; }
    var queryIndex = url.lastIndexOf('?');
    if (queryIndex === -1) {
        return {
            page: url
        };
    }
    var page = url.slice(0, queryIndex);
    var queryString = url.slice(queryIndex + 1);
    return {
        page: page,
        params: parseQueryString(queryString),
    };
}
var getMappingPage = function (urlPackage, urlMap) {
    var url = urlPackage.url, page = urlPackage.page, params = urlPackage.params;
    if (!page && typeof url === 'string') {
        var parsed = getUrlAndQueryFromUrl(url);
        page = parsed.page;
        params = parsed.params;
    }
    if (typeof urlMap === 'function') {
        try {
            var res = urlMap({ url: url, page: page, params: params });
            if (typeof res === 'string') {
                page = res;
            }
            else if (typeof res === 'object') {
                if (res.page) {
                    page = res.page;
                }
                if (res.params) {
                    params = res.params;
                }
            }
        }
        catch (err) { }
    }
    else if (typeof urlMap === 'object') {
        var mappingPage = '';
        for (var key in urlMap) {
            if ((url || page || '').indexOf(key) > -1) {
                mappingPage = urlMap[key];
                break;
            }
        }
        if (mappingPage) {
            page = mappingPage;
        }
    }
    return {
        page: page,
        params: params
    };
};
function cloneDeep(obj) {
    if (typeof obj !== 'object')
        return {};
    var newObj = obj instanceof Array ? [] : {};
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            // @ts-ignore
            newObj[key] = typeof obj[key] === 'object' ? cloneDeep(obj[key]) : obj[key];
        }
    }
    return newObj;
}
function supportsPushState$1() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1)
        && ua.indexOf('Mobile Safari') !== -1
        && ua.indexOf('Chrome') === -1
        && ua.indexOf('Windows Phone') === -1) {
        return false;
    }
    return typeof window !== 'undefined' && window.history && 'pushState' in window.history;
}
var urlChangeEventId = supportsPushState$1() ? 'popstate' : 'hashchange';
function pageUrlWarnForV2(page) {
    // 对于上报到v2，page为url的埋点，给予警告
    if (page && /^(https?:)?\/\//.test(page)) {
        console.error("\u8BF7\u6CE8\u610F\u9875\u9762" + page + "\u57CB\u70B9\u4E0A\u62A5\u4E3Aurl\uFF0C\u89C4\u8303\u4E0A\u62A5\u5E94\u4E3A\u57CB\u70B9\u5E73\u53F0\u6CE8\u518C\u7684\u9875\u9762\u6807\u8BC6\uFF0C\u8BF7\u53CA\u65F6\u5904\u7406\u30022021\u5E746\u670820\u65E5\u6570\u4ED3\u4F1A\u5BF9\u8FD9\u90E8\u5206\u6570\u636E\u8FDB\u884C\u8FC7\u6EE4\uFF0C\u5F71\u54CD\u6D88\u8D39");
    }
}

var uaParser = createCommonjsModule(function (module, exports) {
  /*!@license
   * UAParser.js v0.7.28
   * Lightweight JavaScript-based User-Agent string parser
   * https://github.com/faisalman/ua-parser-js
   *
   * Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   * Licensed under MIT License
   */
  (function (window, undefined$1) {
    // Constants
    /////////////

    var LIBVERSION = '0.7.28',
        EMPTY = '',
        UNKNOWN = '?',
        FUNC_TYPE = 'function',
        UNDEF_TYPE = 'undefined',
        OBJ_TYPE = 'object',
        STR_TYPE = 'string',
        MAJOR = 'major',
        // deprecated
    MODEL = 'model',
        NAME = 'name',
        TYPE = 'type',
        VENDOR = 'vendor',
        VERSION = 'version',
        ARCHITECTURE = 'architecture',
        CONSOLE = 'console',
        MOBILE = 'mobile',
        TABLET = 'tablet',
        SMARTTV = 'smarttv',
        WEARABLE = 'wearable',
        EMBEDDED = 'embedded',
        UA_MAX_LENGTH = 255; ///////////
    // Helper
    //////////

    var util = {
      extend: function extend(regexes, extensions) {
        var mergedRegexes = {};

        for (var i in regexes) {
          if (extensions[i] && extensions[i].length % 2 === 0) {
            mergedRegexes[i] = extensions[i].concat(regexes[i]);
          } else {
            mergedRegexes[i] = regexes[i];
          }
        }

        return mergedRegexes;
      },
      has: function has(str1, str2) {
        return _typeof(str1) === STR_TYPE ? str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1 : false;
      },
      lowerize: function lowerize(str) {
        return str.toLowerCase();
      },
      major: function major(version) {
        return _typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, '').split(".")[0] : undefined$1;
      },
      trim: function trim(str, len) {
        str = str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        return _typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
      }
    }; ///////////////
    // Map helper
    //////////////

    var mapper = {
      rgx: function rgx(ua, arrays) {
        var i = 0,
            j,
            k,
            p,
            q,
            matches,
            match; // loop through all regexes maps

        while (i < arrays.length && !matches) {
          var regex = arrays[i],
              // even sequence (0,2,4,..)
          props = arrays[i + 1]; // odd sequence (1,3,5,..)

          j = k = 0; // try matching uastring with regexes

          while (j < regex.length && !matches) {
            matches = regex[j++].exec(ua);

            if (!!matches) {
              for (p = 0; p < props.length; p++) {
                match = matches[++k];
                q = props[p]; // check if given property is actually array

                if (_typeof(q) === OBJ_TYPE && q.length > 0) {
                  if (q.length == 2) {
                    if (_typeof(q[1]) == FUNC_TYPE) {
                      // assign modified match
                      this[q[0]] = q[1].call(this, match);
                    } else {
                      // assign given value, ignore regex match
                      this[q[0]] = q[1];
                    }
                  } else if (q.length == 3) {
                    // check whether function or regex
                    if (_typeof(q[1]) === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                      // call function (usually string mapper)
                      this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                    } else {
                      // sanitize match using given regex
                      this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                    }
                  } else if (q.length == 4) {
                    this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                  }
                } else {
                  this[q] = match ? match : undefined$1;
                }
              }
            }
          }

          i += 2;
        }
      },
      str: function str(_str, map) {
        for (var i in map) {
          // check if array
          if (_typeof(map[i]) === OBJ_TYPE && map[i].length > 0) {
            for (var j = 0; j < map[i].length; j++) {
              if (util.has(map[i][j], _str)) {
                return i === UNKNOWN ? undefined$1 : i;
              }
            }
          } else if (util.has(map[i], _str)) {
            return i === UNKNOWN ? undefined$1 : i;
          }
        }

        return _str;
      }
    }; ///////////////
    // String map
    //////////////

    var maps = {
      browser: {
        // Safari < 3.0
        oldSafari: {
          version: {
            '1.0': '/8',
            '1.2': '/1',
            '1.3': '/3',
            '2.0': '/412',
            '2.0.2': '/416',
            '2.0.3': '/417',
            '2.0.4': '/419',
            '?': '/'
          }
        },
        oldEdge: {
          version: {
            '0.1': '12.',
            '21': '13.',
            '31': '14.',
            '39': '15.',
            '41': '16.',
            '42': '17.',
            '44': '18.'
          }
        }
      },
      os: {
        windows: {
          version: {
            'ME': '4.90',
            'NT 3.11': 'NT3.51',
            'NT 4.0': 'NT4.0',
            '2000': 'NT 5.0',
            'XP': ['NT 5.1', 'NT 5.2'],
            'Vista': 'NT 6.0',
            '7': 'NT 6.1',
            '8': 'NT 6.2',
            '8.1': 'NT 6.3',
            '10': ['NT 6.4', 'NT 10.0'],
            'RT': 'ARM'
          }
        }
      }
    }; //////////////
    // Regex map
    /////////////

    var regexes = {
      browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
      ], [VERSION, [NAME, 'Chrome']], [/edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
      ], [VERSION, [NAME, 'Edge']], [// breaking change (reserved for next major release):
      ///edge\/([\w\.]+)/i                                                  // Old Edge (Trident)
      //], [[VERSION, mapper.str, maps.browser.oldEdge.version], [NAME, 'Edge']], [
      // Presto based
      /(opera\smini)\/([\w\.-]+)/i, // Opera Mini
      /(opera\s[mobiletab]{3,6})\b.+version\/([\w\.-]+)/i, // Opera Mobi/Tablet
      /(opera)(?:.+version\/|[\/\s]+)([\w\.]+)/i // Opera
      ], [NAME, VERSION], [/opios[\/\s]+([\w\.]+)/i // Opera mini on iphone >= 8.0
      ], [VERSION, [NAME, 'Opera Mini']], [/\sopr\/([\w\.]+)/i // Opera Webkit
      ], [VERSION, [NAME, 'Opera']], [// Mixed
      /(kindle)\/([\w\.]+)/i, // Kindle
      /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i, // Lunascape/Maxthon/Netfront/Jasmine/Blazer
      // Trident based
      /(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i, // Avant/IEMobile/SlimBrowser
      /(ba?idubrowser)[\/\s]?([\w\.]+)/i, // Baidu Browser
      /(?:ms|\()(ie)\s([\w\.]+)/i, // Internet Explorer
      // Webkit/KHTML based
      /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i, // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
      /(rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([\w\.]+)/i, // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
      /(weibo)__([\d\.]+)/i // Weibo
      ], [NAME, VERSION], [/(?:[\s\/]uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i // UCBrowser
      ], [VERSION, [NAME, 'UCBrowser']], [/(?:windowswechat)?\sqbcore\/([\w\.]+)\b.*(?:windowswechat)?/i // WeChat Desktop for Windows Built-in Browser
      ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [/micromessenger\/([\w\.]+)/i // WeChat
      ], [VERSION, [NAME, 'WeChat']], [/konqueror\/([\w\.]+)/i // Konqueror
      ], [VERSION, [NAME, 'Konqueror']], [/trident.+rv[:\s]([\w\.]{1,9})\b.+like\sgecko/i // IE11
      ], [VERSION, [NAME, 'IE']], [/yabrowser\/([\w\.]+)/i // Yandex
      ], [VERSION, [NAME, 'Yandex']], [/(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
      ], [[NAME, /(.+)/, '$1 Secure Browser'], VERSION], [/focus\/([\w\.]+)/i // Firefox Focus
      ], [VERSION, [NAME, 'Firefox Focus']], [/opt\/([\w\.]+)/i // Opera Touch
      ], [VERSION, [NAME, 'Opera Touch']], [/coc_coc_browser\/([\w\.]+)/i // Coc Coc Browser
      ], [VERSION, [NAME, 'Coc Coc']], [/dolfin\/([\w\.]+)/i // Dolphin
      ], [VERSION, [NAME, 'Dolphin']], [/coast\/([\w\.]+)/i // Opera Coast
      ], [VERSION, [NAME, 'Opera Coast']], [/xiaomi\/miuibrowser\/([\w\.]+)/i // MIUI Browser
      ], [VERSION, [NAME, 'MIUI Browser']], [/fxios\/([\w\.-]+)/i // Firefox for iOS
      ], [VERSION, [NAME, 'Firefox']], [/(qihu|qhbrowser|qihoobrowser|360browser)/i // 360
      ], [[NAME, '360 Browser']], [/(oculus|samsung|sailfish)browser\/([\w\.]+)/i], [[NAME, /(.+)/, '$1 Browser'], VERSION], [// Oculus/Samsung/Sailfish Browser
      /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
      ], [[NAME, /_/g, ' '], VERSION], [/\s(electron)\/([\w\.]+)\ssafari/i, // Electron-based App
      /(tesla)(?:\sqtcarbrowser|\/(20[12]\d\.[\w\.-]+))/i, // Tesla
      /m?(qqbrowser|baiduboxapp|2345Explorer)[\/\s]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
      ], [NAME, VERSION], [/(MetaSr)[\/\s]?([\w\.]+)/i, // SouGouBrowser
      /(LBBROWSER)/i // LieBao Browser
      ], [NAME], [// WebView
      /;fbav\/([\w\.]+);/i // Facebook App for iOS & Android with version
      ], [VERSION, [NAME, 'Facebook']], [/FBAN\/FBIOS|FB_IAB\/FB4A/i // Facebook App for iOS & Android without version
      ], [[NAME, 'Facebook']], [/safari\s(line)\/([\w\.]+)/i, // Line App for iOS
      /\b(line)\/([\w\.]+)\/iab/i, // Line App for Android
      /(chromium|instagram)[\/\s]([\w\.-]+)/i // Chromium/Instagram
      ], [NAME, VERSION], [/\bgsa\/([\w\.]+)\s.*safari\//i // Google Search Appliance on iOS
      ], [VERSION, [NAME, 'GSA']], [/headlesschrome(?:\/([\w\.]+)|\s)/i // Chrome Headless
      ], [VERSION, [NAME, 'Chrome Headless']], [/\swv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
      ], [[NAME, 'Chrome WebView'], VERSION], [/droid.+\sversion\/([\w\.]+)\b.+(?:mobile\ssafari|safari)/i // Android Browser
      ], [VERSION, [NAME, 'Android Browser']], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
      ], [NAME, VERSION], [/version\/([\w\.]+)\s.*mobile\/\w+\s(safari)/i // Mobile Safari
      ], [VERSION, [NAME, 'Mobile Safari']], [/version\/([\w\.]+)\s.*(mobile\s?safari|safari)/i // Safari & Safari Mobile
      ], [VERSION, NAME], [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
      ], [NAME, [VERSION, mapper.str, maps.browser.oldSafari.version]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [// Gecko based
      /(navigator|netscape)\/([\w\.-]+)/i // Netscape
      ], [[NAME, 'Netscape'], VERSION], [/ile\svr;\srv:([\w\.]+)\).+firefox/i // Firefox Reality
      ], [VERSION, [NAME, 'Firefox Reality']], [/ekiohf.+(flow)\/([\w\.]+)/i, // Flow
      /(swiftfox)/i, // Swiftfox
      /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
      /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i, // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
      /(firefox)\/([\w\.]+)\s[\w\s\-]+\/[\w\.]+$/i, // Other Firefox-based
      /(mozilla)\/([\w\.]+)\s.+rv\:.+gecko\/\d+/i, // Mozilla
      // Other
      /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
      /(links)\s\(([\w\.]+)/i, // Links
      /(gobrowser)\/?([\w\.]*)/i, // GoBrowser
      /(ice\s?browser)\/v?([\w\._]+)/i, // ICE Browser
      /(mosaic)[\/\s]([\w\.]+)/i // Mosaic
      ], [NAME, VERSION]],
      cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i // AMD64 (x64)
      ], [[ARCHITECTURE, 'amd64']], [/(ia32(?=;))/i // IA32 (quicktime)
      ], [[ARCHITECTURE, util.lowerize]], [/((?:i[346]|x)86)[;\)]/i // IA32 (x86)
      ], [[ARCHITECTURE, 'ia32']], [/\b(aarch64|armv?8e?l?)\b/i // ARM64
      ], [[ARCHITECTURE, 'arm64']], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
      ], [[ARCHITECTURE, 'armhf']], [// PocketPC mistakenly identified as PowerPC
      /windows\s(ce|mobile);\sppc;/i], [[ARCHITECTURE, 'arm']], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i // PowerPC
      ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [/(sun4\w)[;\)]/i // SPARC
      ], [[ARCHITECTURE, 'sparc']], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?:64|(?=v(?:[1-7]|[5-7]1)l?|;|eabi))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
      ], [[ARCHITECTURE, util.lowerize]]],
      device: [[//////////////////////////
      // MOBILES & TABLETS
      // Ordered by popularity
      /////////////////////////
      // Samsung
      /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus\s10)/i], [MODEL, [VENDOR, 'Samsung'], [TYPE, TABLET]], [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy\snexus)/i, /\ssamsung[\s-]([\w-]+)/i, /sec-(sgh\w+)/i], [MODEL, [VENDOR, 'Samsung'], [TYPE, MOBILE]], [// Apple
      /\((ip(?:hone|od)[\s\w]*);/i // iPod/iPhone
      ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [/\((ipad);[\w\s\),;-]+apple/i, // iPad
      /applecoremedia\/[\w\.]+\s\((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [// Huawei
      /\b((?:agr|ags[23]|bah2?|sht?)-a?[lw]\d{2})/i], [MODEL, [VENDOR, 'Huawei'], [TYPE, TABLET]], [/d\/huawei([\w\s-]+)[;\)]/i, /\b(nexus\s6p|vog-[at]?l\d\d|ane-[at]?l[x\d]\d|eml-a?l\d\da?|lya-[at]?l\d[\dc]|clt-a?l\d\di?|ele-l\d\d)/i, /\b(\w{2,4}-[atu][ln][01259][019])[;\)\s]/i], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [// Xiaomi
      /\b(poco[\s\w]+)(?:\sbuild|\))/i, // Xiaomi POCO
      /\b;\s(\w+)\sbuild\/hm\1/i, // Xiaomi Hongmi 'numeric' models
      /\b(hm[\s\-_]?note?[\s_]?(?:\d\w)?)\sbuild/i, // Xiaomi Hongmi
      /\b(redmi[\s\-_]?(?:note|k)?[\w\s_]+)(?:\sbuild|\))/i, // Xiaomi Redmi
      /\b(mi[\s\-_]?(?:a\d|one|one[\s_]plus|note lte)?[\s_]?(?:\d?\w?)[\s_]?(?:plus)?)\sbuild/i // Xiaomi Mi
      ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [/\b(mi[\s\-_]?(?:pad)(?:[\w\s_]+))(?:\sbuild|\))/i // Mi Pad tablets
      ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [// OPPO
      /;\s(\w+)\sbuild.+\soppo/i, /\s(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007)\b/i], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [// Vivo
      /\svivo\s(\w+)(?:\sbuild|\))/i, /\s(v[12]\d{3}\w?[at])(?:\sbuild|;)/i], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [// Realme
      /\s(rmx[12]\d{3})(?:\sbuild|;)/i], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [// Motorola
      /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)\b[\w\s]+build\//i, /\smot(?:orola)?[\s-](\w*)/i, /((?:moto[\s\w\(\)]+|xt\d{3,4}|nexus\s6)(?=\sbuild|\)))/i], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [/\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [// LG
      /((?=lg)?[vl]k\-?\d{3})\sbuild|\s3\.[\s\w;-]{10}lg?-([06cv9]{3,4})/i], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [/(lm-?f100[nv]?|nexus\s[45])/i, /lg[e;\s\/-]+((?!browser|netcast)\w+)/i, /\blg(\-?[\d\w]+)\sbuild/i], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [// Lenovo
      /(ideatab[\w\-\s]+)/i, /lenovo\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+)|yt[\d\w-]{6}|tb[\d\w-]{6})/i // Lenovo tablets
      ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [// Nokia
      /(?:maemo|nokia).*(n900|lumia\s\d+)/i, /nokia[\s_-]?([\w\.-]*)/i], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [// Google
      /droid.+;\s(pixel\sc)[\s)]/i // Google Pixel C
      ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [/droid.+;\s(pixel[\s\daxl]{0,6})(?:\sbuild|\))/i // Google Pixel
      ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [// Sony
      /droid.+\s([c-g]\d{4}|so[-l]\w+|xq-a\w[4-7][12])(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [/sony\stablet\s[ps]\sbuild\//i, /(?:sony)?sgp\w+(?:\sbuild\/|\))/i], [[MODEL, 'Xperia Tablet'], [VENDOR, 'Sony'], [TYPE, TABLET]], [// OnePlus
      /\s(kb2005|in20[12]5|be20[12][59])\b/i, /\ba000(1)\sbuild/i, // OnePlus
      /\boneplus\s(a\d{4})[\s)]/i], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [// Amazon
      /(alexa)webm/i, /(kf[a-z]{2}wi)(\sbuild\/|\))/i, // Kindle Fire without Silk
      /(kf[a-z]+)(\sbuild\/|\)).+silk\//i // Kindle Fire HD
      ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [/(sd|kf)[0349hijorstuw]+(\sbuild\/|\)).+silk\//i // Fire Phone
      ], [[MODEL, 'Fire Phone'], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [// BlackBerry
      /\((playbook);[\w\s\),;-]+(rim)/i // BlackBerry PlayBook
      ], [MODEL, VENDOR, [TYPE, TABLET]], [/((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10;\s(\w+)/i // BlackBerry 10
      ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [// Asus
      /(?:\b|asus_)(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus\s7|padfone|p00[cj])/i], [MODEL, [VENDOR, 'ASUS'], [TYPE, TABLET]], [/\s(z[es]6[027][01][km][ls]|zenfone\s\d\w?)\b/i], [MODEL, [VENDOR, 'ASUS'], [TYPE, MOBILE]], [// HTC
      /(nexus\s9)/i // HTC Nexus 9
      ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [/(htc)[;_\s-]{1,2}([\w\s]+(?=\)|\sbuild)|\w+)/i, // HTC
      // ZTE
      /(zte)-(\w*)/i, /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
      ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [// Acer
      /droid[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [// Meizu
      /droid.+;\s(m[1-5]\snote)\sbuild/i, /\bmz-([\w-]{2,})/i], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [// MIXED
      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i, // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
      /(hp)\s([\w\s]+\w)/i, // HP iPAQ
      /(asus)-?(\w+)/i, // Asus
      /(microsoft);\s(lumia[\s\w]+)/i, // Microsoft Lumia
      /(lenovo)[_\s-]?([\w-]+)/i, // Lenovo
      /linux;.+(jolla);/i, // Jolla
      /droid.+;\s(oppo)\s?([\w\s]+)\sbuild/i // OPPO
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(archos)\s(gamepad2?)/i, // Archos
      /(hp).+(touchpad(?!.+tablet)|tablet)/i, // HP TouchPad
      /(kindle)\/([\w\.]+)/i, // Kindle
      /\s(nook)[\w\s]+build\/(\w+)/i, // Nook
      /(dell)\s(strea[kpr\s\d]*[\dko])/i, // Dell Streak
      /[;\/]\s?(le[\s\-]+pan)[\s\-]+(\w{1,9})\sbuild/i, // Le Pan Tablets
      /[;\/]\s?(trinity)[\-\s]*(t\d{3})\sbuild/i, // Trinity Tablets
      /\b(gigaset)[\s\-]+(q\w{1,9})\sbuild/i, // Gigaset Tablets
      /\b(vodafone)\s([\w\s]+)(?:\)|\sbuild)/i // Vodafone
      ], [VENDOR, MODEL, [TYPE, TABLET]], [/\s(surface\sduo)\s/i // Surface Duo
      ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, TABLET]], [/droid\s[\d\.]+;\s(fp\du?)\sbuild/i], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [/\s(u304aa)\sbuild/i // AT&T
      ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [/sie-(\w*)/i // Siemens
      ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [/[;\/]\s?(rct\w+)\sbuild/i // RCA Tablets
      ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [/[;\/\s](venue[\d\s]{2,7})\sbuild/i // Dell Venue Tablets
      ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [/[;\/]\s?(q(?:mv|ta)\w+)\sbuild/i // Verizon Tablet
      ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [/[;\/]\s(?:barnes[&\s]+noble\s|bn[rt])([\w\s\+]*)\sbuild/i // Barnes & Noble Tablet
      ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [/[;\/]\s(tm\d{3}\w+)\sbuild/i], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [/;\s(k88)\sbuild/i // ZTE K Series Tablet
      ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [/;\s(nx\d{3}j)\sbuild/i // ZTE Nubia
      ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [/[;\/]\s?(gen\d{3})\sbuild.*49h/i // Swiss GEN Mobile
      ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [/[;\/]\s?(zur\d{3})\sbuild/i // Swiss ZUR Tablet
      ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [/[;\/]\s?((zeki)?tb.*\b)\sbuild/i // Zeki Tablets
      ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [/[;\/]\s([yr]\d{2})\sbuild/i, /[;\/]\s(dragon[\-\s]+touch\s|dt)(\w{5})\sbuild/i // Dragon Touch Tablet
      ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [/[;\/]\s?(ns-?\w{0,9})\sbuild/i // Insignia Tablets
      ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [/[;\/]\s?((nxa|Next)-?\w{0,9})\sbuild/i // NextBook Tablets
      ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [/[;\/]\s?(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05]))\sbuild/i], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [// Voice Xtreme Phones
      /[;\/]\s?(lvtel\-)?(v1[12])\sbuild/i // LvTel Phones
      ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [/;\s(ph-1)\s/i], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [// Essential PH-1
      /[;\/]\s?(v(100md|700na|7011|917g).*\b)\sbuild/i // Envizen Tablets
      ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [/[;\/]\s?(trio[\s\w\-\.]+)\sbuild/i // MachSpeed Tablets
      ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [/[;\/]\s?tu_(1491)\sbuild/i // Rotor Tablets
      ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [/(shield[\w\s]+)\sbuild/i // Nvidia Shield Tablets
      ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [/(sprint)\s(\w+)/i // Sprint Phones
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kin\.[onetw]{3})/i // Microsoft Kin
      ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [/droid\s[\d\.]+;\s(cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
      ], [MODEL, [VENDOR, 'Zebra'], [TYPE, TABLET]], [/droid\s[\d\.]+;\s(ec30|ps20|tc[2-8]\d[kx])\)/i], [MODEL, [VENDOR, 'Zebra'], [TYPE, MOBILE]], [///////////////////
      // CONSOLES
      ///////////////////
      /\s(ouya)\s/i, // Ouya
      /(nintendo)\s([wids3utch]+)/i // Nintendo
      ], [VENDOR, MODEL, [TYPE, CONSOLE]], [/droid.+;\s(shield)\sbuild/i // Nvidia
      ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [/(playstation\s[345portablevi]+)/i // Playstation
      ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [/[\s\(;](xbox(?:\sone)?(?!;\sxbox))[\s\);]/i // Microsoft Xbox
      ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [///////////////////
      // SMARTTVS
      ///////////////////
      /smart-tv.+(samsung)/i // Samsung
      ], [VENDOR, [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [/(?:linux;\snetcast.+smarttv|lg\snetcast\.tv-201\d)/i // LG SmartTV
      ], [[VENDOR, 'LG'], [TYPE, SMARTTV]], [/(apple)\s?tv/i // Apple TV
      ], [VENDOR, [MODEL, 'Apple TV'], [TYPE, SMARTTV]], [/crkey/i // Google Chromecast
      ], [[MODEL, 'Chromecast'], [VENDOR, 'Google'], [TYPE, SMARTTV]], [/droid.+aft([\w])(\sbuild\/|\))/i // Fire TV
      ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i // Sharp
      ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i // HbbTV devices
      ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [/[\s\/\(](android\s|smart[-\s]?|opera\s)tv[;\)\s]/i // SmartTV from Unidentified Vendors
      ], [[TYPE, SMARTTV]], [///////////////////
      // WEARABLES
      ///////////////////
      /((pebble))app\/[\d\.]+\s/i // Pebble
      ], [VENDOR, MODEL, [TYPE, WEARABLE]], [/droid.+;\s(glass)\s\d/i // Google Glass
      ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [/droid\s[\d\.]+;\s(wt63?0{2,3})\)/i], [MODEL, [VENDOR, 'Zebra'], [TYPE, WEARABLE]], [///////////////////
      // EMBEDDED
      ///////////////////
      /(tesla)(?:\sqtcarbrowser|\/20[12]\d\.[\w\.-]+)/i // Tesla
      ], [VENDOR, [TYPE, EMBEDDED]], [////////////////////
      // MIXED (GENERIC)
      ///////////////////
      /droid .+?; ([^;]+?)(?: build|\) applewebkit).+? mobile safari/i // Android Phones from Unidentified Vendors
      ], [MODEL, [TYPE, MOBILE]], [/droid .+?;\s([^;]+?)(?: build|\) applewebkit).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
      ], [MODEL, [TYPE, TABLET]], [/\s(tablet|tab)[;\/]/i, // Unidentifiable Tablet
      /\s(mobile)(?:[;\/]|\ssafari)/i // Unidentifiable Mobile
      ], [[TYPE, util.lowerize]], [/(android[\w\.\s\-]{0,9});.+build/i // Generic Android Device
      ], [MODEL, [VENDOR, 'Generic']], [/(phone)/i], [[TYPE, MOBILE]]],
      engine: [[/windows.+\sedge\/([\w\.]+)/i // EdgeHTML
      ], [VERSION, [NAME, 'EdgeHTML']], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
      ], [VERSION, [NAME, 'Blink']], [/(presto)\/([\w\.]+)/i, // Presto
      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
      /ekioh(flow)\/([\w\.]+)/i, // Flow
      /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, // KHTML/Tasman/Links
      /(icab)[\/\s]([23]\.[\d\.]+)/i // iCab
      ], [NAME, VERSION], [/rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
      ], [VERSION, NAME]],
      os: [[// Windows
      /microsoft\s(windows)\s(vista|xp)/i // Windows (iTunes)
      ], [NAME, VERSION], [/(windows)\snt\s6\.2;\s(arm)/i, // Windows RT
      /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i, // Windows Phone
      /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)(?!.+xbox)/i], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [// iOS/macOS
      /ip[honead]{2,4}\b(?:.*os\s([\w]+)\slike\smac|;\sopera)/i, // iOS
      /cfnetwork\/.+darwin/i], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)(?!.+haiku)/i // Mac OS
      ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [// Mobile OSes                                                      // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
      /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, // Blackberry
      /(tizen|kaios)[\/\s]([\w\.]+)/i, // Tizen/KaiOS
      /\((series40);/i // Series 40
      ], [NAME, VERSION], [/\(bb(10);/i // BlackBerry 10
      ], [VERSION, [NAME, 'BlackBerry']], [/(?:symbian\s?os|symbos|s60(?=;)|series60)[\/\s-]?([\w\.]*)/i // Symbian
      ], [VERSION, [NAME, 'Symbian']], [/mozilla.+\(mobile;.+gecko.+firefox/i // Firefox OS
      ], [[NAME, 'Firefox OS']], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
      ], [VERSION, [NAME, 'webOS']], [// Google Chromecast
      /crkey\/([\d\.]+)/i // Google Chromecast
      ], [VERSION, [NAME, 'Chromecast']], [/(cros)\s[\w]+\s([\w\.]+\w)/i // Chromium OS
      ], [[NAME, 'Chromium OS'], VERSION], [// Console
      /(nintendo|playstation)\s([wids345portablevuch]+)/i, // Nintendo/Playstation
      /(xbox);\s+xbox\s([^\);]+)/i, // Microsoft Xbox (360, One, X, S, Series X, Series S)
      // GNU/Linux based
      /(mint)[\/\s\(\)]?(\w*)/i, // Mint
      /(mageia|vectorlinux)[;\s]/i, // Mageia/VectorLinux
      /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?=\slinux)|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus|raspbian)(?:\sgnu\/linux)?(?:\slinux)?[\/\s-]?(?!chrom|package)([\w\.-]*)/i, // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
      // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
      /(hurd|linux)\s?([\w\.]*)/i, // Hurd/Linux
      /(gnu)\s?([\w\.]*)/i, // GNU
      // BSD based
      /\s([frentopc-]{0,4}bsd|dragonfly)\s?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
      /(haiku)\s(\w+)/i // Haiku
      ], [NAME, VERSION], [// Other
      /(sunos)\s?([\w\.\d]*)/i // Solaris
      ], [[NAME, 'Solaris'], VERSION], [/((?:open)?solaris)[\/\s-]?([\w\.]*)/i, // Solaris
      /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i, // AIX
      /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i, // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
      /(unix)\s?([\w\.]*)/i // UNIX
      ], [NAME, VERSION]]
    }; /////////////////
    // Constructor
    ////////////////

    var UAParser = function UAParser(ua, extensions) {
      if (_typeof(ua) === 'object') {
        extensions = ua;
        ua = undefined$1;
      }

      if (!(this instanceof UAParser)) {
        return new UAParser(ua, extensions).getResult();
      }

      var _ua = ua || (typeof window !== 'undefined' && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);

      var _rgxmap = extensions ? util.extend(regexes, extensions) : regexes;

      this.getBrowser = function () {
        var _browser = {
          name: undefined$1,
          version: undefined$1
        };
        mapper.rgx.call(_browser, _ua, _rgxmap.browser);
        _browser.major = util.major(_browser.version); // deprecated

        return _browser;
      };

      this.getCPU = function () {
        var _cpu = {
          architecture: undefined$1
        };
        mapper.rgx.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
      };

      this.getDevice = function () {
        var _device = {
          vendor: undefined$1,
          model: undefined$1,
          type: undefined$1
        };
        mapper.rgx.call(_device, _ua, _rgxmap.device);
        return _device;
      };

      this.getEngine = function () {
        var _engine = {
          name: undefined$1,
          version: undefined$1
        };
        mapper.rgx.call(_engine, _ua, _rgxmap.engine);
        return _engine;
      };

      this.getOS = function () {
        var _os = {
          name: undefined$1,
          version: undefined$1
        };
        mapper.rgx.call(_os, _ua, _rgxmap.os);
        return _os;
      };

      this.getResult = function () {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };

      this.getUA = function () {
        return _ua;
      };

      this.setUA = function (ua) {
        _ua = _typeof(ua) === STR_TYPE && ua.length > UA_MAX_LENGTH ? util.trim(ua, UA_MAX_LENGTH) : ua;
        return this;
      };

      this.setUA(_ua);
      return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
      NAME: NAME,
      MAJOR: MAJOR,
      // deprecated
      VERSION: VERSION
    };
    UAParser.CPU = {
      ARCHITECTURE: ARCHITECTURE
    };
    UAParser.DEVICE = {
      MODEL: MODEL,
      VENDOR: VENDOR,
      TYPE: TYPE,
      CONSOLE: CONSOLE,
      MOBILE: MOBILE,
      SMARTTV: SMARTTV,
      TABLET: TABLET,
      WEARABLE: WEARABLE,
      EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
      NAME: NAME,
      VERSION: VERSION
    };
    UAParser.OS = {
      NAME: NAME,
      VERSION: VERSION
    }; ///////////
    // Export
    //////////
    // check js environment

    {
      // nodejs env
      if (module.exports) {
        exports = module.exports = UAParser;
      }

      exports.UAParser = UAParser;
    } // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.


    var $ = typeof window !== 'undefined' && (window.jQuery || window.Zepto);

    if ($ && !$.ua) {
      var parser = new UAParser();
      $.ua = parser.getResult();

      $.ua.get = function () {
        return parser.getUA();
      };

      $.ua.set = function (uastring) {
        parser.setUA(uastring);
        var result = parser.getResult();

        for (var prop in result) {
          $.ua[prop] = result[prop];
        }
      };
    }
  })((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' ? window : commonjsGlobal);
});
uaParser.UAParser;

if (typeof window !== 'undefined' && typeof window.UAParser === 'undefined') {
    window.UAParser = uaParser;
}
var uaInfo = null;
var getUAInfo = function () {
    if (!uaInfo) {
        // @ts-ignore
        uaInfo = new uaParser().getResult();
    }
    return uaInfo;
};
/**
 * 判断是否当前浏览器环境是否是ie8/ie9来做cors兼容
 */
function needCompatible() {
    var uaInfo = getUAInfo();
    if (uaInfo.browser.name !== 'IE') {
        return false;
    }
    return uaInfo.browser.major && +uaInfo.browser.major <= 9;
}
// 从vue-router里面拿的……
function supportsPushState() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1)
        && ua.indexOf('Mobile Safari') !== -1
        && ua.indexOf('Chrome') === -1
        && ua.indexOf('Windows Phone') === -1) {
        return false;
    }
    return window.history && 'pushState' in window.history;
}
var uaUtils = {
    needCompatible: needCompatible,
    supportsPushState: supportsPushState,
    getUAInfo: getUAInfo
};

var devices = [
    ['a7', '640x1136', ['iPhone 5', 'iPhone 5s']],
    ['a7', '1536x2048', ['iPad Air', 'iPad Mini 2', 'iPad Mini 3']],
    ['a8', '640x1136', ['iPod touch (6th gen)']],
    ['a8', '750x1334', ['iPhone 6']],
    ['a8', '1242x2208', ['iPhone 6 Plus']],
    ['a8', '1536x2048', ['iPad Air 2', 'iPad Mini 4']],
    ['a9', '640x1136', ['iPhone SE']],
    ['a9', '750x1334', ['iPhone 6s']],
    ['a9', '1242x2208', ['iPhone 6s Plus']],
    ['a9x', '1536x2048', ['iPad Pro (1st gen 9.7-inch)']],
    ['a9x', '2048x2732', ['iPad Pro (1st gen 12.9-inch)']],
    ['a10', '750x1334', ['iPhone 7']],
    ['a10', '1242x2208', ['iPhone 7 Plus']],
    ['a10x', '1668x2224', ['iPad Pro (2th gen 10.5-inch)']],
    ['a10x', '2048x2732', ['iPad Pro (2th gen 12.9-inch)']],
    ['a11', '750x1334', ['iPhone 8']],
    ['a11', '1242x2208', ['iPhone 8 Plus']],
    ['a11', '1125x2436', ['iPhone X']],
    ['a12', '828x1792', ['iPhone Xr']],
    ['a12', '1125x2436', ['iPhone Xs']],
    ['a12', '1242x2688', ['iPhone Xs Max']],
    ['a12x', '1668x2388', ['iPad Pro (3rd gen 11-inch)']],
    ['a12x', '2048x2732', ['iPad Pro (3rd gen 12.9-inch)']],
];
var getResolution = (function () {
    var resolution = '';
    return function () {
        if (resolution) {
            return resolution;
        }
        try {
            var ratio = window.devicePixelRatio || 1;
            var width = Math.floor(Math.min(screen.width, screen.height) * ratio); // 有的devicePixelRatio为小数，在此转为整数
            var height = Math.floor(Math.max(screen.width, screen.height) * ratio);
            resolution = width + "x" + height;
            return resolution;
        }
        catch (err) {
            return '';
        }
    };
})();
var getGPU = (function () {
    var gpu = '';
    return function () {
        if (gpu) {
            return gpu;
        }
        try {
            var canvas = document.createElement('canvas');
            var glRenderContext = canvas.getContext('webgl');
            if (glRenderContext) {
                var debugRenderInfo = glRenderContext.getExtension('WEBGL_debug_renderer_info');
                gpu = debugRenderInfo
                    ? glRenderContext.getParameter(debugRenderInfo.UNMASKED_RENDERER_WEBGL)
                    : 'unknown';
            }
            else {
                gpu = 'unknown';
            }
            return gpu;
        }
        catch (err) {
            return 'unknown';
        }
    };
})();
var getModel = (function () {
    var model = '';
    return function () {
        if (model) {
            return model;
        }
        try {
            var uaInfo = getUAInfo();
            var inApp = isInApp();
            // 非iOS设备走ua判断
            // iOS端内也有问题= =妈的，傻逼苹果！应该是UIWebView特有的坑
            // 链接:https://www.jianshu.com/p/bae4db1f08b2
            if (uaInfo.os.name !== 'iOS' || inApp) {
                return uaInfo.device.model || 'unknown';
            }
            var gpu = getGPU();
            var resolution = getResolution();
            var matches = gpu.match(/^apple\s+([_a-z0-9-]+)\s+gpu$/i);
            if (!matches) {
                model = 'unknown';
                return model;
            }
            for (var _i = 0, devices_1 = devices; _i < devices_1.length; _i++) {
                var device = devices_1[_i];
                if (matches[1].toLocaleLowerCase() === device[0] && resolution === device[1]) {
                    model = device[2].join(' or ');
                    break;
                }
            }
            model = model || uaInfo.device.model || 'unknown';
            return model;
        }
        catch (err) {
            return 'unknown';
        }
    };
})();
function isReactNative() {
    var GLOBAL = typeof globalThis !== 'undefined' ? globalThis : (typeof window !== 'undefined' ? window : null);
    return GLOBAL && GLOBAL.navigator && GLOBAL.navigator.product === 'ReactNative'
        || GLOBAL && GLOBAL.ReactNative && GLOBAL.ReactNative.NativeModules;
}

/**
 * 事件
 */
// 网络类型
var networkType = {
    unknown: Base.NetworkPackageType.UNKNOWN_NETWORK,
    none: Base.NetworkPackageType.NOT_CONNECTED,
    wifi: Base.NetworkPackageType.WIFI,
    '4g': Base.NetworkPackageType.MOBILE_4G,
    '3g': Base.NetworkPackageType.MOBILE_3G,
    '2g': Base.NetworkPackageType.MOBILE_2G,
    'slow-2g': Base.NetworkPackageType.MOBILE_2G,
};
// 任务事件类型
var TaskOperations;
(function (TaskOperations) {
    TaskOperations["CLICK"] = "CLICK";
    TaskOperations["DOUBLE_CLICK"] = "DOUBLE_CLICK";
    TaskOperations["TRIPLE_CLICK"] = "TRIPLE_CLICK";
    TaskOperations["LONG_PRESS"] = "LONG_PRESS";
    TaskOperations["PULL"] = "PULL";
    TaskOperations["DRAG"] = "DRAG";
    TaskOperations["SCALE"] = "SCALE";
    TaskOperations["PULL_DOWN"] = "PULL_DOWN";
    TaskOperations["PULL_UP"] = "PULL_UP";
    // VIDEO = 'VIDEO',
})(TaskOperations || (TaskOperations = {}));
// 事件类型
var EventTypes;
(function (EventTypes) {
    EventTypes["PV"] = "PV";
    EventTypes["SHOW"] = "SHOW";
    // Costume
    EventTypes["CUSTOM"] = "CUSTOM";
    EventTypes["RADAR"] = "RADAR";
})(EventTypes || (EventTypes = {}));

// 常规业务事件自增 id key
var LOCAL_INCREAMENT_ID_KEY = 'WEBLOGGER_INCREAMENT_ID_KEY';
// 自定义事件自增 id key
var LOCAL_CUSTOM_INCREAMENT_ID_KEY = 'WEBLOGGER_CUSTOM_INCREAMENT_ID_KEY';
// Bridge 常规事件自增 id 本地缓存 key
var H5_SEQ_ID_KEY = 'WEBLOGGER_H5_SEQ_ID';
// Bridge 自定义事件自增 id 本地缓存 key
var H5_CUSTOM_SEQ_ID_KEY = 'WEBLOGGER_H5_CUSTOM_SEQ_ID';
// http 请求自增 id 本地缓存 key
var LOCAL_HTTP_INCREMENT_ID_KEY = 'WEBLOGGER_HTTP_SEQ_ID';
// v2 自增 id 本地缓存 key
var V2_INCREMENT_ID_KEY = 'WEBLOGGER_V2_SEQ_ID';
var CHANNEL_INCREMENT_ID_KEY = 'WEBLOGGER_CHANNEL_SEQ_ID';
// 自增 id 最大值
var maxId = 1e8;
// 如果没有 localStorage 则使用运行时自增 id，用于非浏览器场景，比如 React Native
var runtimeIdMap = {};
var genId = function (key) {
    try {
        if (window && window.localStorage && typeof Storage !== 'undefined' && window.localStorage instanceof Storage) {
            var id = Number(getLocalStorageItem(key)) || 0;
            if (id + 1 > maxId) {
                id = 0;
            }
            setLocalStorageItem(key, id + 1);
            return id;
        }
    }
    catch (err) { }
    if (!runtimeIdMap[key]) {
        runtimeIdMap[key] = 0;
    }
    return runtimeIdMap[key]++;
};
/**
 * 常规事件自增 id
 */
var getNomalIncrementId = function () {
    return genId(LOCAL_INCREAMENT_ID_KEY);
};
/**
 * 自定义事件自增 id
 */
var getCustomIncrementId = function () {
    return genId(LOCAL_CUSTOM_INCREAMENT_ID_KEY);
};
/**
 * 桥接常规事件自增 id
 */
var getBridgeNormalIncrementId = function () {
    return genId(H5_SEQ_ID_KEY);
};
/**
 * 桥接自定义事件自增 id
 */
var getBridgeCustomIncrementId = function () {
    return genId(H5_CUSTOM_SEQ_ID_KEY);
};
/**
 * http 请求自增 id
 */
var getHttpIncrementId = function () {
    return genId(LOCAL_HTTP_INCREMENT_ID_KEY);
};
/**
 * v2 channel 自增 id
 */
var getChannelIncrementId = function (channel) {
    if (channel === void 0) { channel = ''; }
    return genId(CHANNEL_INCREMENT_ID_KEY + "_" + channel);
};
/**
 * v2 事件自增 id
 */
var getV2EventIncrementId = function (event) {
    return genId(V2_INCREMENT_ID_KEY + "_" + event);
};

var BASE = {
    device_id: '',
    global_id: '',
    union_id: '',
    user_id: '',
    session_id: '',
    product: 0,
    channel: '',
    version_name: '',
    package_name: '',
    product_name: '',
    network_type: 'unknown',
    container: Base.Container.H5,
    service_name: '',
    sub_biz: '',
    need_encrypt: false,
    safety_id: '',
    experiment: [],
    h5_extra_attr: {},
};
var initPackageKeys = [
    {
        keys: ['identity_package', 'device_id'],
        type: 'string',
        validator: function (val) { return typeof val === 'string'; },
    },
    {
        keys: ['identity_package', 'user_id'],
        type: 'string',
        validator: function (val) { return typeof val === 'string'; },
    },
    {
        keys: ['identity_package', 'union_id'],
        type: 'string',
        validator: function (val) { return typeof val === 'string'; },
    },
    {
        keys: ['identity_package', 'global_id'],
        type: 'string',
        validator: function (val) { return typeof val === 'string'; },
    },
    {
        keys: ['app_package', 'product'],
        type: 'number',
        validator: function (val) { return typeof val === 'number'; },
    },
    {
        keys: ['app_package', 'channel'],
        type: 'string',
        validator: function (val) { return typeof val === 'string'; },
    },
    {
        keys: ['app_package', 'version_name'],
        type: 'string',
        validator: function (val) { return typeof val === 'string'; },
    },
    {
        keys: ['app_package', 'package_name'],
        type: 'string',
        validator: function (val) { return typeof val === 'string'; },
    },
    {
        keys: ['app_package', 'product_name'],
        type: 'string',
        validator: function (val) { return typeof val === 'string'; },
    },
    {
        keys: ['app_package', 'platform'],
        type: 'number',
        validator: function (val) { return typeof val === 'number'; },
    },
    {
        keys: ['experiment'],
        type: 'Array',
        validator: function (val) { return val instanceof Array; },
    },
    {
        keys: ['service_name'],
        type: 'string',
        validator: function (val) { return typeof val === 'string'; },
    },
    {
        keys: ['sub_biz'],
        type: 'string',
        validator: function (val) { return typeof val === 'string'; },
    },
    {
        keys: ['need_encrypt'],
        type: 'boolean',
        validator: function (val) { return typeof val === 'boolean'; },
    },
    {
        keys: ['safety_id'],
        type: 'string',
        validator: function (val) { return typeof val === 'string'; },
    },
    {
        keys: ['h5_extra_attr'],
        type: 'Object',
        validator: function (val) { return val instanceof Object; },
    },
];

var ClientCommon;
(function (ClientCommon) {
    (function (Product) {
        Product[Product["UNKNOWN1"] = 0] = "UNKNOWN1";
        Product[Product["KUAISHOU"] = 1] = "KUAISHOU";
        Product[Product["KUAISHOU_GAME_EXTENSION"] = 2] = "KUAISHOU_GAME_EXTENSION";
        Product[Product["KUAISHOU_LIVE_MATE"] = 3] = "KUAISHOU_LIVE_MATE";
        Product[Product["KUAISHOU_VIDEO_EDITOR"] = 4] = "KUAISHOU_VIDEO_EDITOR";
        Product[Product["KWAI"] = 5] = "KWAI";
        Product[Product["KUAISHOU_H5"] = 6] = "KUAISHOU_H5";
        Product[Product["KWAI_LITE"] = 7] = "KWAI_LITE";
        Product[Product["KWAI_GO"] = 8] = "KWAI_GO";
        Product[Product["KUAISHOU_LIVE_MATE_WP"] = 9] = "KUAISHOU_LIVE_MATE_WP";
        Product[Product["WECHAT_SMALL_APP"] = 12] = "WECHAT_SMALL_APP";
        Product[Product["NEBULA"] = 13] = "NEBULA";
        Product[Product["KWAI_GAME_LIVE_PLUGIN"] = 14] = "KWAI_GAME_LIVE_PLUGIN";
        Product[Product["ACFUN_GAME_CENTER"] = 15] = "ACFUN_GAME_CENTER";
        Product[Product["GAME_DIANDIANXIAO"] = 16] = "GAME_DIANDIANXIAO";
        Product[Product["THANOS"] = 17] = "THANOS";
        Product[Product["UVIDEO"] = 18] = "UVIDEO";
        Product[Product["GAME_ZONE"] = 19] = "GAME_ZONE";
        Product[Product["KWAI_GO_BRAZIL"] = 20] = "KWAI_GO_BRAZIL";
        Product[Product["KWAI_GO_COMICS"] = 21] = "KWAI_GO_COMICS";
        Product[Product["KUAISHOU_ANTMAN"] = 22] = "KUAISHOU_ANTMAN";
        Product[Product["UVIDEO_V2"] = 23] = "UVIDEO_V2";
        Product[Product["KWAI_BULLDOG"] = 24] = "KWAI_BULLDOG";
        Product[Product["LOLITA_GLOBAL"] = 25] = "LOLITA_GLOBAL";
        Product[Product["KUAISHOU_NEBULA_ANTMAN"] = 26] = "KUAISHOU_NEBULA_ANTMAN";
        Product[Product["ZIKZAK"] = 27] = "ZIKZAK";
        Product[Product["KS_TV"] = 28] = "KS_TV";
        Product[Product["UVIDEO_LITE"] = 29] = "UVIDEO_LITE";
        Product[Product["KUAISHOU_VISION"] = 30] = "KUAISHOU_VISION";
    })(ClientCommon.Product || (ClientCommon.Product = {}));
    (function (TimePackageSyncStatus) {
        TimePackageSyncStatus[TimePackageSyncStatus["UNSYNCHROIZED"] = 0] = "UNSYNCHROIZED";
        TimePackageSyncStatus[TimePackageSyncStatus["SYNCHROIZED"] = 1] = "SYNCHROIZED";
    })(ClientCommon.TimePackageSyncStatus || (ClientCommon.TimePackageSyncStatus = {}));
})(ClientCommon || (ClientCommon = {}));

var _yoda;
var yodaNamespace = 'tool';
var yodaResolve = null;
var yodaAlready = false;
/**
 * 检查 yoda 环境
 */
var checkYoda = function (yoda) {
    if (yoda === void 0) { yoda = _yoda || typeof window !== 'undefined' && window.yoda; }
    if (_yoda && _yoda.isInYoda)
        return _yoda;
    if (yoda && yoda.isInYoda) {
        _yoda = yoda;
        return _yoda;
    }
    return null;
};
/**
 * 初始化 yoda
 * @param namespace
 */
var initYoda = function () { return __awaiter(void 0, void 0, void 0, function () {
    var err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!_yoda || yodaAlready)
                    return [2 /*return*/];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 7]);
                if (!yodaResolve) return [3 /*break*/, 3];
                return [4 /*yield*/, yodaResolve];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                yodaResolve = _yoda.ready();
                return [4 /*yield*/, yodaResolve];
            case 4:
                _a.sent();
                _yoda.register({
                    namespace: 'webview',
                    name: 'getPageLoadData',
                });
                _yoda.register({
                    namespace: 'tool',
                    name: 'setClientLog',
                });
                _yoda.register({
                    namespace: 'tool',
                    name: 'sendRadarLog',
                });
                _yoda.register({
                    namespace: 'tool',
                    name: 'getKswitchData',
                });
                _a.label = 5;
            case 5:
                yodaResolve = null;
                yodaAlready = true;
                return [3 /*break*/, 7];
            case 6:
                err_1 = _a.sent();
                console.log('initYoda err', err_1);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}); };
/**
 * 判断是否支持桥接接口
 * @param name
 * @param namespace
 */
var isSupportBridge = function (name, namespace) {
    if (name === void 0) { name = 'setClientLog'; }
    if (namespace === void 0) { namespace = yodaNamespace; }
    return __awaiter(void 0, void 0, void 0, function () {
        var isSupport, canUse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isSupport = false;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!_yoda) return [3 /*break*/, 5];
                    if (!!yodaAlready) return [3 /*break*/, 3];
                    return [4 /*yield*/, initYoda()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [4 /*yield*/, _yoda.tool.canIUse({
                        namespace: namespace,
                        name: name,
                    })];
                case 4:
                    canUse = (_a.sent()).canUse;
                    isSupport = canUse;
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/, isSupport];
            }
        });
    });
};
/**
 * 获取 webview 信息
 */
var getWebviewLoadPerf = function (options) {
    if (options === void 0) { options = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!_yoda)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    if (!!yodaAlready) return [3 /*break*/, 3];
                    return [4 /*yield*/, initYoda()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [4 /*yield*/, _yoda.webview['getPageLoadData'](options)];
                case 4: return [2 /*return*/, _a.sent()];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
};
/**
 * 发送雷达事件
 */
var sendRadarLog = function (options) {
    if (options === void 0) { options = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!_yoda)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    if (!!yodaAlready) return [3 /*break*/, 3];
                    return [4 /*yield*/, initYoda()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [4 /*yield*/, _yoda.tool['sendRadarLog'](options)];
                case 4: return [2 /*return*/, _a.sent()];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
};
/**
 * 发送业务事件
 * @param type
 * @param data
 */
var setClientLog = function (type, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!_yoda)
                    return [2 /*return*/];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                if (!!yodaAlready) return [3 /*break*/, 3];
                return [4 /*yield*/, initYoda()];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [4 /*yield*/, _yoda.tool['setClientLog']({
                    type: type,
                    data: data
                })];
            case 4: return [2 /*return*/, _a.sent()];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); };
/**
 * 采样配置：
 * undefined 表示还未获取到配置；
 * null 表示没有配置
 */
var KSwitchSampling = undefined;
/**
 * 获取 Kswitch 采样配置
 */
var getKSwitchSampling = function () { return __awaiter(void 0, void 0, void 0, function () {
    var canUse, res, kswitchData, data, host, pathname;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!_yoda) {
                    KSwitchSampling = null;
                    return [2 /*return*/, KSwitchSampling];
                }
                if (typeof KSwitchSampling !== 'undefined')
                    return [2 /*return*/, KSwitchSampling];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 7]);
                if (!!yodaAlready) return [3 /*break*/, 3];
                return [4 /*yield*/, initYoda()];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [4 /*yield*/, _yoda.tool.canIUse({
                    namespace: 'tool',
                    name: 'getKswitchData'
                })];
            case 4:
                canUse = (_a.sent()).canUse;
                if (!canUse) {
                    KSwitchSampling = null;
                    return [2 /*return*/, KSwitchSampling];
                }
                return [4 /*yield*/, _yoda.tool.getKswitchData({
                        keys: [
                            {
                                key: 'webloggerSampling'
                            }
                        ]
                    })];
            case 5:
                res = _a.sent();
                if (res && res.data) {
                    kswitchData = res.data[0];
                    if (typeof kswitchData === 'string') {
                        kswitchData = JSON.parse(kswitchData);
                    }
                    data = kswitchData ? kswitchData.value : null;
                    if (data) {
                        if (typeof data === 'string') {
                            data = JSON.parse(data);
                        }
                        host = typeof location !== 'undefined' ? location.host : '*';
                        for (pathname in data) {
                            if (pathname === '*' || pathname.indexOf(host) !== -1) {
                                if (!KSwitchSampling)
                                    KSwitchSampling = {};
                                KSwitchSampling[pathname] = data[pathname];
                            }
                        }
                        if (KSwitchSampling)
                            return [2 /*return*/, KSwitchSampling];
                    }
                }
                return [3 /*break*/, 7];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7:
                KSwitchSampling = null;
                return [2 /*return*/, KSwitchSampling];
        }
    });
}); };
var deviceInfo = null;
var getDeviceInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
    var enable;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!_yoda)
                    return [2 /*return*/, null];
                return [4 /*yield*/, isSupportBridge('getDeviceInfo', 'system')];
            case 1:
                enable = _a.sent();
                if (!enable) return [3 /*break*/, 5];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, _yoda.system.getDeviceInfo()];
            case 3:
                deviceInfo = _a.sent();
                return [2 /*return*/, deviceInfo];
            case 4:
                _a.sent();
                return [2 /*return*/, null];
            case 5: return [2 /*return*/];
        }
    });
}); };
var appInfo = null;
var getAppInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
    var enable;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!_yoda)
                    return [2 /*return*/, null];
                return [4 /*yield*/, isSupportBridge('getAppInfo', 'system')];
            case 1:
                enable = _a.sent();
                if (!enable) return [3 /*break*/, 5];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, _yoda.system.getAppInfo()];
            case 3:
                appInfo = _a.sent();
                return [2 /*return*/, appInfo];
            case 4:
                _a.sent();
                return [2 /*return*/, null];
            case 5: return [2 /*return*/];
        }
    });
}); };
var yodaUtils = {
    isSupportBridge: isSupportBridge,
    getWebviewLoadPerf: getWebviewLoadPerf,
    sendRadarLog: sendRadarLog,
    setClientLog: setClientLog,
    yodaAlready: yodaAlready,
};

function network() {
    try {
        var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (!connection) {
            // 不支持connection的全部为UNKNOWN_NETWORK
            return networkType.unknown;
        }
        var type = connection.type;
        var effectiveType = connection.effectiveType;
        return networkType[type] || networkType[effectiveType] || networkType.unknown;
    }
    catch (err) {
        return networkType.unknown;
    }
}
function platform() {
    try {
        var uaInfo = getUAInfo();
        if (!uaInfo.os.name) {
            return Base.Platform.UNKNOWN_PLATFORM;
        }
        var inApp = isInApp();
        if (uaInfo.os.name === 'Android') {
            return inApp
                ? Base.Platform.ANDROID_PHONE_H5
                : Base.Platform.OUTSIDE_ANDROID_H5;
        }
        if (uaInfo.os.name === 'iOS') {
            return inApp
                ? Base.Platform.IPHONE_H5
                : Base.Platform.OUTSIDE_IOS_H5;
        }
        return Base.Platform.PC_WEB;
    }
    catch (err) {
        return Base.Platform.UNKNOWN_PLATFORM;
    }
}
function container() {
    if (isReactNative()) {
        return Base.Container.REACT_NATIVE;
    }
    if (platform() === Base.Platform.PC_WEB) {
        return Base.Container.WEB;
    }
    return Base.Container.H5;
}
function mergeOptions(target, options) {
    if (!options) {
        return;
    }
    Object.keys(options).forEach(function (key) {
        var value = options[key];
        var isNeedMerge = key !== 'h5_extra_attr';
        if (typeof value === 'object' && isNeedMerge && target[key] !== undefined) {
            mergeOptions(target[key], value);
        }
        else if (value) {
            target[key] = value;
        }
    });
}
var getOSVersion = function () {
    try {
        return getUAInfo().os.version || 'unknown';
    }
    catch (err) {
        return 'unknown';
    }
};
var getDefaultUserId = function () { return getCookie('userId') || getCookie('userName') || (GlobalConfig.isV2 ? '0' : ''); };
function transformCommonPackage(base, config) {
    var initPackage = {
        identity_package: {},
        network_package: {},
        app_package: {},
        experiment: [],
        service_name: '',
        safety_id: '',
    };
    if (GlobalConfig.isV2) {
        if (!base.product) {
            base.product = ClientCommon.Product[base.product_name || getCookie('kpn')] || 1;
        }
        delete base.product_name;
    }
    else if (!GlobalConfig.isBridge) {
        if (!base.product_name) {
            base.product_name = getCookie('kpn') || 'KUAISHOU';
        }
        delete base.product;
    }
    if (!base.user_id) {
        base.user_id = getDefaultUserId();
    }
    if (!base.device_id) {
        base.device_id = generateDID();
    }
    if (!base.global_id) {
        base.global_id = isInApp() && getCookie('egid') || '';
    }
    for (var _i = 0, initPackageKeys_1 = initPackageKeys; _i < initPackageKeys_1.length; _i++) {
        var _a = initPackageKeys_1[_i], keys = _a.keys, validator = _a.validator, type = _a.type;
        var baseKey = keys[0], subKey = keys[1];
        var baseValue = base[subKey || baseKey];
        if (!subKey) {
            initPackage[baseKey] = base[baseKey];
        }
        else {
            initPackage[baseKey][subKey] = base[subKey];
        }
        if (typeof baseValue !== 'undefined' && !validator(baseValue)) {
            console.error("There is an error init value on '" + (subKey || baseKey) + "', ", "the type should be '" + type + "', ", "but your type is '" + typeof baseValue + "'");
        }
    }
    if (base.network_type) {
        initPackage.network_package.type =
            networkType[base.network_type] ||
                networkType.unknown;
    }
    else {
        delete initPackage.network_package;
    }
    return new CommonPackage(initPackage, config);
}
var CommonPackage = /** @class */ (function () {
    function CommonPackage(options, logConfig) {
        this.identity_package = {
            device_id: '',
            global_id: '',
            user_id: '',
        };
        this.app_package = {
            product: undefined,
            language: navigator.language,
            platform: platform(),
            container: container(),
            package_name: '',
            product_name: undefined,
            version_name: getCookie('appver', undefined, true) || '',
            channel: '',
            version_code: 0,
        };
        this.device_package = {
            os_version: getOSVersion(),
            model: getModel(),
            ua: navigator.userAgent,
        };
        this.need_encrypt = false;
        this.network_package = {
            type: network(),
        };
        this.sdk_version = GlobalConfig.isV2 ? undefined : '3.8.21';
        mergeOptions(this, options);
        this.checkMustProps();
        if (this.app_package.version_name) {
            var lastDotIndex = this.app_package.version_name.lastIndexOf('.');
            this.app_package.version_code = +this.app_package.version_name.slice(lastDotIndex + 1) || 0;
        }
        // TODO: 这块参数有些混乱，options 和 logConfig 都可能传 h5_extra_attr 和 product_name 进来
        var mixinOptions = _assign(_assign({}, options), logConfig);
        this.h5_extra_attr = _assign(_assign(_assign({}, CommonPackage.DefaultH5ExtraAttr), mixinOptions.h5_extra_attr), { app_version_name: this.app_package.version_name, product_name: mixinOptions.product_name });
    }
    /**
     * 检查必填参数
     */
    CommonPackage.prototype.checkMustProps = function () {
        if (GlobalConfig.isV2) {
            if (typeof this.app_package.product !== 'number') {
                console.error('请设置有效的 product 值!');
            }
        }
        else if (!GlobalConfig.isBridge) {
            if (typeof this.app_package.product_name !== 'string') {
                console.error('请设置有效的 product_name 值!');
            }
        }
    };
    CommonPackage.prototype.setAdditionalSeqIdPackage = function (eventType) {
        this.additional_seq_id_package = {
            channel: Base.AdditionalSeqIdPackageChannel.NORMAL,
            channel_seq_id: getChannelIncrementId('NORMAL'),
            custom_type: eventType,
            custom_seq_id: getV2EventIncrementId(eventType),
        };
    };
    // h5 id 自增，用在 Bridge 模式下验证 Bridge 丢失率
    CommonPackage.prototype.increaseH5SeqId = function (isCustom) {
        this.setH5ClientTimestamp();
        this.h5_extra_attr.seq_id = isCustom ? getBridgeCustomIncrementId() : getBridgeNormalIncrementId();
    };
    // 在 bridge 模式下生成时间戳
    CommonPackage.prototype.setH5ClientTimestamp = function () {
        this.h5_extra_attr.client_timestamp = new Date().valueOf();
    };
    // HTTP 自增 id，每次发起请求连续递增，验证 http 请求丢失
    CommonPackage.prototype.increaseHTTPSeqId = function () {
        this.setH5ClientTimestamp();
        this.h5_extra_attr.http_seq_id = getHttpIncrementId();
    };
    CommonPackage.prototype.setChannel = function () {
        // for radar_channel
        // parseQueryString 居然需要自己去掉问号。。
        if (this.app_package.channel) {
            this.h5_extra_attr.channel = this.app_package.channel;
            return;
        }
        var search = window && window.location && window.location.search || '';
        var queryStringRes = parseQueryString(search.slice(1));
        var queryChannel = queryStringRes ? queryStringRes.channel : '';
        this.h5_extra_attr.channel = queryChannel || getCookie('channel') || '';
    };
    CommonPackage.prototype.getVersionName = function () {
        return this.app_package.version_name;
    };
    CommonPackage.prototype.getChannel = function () {
        return this.h5_extra_attr.channel;
    };
    CommonPackage.prototype.toJSON = function () {
        if (!this.identity_package.user_id) {
            this.identity_package.user_id = getDefaultUserId();
        }
        var json = _assign(_assign({}, cloneDeep(this)), { 
            // 埋点上报时，h5_extra_attr 要处理成字符串
            // @ts-ignore
            h5_extra_attr: JSON.stringify(this.h5_extra_attr) });
        return json;
    };
    // 设置 bridge 信息
    CommonPackage.prototype.setBridgeInfo = function (info) {
        if (info) {
            this.h5_extra_attr.bridge_info = info;
        }
    };
    CommonPackage.prototype.getH5ExtraAttr = function () {
        return this.h5_extra_attr;
    };
    CommonPackage.prototype.update = function (options) {
        var _this = this;
        if (typeof options !== 'object')
            return;
        var commonPackage = this;
        Object.keys(options).forEach(function (key) {
            var newValue = options[key];
            // hasOwnProperty 只检测属性
            if (_this.hasOwnProperty(key)) {
                // 对于 newValue 是对象
                if (typeof commonPackage[key] === 'object' && typeof newValue === 'object'
                    && !(Array.isArray(commonPackage[key]) && newValue)) {
                    newValue = _assign(_assign({}, commonPackage[key]), newValue);
                }
                commonPackage[key] = newValue;
            }
            else {
                var innerPackageKeys = ['identity_package', 'app_package', 'device_package'];
                for (var _i = 0, innerPackageKeys_1 = innerPackageKeys; _i < innerPackageKeys_1.length; _i++) {
                    var innerKey = innerPackageKeys_1[_i];
                    if (key in commonPackage[innerKey]) {
                        commonPackage[innerKey][key] = newValue;
                        break;
                    }
                }
            }
        });
    };
    CommonPackage.prototype.initYodaDeviceInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getDeviceInfo()];
                    case 1:
                        info = _a.sent();
                        if (info && info.mod) {
                            this.device_package.model = info.mod;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CommonPackage.prototype.initYodaAppInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getAppInfo()];
                    case 1:
                        info = _a.sent();
                        if (info) {
                            info.did && (this.identity_package.device_id = info.did);
                            info.userId && !this.identity_package.user_id && (this.identity_package.user_id = info.userId);
                            info.appver && (this.app_package.version_name = info.appver);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    // 默认 H5 附加信息
    CommonPackage.DefaultH5ExtraAttr = {
        host_product: getDefaultKpn(),
        app_version_name: getCookie('appver', undefined, true) || '',
        resolution: getResolution(),
        domain: window && window.location && window.location.origin || '',
        sdk_name: 'webLogger',
        sdk_version: '3.8.21',
    };
    return CommonPackage;
}());

/**
 * @file iframe发送log
 *
 * @author 天翔Skyline(skyline0705@gmail.com)
 * May 14, 2019
 */
var commonHideStyle = [
    'display: none;',
    'position: absolute;',
    'top: -9999px',
    'left: -9999px',
].join('');
function createIframe(target) {
    var iframe = document.createElement('iframe');
    document.body.appendChild(iframe);
    iframe.contentWindow.name = target;
    iframe.style.cssText = commonHideStyle;
    return iframe;
}
function createForm(target, url) {
    var form = document.createElement('form');
    document.body.appendChild(form);
    form.target = target;
    form.enctype = 'multipart/form-data';
    form.method = 'POST';
    form.action = url;
    form.style.cssText = commonHideStyle;
    return form;
}
function appendDataToForm(form, data) {
    for (var key in data) {
        if (data.hasOwnProperty(key)) {
            var input = document.createElement('input');
            input.name = key;
            input.value = JSON.stringify(data[key]);
            form.appendChild(input);
        }
    }
}
function sendData$1(_a, callback) {
    var url = _a.url, data = _a.data;
    var target = "iframe_" + nanoId();
    var iframe = createIframe(target);
    var form = createForm(target, url);
    appendDataToForm(form, data);
    try {
        form.submit();
    }
    catch (e) {
        return callback && callback(e);
    }
    iframe.onload = function () {
        document.body.removeChild(iframe);
        document.body.removeChild(form);
        iframe = null;
        form = null;
    };
    callback && callback();
}

function send$1(_a, callback) {
    var url = _a.url, data = _a.data, timeout = _a.timeout;
    var xhr = new XMLHttpRequest();
    // async 同步情况会报错，而且影响性能，取消使用同步
    xhr.open('POST', url);
    if (timeout) {
        xhr.timeout = timeout;
    }
    xhr.onload = function () {
        var err;
        if (xhr.status < 200 || (xhr.status >= 300 && xhr.status !== 304)) {
            err = xhr.response || xhr.status || 'unknonw error';
        }
        callback && callback(err);
    };
    xhr.ontimeout = xhr.onerror = function (e) {
        callback && callback(e);
    };
    xhr.send(data);
}

var enableBeacon = false;
(function () {
    try {
        var uaInfo = getUAInfo();
        var forceUseBeacon = uaInfo.browser.name === 'Chrome'
            && +(uaInfo.browser.major || 0) > 77;
        enableBeacon = forceUseBeacon && typeof window !== 'undefined' && typeof window.navigator !== 'undefined' && typeof window.navigator.sendBeacon === 'function';
    }
    catch (err) { }
})();
function send(_a) {
    var url = _a.url, data = _a.data;
    if (!enableBeacon)
        return false;
    // xhook 如果改写了 FormData
    if (typeof data === 'object' && data.fd) {
        data = data.fd;
    }
    return navigator.sendBeacon(url, data);
}

/**
 * @file IO工具函数
 *
 * @author 天翔Skyline(skyline0705@gmail.com)
 * May 15, 2019
 */
function transToFormData(data) {
    var formData = new FormData();
    for (var key in data) {
        if (data.hasOwnProperty(key)) {
            formData.append(key, JSON.stringify(data[key]));
        }
    }
    return formData;
}

function sendData(_a, callback) {
    var url = _a.url, data = _a.data, timeout = _a.timeout, format = _a.format;
    // 使用 iframe 发送
    if (needCompatible()) {
        return sendData$1({ url: url, data: data }, callback);
    }
    data = format && format === 'string' ? JSON.stringify(data) : transToFormData(data);
    // 优先走 sendBeacon，如果成功把数据添加到 beacon 通道，则认为发送成功
    if (send({ url: url, data: data })) {
        return callback && callback();
    }
    send$1({ url: url, data: data, timeout: timeout }, callback);
}

// 测试环境 url
var devHost = 'https://webapi.test.gifshow.com/';
var dataTrackHost = 'https://data-track.corp.kuaishou.com';
var testHost = dataTrackHost + '/';
var isDataTrack = function (host) { return host.indexOf('data-track.corp') !== -1; };
var xhrGet = function (url) {
    try {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.send();
    }
    catch (err) { }
};
var getReportUrl = function (viewHost, reportHost, sessionId) {
    if (sessionId === void 0) { sessionId = generateDID(); }
    var loggerUrl = isDataTrack(reportHost) ? dataTrackHost + "/v3/#/logger/index?sessionId=" + sessionId : viewHost + "/#/home?sessionId=" + sessionId;
    console.log("%c\u65E5\u5FD7\u6293\u5305\u6821\u9A8C: %c" + loggerUrl, 'color:#1abf89;font-size:1.4em;line-height:2.4em;', 'font-size:1.2em;');
    return reportHost + "/" + sessionId + "/";
};
/**
 * logger 平台上报 url
 */
var getLoggerReportUrl = function () {
    var did = generateDID();
    xhrGet(dataTrackHost + "/rest/" + did);
    return getReportUrl('', dataTrackHost + "/rest", did);
};
/**
 * 端内环境根据cookie值切换发送地址
 */
var getCookieReportUrl = function () {
    try {
        var webloggerSwitch = getCookie('weblogger_switch') ||
            typeof sessionStorage !== 'undefined' && sessionStorage.getItem('weblogger_switch');
        if (!webloggerSwitch)
            return;
        var _a = JSON.parse(webloggerSwitch), loggerSessionId = _a.loggerSessionId, reportHost = _a.reportHost, loggerHost = _a.loggerHost, handshakeApi = _a.handshakeApi;
        // 若cookie内存在loggerSessionId，则会自动切换发送路径到测试地址，否则返回空，代表不切换地址
        if (!loggerSessionId || !isDataTrack(reportHost)) {
            return '';
        }
        xhrGet(handshakeApi || reportHost + "/" + loggerSessionId);
        return getReportUrl(loggerHost, reportHost, loggerSessionId);
    }
    catch (err) {
        return '';
    }
};
/**
 * 端外H5 or pc页面根据当前的url参数切换发送地址
 */
var getWebPageReportUrl = function (url) {
    if (url === void 0) { url = location.href; }
    var queryIndex = url.lastIndexOf('?');
    if (queryIndex === -1) {
        return '';
    }
    var queryString = url.slice(queryIndex + 1);
    var webloggerSwitch = parseQueryString(queryString).webloggerSwitch;
    if (!webloggerSwitch) {
        return '';
    }
    try {
        var data = decodeURIComponent(webloggerSwitch);
        var _a = JSON.parse(data), loggerSessionId = _a.loggerSessionId, reportHost = _a.reportHost, loggerHost = _a.loggerHost, handshakeApi = _a.handshakeApi;
        if (!loggerSessionId || !isDataTrack(reportHost)) {
            return '';
        }
        // 存到 sessionStorage 中使同域名页面都可以调试
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem('weblogger_switch', data);
        }
        xhrGet(handshakeApi || reportHost + "/" + loggerSessionId);
        return getReportUrl(loggerHost, reportHost, loggerSessionId);
    }
    catch (err) {
        return '';
    }
};
// 不同环境的接口
var Hosts = {
    v2: {
        // 正式环境随机域名分流
        production: ['https://wlog.ksapisrv.com/', 'https://wlog.gifshow.com/'][Math.round(Math.random())],
        development: devHost,
        test: testHost
    },
    v3: {
        production: 'https://log-sdk.ksapisrv.com/',
        development: devHost,
        test: testHost
    }
};
var Apis = {
    v2: 'rest/kd/log/collect?_json=1&biz=',
    v3: 'rest/wd/common/log/collect/misc2',
    // 雷达都上报到 v3
    radar: 'rest/wd/common/log/collect/radar'
};
var getUrl = function (env, radar, proto) {
    if (env === void 0) { env = 'production'; }
    if (radar === void 0) { radar = false; }
    if (proto === void 0) { proto = GlobalConfig.proto; }
    if (['production', 'test', 'development'].indexOf(env) === -1) {
        return env + Apis[proto];
    }
    if (radar) {
        return Hosts.v3[env] + Apis.radar;
    }
    return Hosts[proto][env] + Apis[proto];
};
// 是否未排干日志队列
var drained = false;
var BatchLog = /** @class */ (function () {
    function BatchLog() {
        var _this = this;
        // 存储待发送的消息
        this.logQueue = [];
        // 存储失败或者超时的数据
        this.errorQueue = [];
        this.url = '';
        this.radarUrl = '';
        /**
         * 清空当前日志队列
         * @param callback
         */
        this.flush = function (callback) {
            _this.sendLogs(_this.logQueue, callback);
            _this.logQueue = [];
        };
        /**
         * 页面关闭前排干所有未发送的和发送失败的日志
         */
        this.drain = function () {
            _this.flush();
            _this.flushErrorLogs();
            drained = true;
            // 处理 beforunload 中断，实际页面未退出的情况
            setTimeout(function () {
                drained = false;
            }, 1000);
            /* 会导致重复率升高，春节后再看服务端去重后处理
                const logPackages = this.errorQueue.slice(0)
                this.errorQueue = [];
                this.sendingQuery = {};
                if (this.logQueue.length) {
                    logPackages.unshift(this.buildLogPackage(this.logQueue));
                    this.logQueue = [];
                }
                const unSendLogPackages: LogPackage[] = [];
                logPackages.forEach(logPackage => {
                    this.beforeStore(logPackage);
                    unSendLogPackages.push(logPackage);
                });
                // 不支持 sendBeacon 或者添加到 beacon 失败的日志则存到本地
                if (unSendLogPackages.length) {
                    storeLogs(unSendLogPackages.concat(
                        Object.keys(this.sendingQuery).map(key => this.sendingQuery[key])
                    ));
                }
            */
        };
    }
    /*
    constructor() {
        this.compensateLogs();
    }
    */
    BatchLog.prototype.updateBase = function (commonPackage) {
        this.commonPackage = commonPackage;
    };
    /**
     * 根据配置生成上报的 url 地址
     */
    BatchLog.prototype.updateUrls = function () {
        var _a = this.config, env = _a.env, logger = _a.logger;
        var url = getCookieReportUrl() || getWebPageReportUrl();
        if (url) {
            this.radarUrl = this.url = getUrl(url);
            GlobalConfig.isDebug = true;
        }
        else if (logger || env === 'logger') {
            var loggerEnv = getLoggerReportUrl();
            this.url = getUrl(loggerEnv);
            this.radarUrl = this.url.indexOf(Apis.v2) !== -1 ? this.url.replace(Apis.v2, Apis.radar) : this.url.replace(Apis.v3, Apis.radar);
            GlobalConfig.isDebug = true;
        }
        else if (env && /^(https?:)?\/\//.test(env)) {
            this.url = env;
            this.radarUrl = this.url.replace(Apis.v3, Apis.radar);
        }
        else {
            this.url = getUrl(env);
            this.radarUrl = getUrl(env, true);
        }
    };
    BatchLog.prototype.init = function (config, commonPackage) {
        this.config = (_assign(_assign({}, this.config), config));
        this.updateUrls();
        this.updateBase(commonPackage);
    };
    /**
     * 之所以使用 JSON 而不是 commonPackage 对象，是因为对象可能会变化，而 JSON 则是当时的一个快照，一旦生成不会变化
     */
    BatchLog.prototype.getCommonPackageJSON = function () {
        if (!GlobalConfig.isV2) {
            this.commonPackage.increaseHTTPSeqId();
            delete this.commonPackage.h5_extra_attr.bridge_info;
        }
        return this.commonPackage.toJSON();
    };
    /**
     * 每个 logPackage 包含了所有上报所需的信息，上报地址和上报数据
     * @param logs
     * @param url
     */
    BatchLog.prototype.buildLogPackage = function (logs, url) {
        if (url === void 0) { url = this.url; }
        if (GlobalConfig.isV2) {
            return this.buildV2Package(logs, url);
        }
        return this.buildV3Package(logs, url);
    };
    BatchLog.prototype.buildV2Package = function (logs, url) {
        if (url === void 0) { url = this.url; }
        return {
            url: url,
            data: {
                log: {
                    event: logs
                }
            },
            format: 'string',
        };
    };
    BatchLog.prototype.buildV3Package = function (logs, url) {
        if (url === void 0) { url = this.url; }
        return {
            url: url,
            data: {
                common: this.getCommonPackageJSON(),
                logs: {
                    // 格式对应PB定义中RawBatchReportEvent
                    event: logs,
                },
            },
            format: 'formdata',
        };
    };
    /**
     * 批量发送日志
     * @param logs
     * @param callback
     */
    BatchLog.prototype.sendLogs = function (logs, callback) {
        var _this = this;
        if (!logs || !logs.length) {
            return typeof callback === 'function' && callback();
        }
        var data = this.buildLogPackage(logs);
        // 如果已经调过 drained 方法应该直接走 drain 逻辑，但是在浏览器中会造成重复
        // if (drained) {
        //     this.beforeStore(data);
        //     return storeLogs([data]);
        // }
        // data.seqid = seqid ++;
        var callbackFn = function (error) {
            // if (typeof data.seqid !== 'undefined') {
            //     delete this.sendingQuery[data.seqid];
            // }
            // 如果网络异常，日志发送失败，则将错误日志缓存，在网络恢复时清空一次错误队列
            if (error) {
                _this.errHandler(data);
            }
            else {
                _this.flushErrorLogs();
            }
            typeof callback === 'function' && callback(error);
        };
        // this.sendingQuery[data.seqid] = data;
        this.sendPackage(data, callbackFn);
    };
    /**
     * 直接发送一个数据包，包含 url 和 日志
     * @param data
     * @param callback
     */
    BatchLog.prototype.sendPackage = function (data, callback) {
        var _a = this.config, timeout = _a.timeout, sender = _a.sender;
        try {
            // 如果业务方配置了 sender
            if (typeof sender === 'function') {
                sender(data, callback);
            }
            else {
                sendData(_assign(_assign({}, data), { timeout: timeout }), callback);
            }
        }
        catch (err) {
            typeof callback === 'function' && callback(err);
        }
    };
    /**
     * 日志存储前标识处理
     * @param logPackage
     */
    /* 会导致重复率升高，春节后再看服务端去重后处理
    beforeStore(logPackage: LogPackage) {
        // 使用 puppeteer 测试 sendBeacon 页面关闭前请求成功率低，这里使用 sendBeacon 发送，同时保存本地
        this.sendPackage(logPackage);
        // 标记日志是否来自存储
        if ((logPackage as ClientLogV3.ReportPackage).data.common) {
            (logPackage as ClientLogV3.ReportPackage).data.common.h5_extra_attr.stored = true;
        } else {
            (logPackage as ClientLogV2.ReportPackage).data.log.event.forEach(log => log.common_package.h5_extra_attr.stored = true);
        }
    }
    */
    BatchLog.prototype.send = function (data, immediate, callback) {
        var _this = this;
        if (immediate === void 0) { immediate = false; }
        // v2 是每个 log 都有 common_package
        if (GlobalConfig.isV2) {
            // v2 log 的自增 id 是存在 common 信息中
            this.commonPackage.setAdditionalSeqIdPackage(data.getEventType());
            data.common_package = this.getCommonPackageJSON();
        }
        // 立即发送马上插入发送队列
        // 立即上报可以设置回调函数，延迟上报没有
        if (immediate || drained) {
            this.sendLogs([data], callback);
            return;
        }
        this.logQueue.push(data);
        // 积攒超过最大
        if (this.logQueue.length >= 50) {
            this.flush();
            return;
        }
        // debounce逻辑
        clearTimeout(this.batchWaitTimer);
        this.batchWaitTimer = setTimeout(function () {
            _this.flush();
        }, this.config.wait);
    };
    /**
     * 雷达专用上报（雷达上报接口和其他事件上报接口做了区分，用于分流统计）
     * @param radar
     */
    BatchLog.prototype.sendRadar = function (radar) {
        var radarPackage = this.buildV3Package([radar], this.radarUrl);
        this.sendPackage(radarPackage);
    };
    /**
     * 日志上报出错处理，一般为网络异常
     * @param logPackage
     */
    BatchLog.prototype.errHandler = function (logPackage) {
        var _a;
        if (GlobalConfig.isV2) {
            this.errorQueue.unshift(logPackage);
            return;
        }
        var data = logPackage.data;
        if (!data.logs.event.length)
            return;
        // http_seq_id 和 client_timestamp 不是必须的，合并时删除
        delete data.common.h5_extra_attr.http_seq_id;
        delete data.common.h5_extra_attr.client_timestamp;
        // 尝试合并相同 url 和 common 的请求
        var merged = false;
        for (var i = 0; i < this.errorQueue.length; i++) {
            var currentLog = this.errorQueue[i];
            if (currentLog.url === logPackage.url &&
                currentLog.data.logs.event.length + data.logs.event.length <= 100 &&
                JSON.stringify(currentLog.data.common) === JSON.stringify(data.common)) {
                merged = true;
                (_a = currentLog.data.logs.event).push.apply(_a, data.logs.event);
                break;
            }
        }
        if (!merged) {
            // 先进后出
            // 最大错误数量限制为 5
            if (this.errorQueue.length >= 5) {
                this.errorQueue.pop();
            }
            this.errorQueue.unshift(logPackage);
        }
    };
    // 当网络恢复时尝试一次上报
    BatchLog.prototype.flushErrorLogs = function () {
        var _this = this;
        this.errorQueue.forEach(function (logPackage) {
            _this.sendPackage(logPackage);
        });
        this.errorQueue = [];
    };
    /**
     * 补报本地存的日志，本地可能存在多个，根据时间顺序取出上报
     */
    /* 会导致重复率升高，春节后再看服务端去重后处理
    compensateLogs(secs: number = 1500) {
        this.compensateTimer = setTimeout(() => {
            const logPackages = getStoredLogs();
            if (!logPackages || !logPackages.length) return;
            logPackages.forEach((logPackage: LogPackage) => {
                sendData(logPackage);
            });
        }, secs);
    }
    */
    BatchLog.prototype.destory = function () {
        this.batchWaitTimer && clearTimeout(this.batchWaitTimer);
        this.compensateTimer && clearTimeout(this.compensateTimer);
    };
    return BatchLog;
}());

var initConfig = (function (options) {
    var logConfig = _assign({ env: 'production', proto: 'v3', timeout: 30000, wait: 1000, maxBatchLength: 50, sampleRate: 1, 
        // 尝试从全局中获取 yoda
        yoda: typeof window !== 'undefined' && window.yoda }, (options || {}));
    // 业务方采样配置
    if (options && (typeof options.sampleRateFn === 'function' || typeof options.sampleRate !== 'undefined')) {
        try {
            var sampled = options.sampleRateFn ? options.sampleRateFn() : Math.random() < Number(options.sampleRate);
            updateConfig('sampled', sampled);
        }
        catch (err) {
            updateConfig('sampled', false);
        }
    }
    updateConfig('proto', logConfig.proto || 'v3');
    return logConfig;
});

var ClientEvent$1;
(function (ClientEvent) {
    (function (ShowType) {
        ShowType[ShowType["UNKNOWN_TYPE"] = 0] = "UNKNOWN_TYPE";
        ShowType[ShowType["PAGE_AUTO"] = 10] = "PAGE_AUTO";
        ShowType[ShowType["PAGE_CUSTOM"] = 11] = "PAGE_CUSTOM";
        ShowType[ShowType["ELEMENT"] = 12] = "ELEMENT";
    })(ClientEvent.ShowType || (ClientEvent.ShowType = {}));
    (function (TaskEventType) {
        TaskEventType[TaskEventType["UNKNOWN_TYPE"] = 0] = "UNKNOWN_TYPE";
        TaskEventType[TaskEventType["USER_OPERATION"] = 1] = "USER_OPERATION";
        TaskEventType[TaskEventType["STAY_LENGTH_STAT_EVENT"] = 2] = "STAY_LENGTH_STAT_EVENT";
        TaskEventType[TaskEventType["BACKGROUND_TASK_EVENT"] = 3] = "BACKGROUND_TASK_EVENT";
    })(ClientEvent.TaskEventType || (ClientEvent.TaskEventType = {}));
})(ClientEvent$1 || (ClientEvent$1 = {}));

var ClientEvent;
(function (ClientEvent) {
    (function (PageCategory) {
        PageCategory[PageCategory["UNKNOWN1"] = 0] = "UNKNOWN1";
        PageCategory[PageCategory["APP"] = 1] = "APP";
        PageCategory[PageCategory["HOME"] = 2] = "HOME";
        PageCategory[PageCategory["USER"] = 3] = "USER";
        PageCategory[PageCategory["VIDEO"] = 4] = "VIDEO";
        PageCategory[PageCategory["LIVE_STREAM"] = 5] = "LIVE_STREAM";
        PageCategory[PageCategory["PAY"] = 6] = "PAY";
        PageCategory[PageCategory["ADS"] = 7] = "ADS";
        PageCategory[PageCategory["SEARCH"] = 8] = "SEARCH";
        PageCategory[PageCategory["IMAGE"] = 9] = "IMAGE";
    })(ClientEvent.PageCategory || (ClientEvent.PageCategory = {}));
    (function (ElementType) {
        ElementType[ElementType["UNKNOWN1"] = 0] = "UNKNOWN1";
        ElementType[ElementType["BUTTON"] = 1] = "BUTTON";
        ElementType[ElementType["LABEL"] = 2] = "LABEL";
        ElementType[ElementType["ICON"] = 3] = "ICON";
        ElementType[ElementType["IMAGE"] = 4] = "IMAGE";
        ElementType[ElementType["MENU"] = 5] = "MENU";
        ElementType[ElementType["LINK"] = 6] = "LINK";
        ElementType[ElementType["TAB"] = 7] = "TAB";
        ElementType[ElementType["INPUT_BOX"] = 8] = "INPUT_BOX";
        ElementType[ElementType["OPTION_BOX"] = 9] = "OPTION_BOX";
        ElementType[ElementType["NOTIFICATION"] = 10] = "NOTIFICATION";
        ElementType[ElementType["CARD"] = 11] = "CARD";
        ElementType[ElementType["VIEW"] = 12] = "VIEW";
        ElementType[ElementType["PAGE"] = 13] = "PAGE";
        ElementType[ElementType["VIDEO"] = 14] = "VIDEO";
        ElementType[ElementType["CELL"] = 15] = "CELL";
        ElementType[ElementType["BANNER"] = 16] = "BANNER";
        ElementType[ElementType["BUBBLE"] = 17] = "BUBBLE";
        ElementType[ElementType["POPUP_WINDOW"] = 18] = "POPUP_WINDOW";
    })(ClientEvent.ElementType || (ClientEvent.ElementType = {}));
    (function (ShowType) {
        ShowType[ShowType["UNKNOWN2"] = 0] = "UNKNOWN2";
        ShowType[ShowType["PAGE"] = 1] = "PAGE";
        ShowType[ShowType["SUB_PAGE"] = 2] = "SUB_PAGE";
        ShowType[ShowType["ITEM"] = 3] = "ITEM";
        ShowType[ShowType["DIALOG"] = 4] = "DIALOG";
        ShowType[ShowType["BANNER"] = 5] = "BANNER";
        ShowType[ShowType["BUTTON"] = 6] = "BUTTON";
        ShowType[ShowType["BUBBLE"] = 7] = "BUBBLE";
        ShowType[ShowType["VIDEO"] = 8] = "VIDEO";
        ShowType[ShowType["LIVE"] = 9] = "LIVE";
        ShowType[ShowType["POPUP_WINDOW"] = 10] = "POPUP_WINDOW";
    })(ClientEvent.ShowType || (ClientEvent.ShowType = {}));
    (function (ShowActionType) {
        ShowActionType[ShowActionType["UNKNOWN4"] = 0] = "UNKNOWN4";
        ShowActionType[ShowActionType["CLICK"] = 1] = "CLICK";
        ShowActionType[ShowActionType["LEFT_PULL"] = 2] = "LEFT_PULL";
        ShowActionType[ShowActionType["RIGHT_PULL"] = 3] = "RIGHT_PULL";
        ShowActionType[ShowActionType["BACK_CLICK"] = 4] = "BACK_CLICK";
        ShowActionType[ShowActionType["UP_SLIDE"] = 5] = "UP_SLIDE";
        ShowActionType[ShowActionType["DOWN_SLIDE"] = 6] = "DOWN_SLIDE";
        ShowActionType[ShowActionType["DOWN_PULL"] = 7] = "DOWN_PULL";
        ShowActionType[ShowActionType["CLICK_HOME"] = 8] = "CLICK_HOME";
        ShowActionType[ShowActionType["CLICK_SYS_BACK"] = 9] = "CLICK_SYS_BACK";
        ShowActionType[ShowActionType["CLICK_UPLEFT_ICON"] = 10] = "CLICK_UPLEFT_ICON";
        ShowActionType[ShowActionType["COLD_LAUNCH"] = 11] = "COLD_LAUNCH";
    })(ClientEvent.ShowActionType || (ClientEvent.ShowActionType = {}));
    (function (ResultPackageDomain) {
        ResultPackageDomain[ResultPackageDomain["UNKNOWN2"] = 0] = "UNKNOWN2";
        ResultPackageDomain[ResultPackageDomain["HTTP"] = 1] = "HTTP";
        ResultPackageDomain[ResultPackageDomain["SYSTEM"] = 2] = "SYSTEM";
        ResultPackageDomain[ResultPackageDomain["KUAISHOU"] = 3] = "KUAISHOU";
        ResultPackageDomain[ResultPackageDomain["KINGSOFT_LIVE_PUSH"] = 4] = "KINGSOFT_LIVE_PUSH";
        ResultPackageDomain[ResultPackageDomain["KINGSOFT_LIVE_PLAY"] = 5] = "KINGSOFT_LIVE_PLAY";
    })(ClientEvent.ResultPackageDomain || (ClientEvent.ResultPackageDomain = {}));
    (function (ClickType) {
        ClickType[ClickType["UNKNOWN1"] = 0] = "UNKNOWN1";
        ClickType[ClickType["CLICK"] = 1] = "CLICK";
        ClickType[ClickType["DOUBLE_CLICK"] = 2] = "DOUBLE_CLICK";
        ClickType[ClickType["TRIPLE_CLICK"] = 3] = "TRIPLE_CLICK";
        ClickType[ClickType["LONG_PRESS"] = 4] = "LONG_PRESS";
        ClickType[ClickType["PULL"] = 5] = "PULL";
        ClickType[ClickType["DRAG"] = 6] = "DRAG";
        ClickType[ClickType["SCALE"] = 7] = "SCALE";
        ClickType[ClickType["PULL_DOWN"] = 8] = "PULL_DOWN";
        ClickType[ClickType["PULL_UP"] = 9] = "PULL_UP";
        ClickType[ClickType["RIGHT_CLICK"] = 10] = "RIGHT_CLICK";
        ClickType[ClickType["AUTO"] = 11] = "AUTO";
    })(ClientEvent.ClickType || (ClientEvent.ClickType = {}));
})(ClientEvent || (ClientEvent = {}));

var firstLoad = true;
var enterTime = new Date().valueOf();
var ShowEvent = (function (options) {
    var _a, _b;
    var type = options.type, currentUrlPackage = options.currentUrlPackage, referUrlPackage = options.referUrlPackage, _c = options.name, name = _c === void 0 ? '' : _c, action = options.action, beginTime = options.beginTime, params = options.params, contentPackage = options.contentPackage, status = options.status, actionType = options.actionType, // 这值目前似乎没传进来
    auto = options.auto;
    var commonInfo = (_a = {
            status: status ? (Base.ActionStatus[status] || Base.ActionStatus.UNKNOWN_STATUS) : Base.ActionStatus.SUCCESS
        },
        _a[GlobalConfig.isV2 ? 'show_type' : 'action_type'] = actionType ? (Base.ActionType[actionType] || Base.ActionType.UNKNOWN_ACTION_TYPE) : Base.ActionType.CLICK,
        _a.url_package = currentUrlPackage,
        _a.refer_url_package = referUrlPackage,
        _a[GlobalConfig.isV2 ? 'content_wrapper' : 'content_package'] = contentPackage,
        _a);
    if (type === 'PV') {
        var sub_action = Base.SubAction.PAGE_ENTER;
        var actionPB = Base.PageShowAction.ENTER;
        var first_load = firstLoad;
        var stay_length = 0;
        firstLoad = false;
        switch (action) {
            case 'leave':
                actionPB = Base.PageShowAction.LEAVE;
                sub_action = Base.SubAction.PAGE_LEAVE;
                stay_length = new Date().valueOf() - (beginTime || enterTime);
                break;
            case 'enter':
                actionPB = Base.PageShowAction.ENTER;
                sub_action = Base.SubAction.PAGE_ENTER;
                enterTime = new Date().valueOf();
                break;
            case 'visible':
                actionPB = Base.PageShowAction.RESUME;
                sub_action = Base.SubAction.PAGE_RESUME;
                enterTime = new Date().valueOf();
                break;
            case 'hidden':
                actionPB = Base.PageShowAction.LEAVE;
                sub_action = Base.SubAction.PAGE_PAUSE;
                stay_length = new Date().valueOf() - (beginTime || enterTime);
                break;
        }
        var showType = auto ? ClientEvent$1.ShowType.PAGE_AUTO : ClientEvent$1.ShowType.PAGE_CUSTOM;
        if (GlobalConfig.isV2) {
            first_load = undefined;
            showType = ClientEvent.ShowType.PAGE;
        }
        return {
            show_event: _assign({ action: actionPB, sub_action: sub_action, type: showType, first_load: first_load, time_cost: 0, stay_length: stay_length }, commonInfo)
        };
    }
    return {
        show_event: _assign({ action: GlobalConfig.isV2 ? 0 : Base.PageShowAction.ENTER, 
            // @ts-ignore
            type: GlobalConfig.isV2 ? 0 : ClientEvent$1.ShowType.ELEMENT, sub_action: GlobalConfig.isV2 ? 0 : Base.SubAction.PAGE_ENTER, element_package: (_b = {},
                _b[GlobalConfig.isV2 ? 'action2' : 'action'] = name,
                _b.params = JSON.stringify(params),
                _b) }, commonInfo)
    };
});

var TaskEvent = (function (options) {
    var _a, _b;
    var sessionId = options.sessionId, currentUrlPackage = options.currentUrlPackage, referUrlPackage = options.referUrlPackage, name = options.name, params = options.params, type = options.type, contentPackage = options.contentPackage, status = options.status, taskType = options.taskType, operationDirection = options.operationDirection;
    var commonInfo = (_a = {
            url_package: currentUrlPackage,
            refer_url_package: referUrlPackage,
            element_package: (_b = {},
                _b[GlobalConfig.isV2 ? 'action2' : 'action'] = name,
                _b.params = JSON.stringify(params),
                _b)
        },
        _a[GlobalConfig.isV2 ? 'content_wrapper' : 'content_package'] = contentPackage,
        _a);
    if (GlobalConfig.isV2) {
        // v2 click_event 是一个单独的事件类型，v3 则属于 task_event
        if (type === 'CLICK') {
            return {
                click_event: _assign({ type: taskType && ClientEvent.ClickType[taskType] || ClientEvent.ClickType.CLICK, direction: operationDirection && Base.Direction[operationDirection] || Base.Direction.UNKNOWN2 }, commonInfo)
            };
        }
        return {
            task_event: _assign({ action2: type, status: status && Base.TaskStatus[status] || Base.TaskStatus.UNKNOWN_STATUS }, commonInfo)
        };
    }
    return {
        task_event: _assign({ type: taskType && ClientEvent$1.TaskEventType[taskType] || ClientEvent$1.TaskEventType.USER_OPERATION, status: status && Base.TaskStatus[status] || Base.TaskStatus.UNKNOWN_STATUS, operation_type: Base.OperationType[type] || Base.OperationType.CLICK, operation_direction: operationDirection && Base.Direction[operationDirection] || Base.Direction.UNKNOWN2, session_id: sessionId }, commonInfo)
    };
});

/**
 * 自定义事件上报
 */
var CustomStatEvent = (function (options) {
    var name = options.name, params = options.params, currentUrlPackage = options.currentUrlPackage, referUrlPackage = options.referUrlPackage, extra = __rest(options, ["name", "params", "currentUrlPackage", "referUrlPackage"]);
    return {
        key: name,
        value: JSON.stringify(_assign(_assign({ url_package: currentUrlPackage, refer_url_package: referUrlPackage }, params), extra))
    };
});

var VideoStatEvent = (function (params) {
    var currentUrlPackage = params.currentUrlPackage, referUrlPackage = params.referUrlPackage, options = params.options;
    return {
        video_stat_event: _assign(_assign({}, options), { url_package: currentUrlPackage, refer_url_package: referUrlPackage }),
    };
});

var GMT = (function () {
    var timeZoneGMTOffset = (new Date()).getTimezoneOffset() / 60;
    return timeZoneGMTOffset <= 0
        ? "GMT+" + leftPad(-timeZoneGMTOffset + '', 2, '0') + ":00"
        : "GMT-" + leftPad(timeZoneGMTOffset + '', 2, '0') + ":00";
})();
// 为防止每个传出都带common_package，所以用base保留大多数信息
// 部分信息放到每个消息体内维护，比如client_timestamp
var ReportEvent = /** @class */ (function () {
    function ReportEvent(options) {
        // uint64 客户端时间, Event或Stat发生时的时间, 而不是上传时的时间
        this.client_timestamp = new Date().valueOf();
        // uint64 客户端自增Id, 每新增一条日志+1, 必须是连续的, 用于校检数据完整性
        this.client_increment_id = 0;
        // string 会话id，设备冷启动或者切到后台超过5分钟再切回前台时，重新生成一个id
        // 端内页面不可缺省
        this.session_id = GlobalConfig.sessionId;
        // 埋点唯一主键， PB 中已不推荐使用
        this.event_id = '';
        // v2 没有 time_zone 字段
        if (!GlobalConfig.isV2) {
            this.time_zone = GMT;
        }
        Object.assign(this, options);
        this.genIncrementId();
    }
    // 设置自增 id，自定义事件和常规事件使用不同的 localStorage key
    ReportEvent.prototype.genIncrementId = function () {
        this.client_increment_id = this.isCustomStatEvent() ? getCustomIncrementId() : getNomalIncrementId();
    };
    // 是否是自定义事件
    ReportEvent.prototype.isCustomStatEvent = function () {
        return !!(this.stat_package && 'custom_stat_event' in this.stat_package);
    };
    // 获取埋点事件类型
    ReportEvent.prototype.getEventType = function () {
        if (this.event_package) {
            var _a = this.event_package, task_event = _a.task_event, show_event = _a.show_event, click_event = _a.click_event, custom_event = _a.custom_event;
            if (show_event)
                return 'showEvent';
            if (click_event)
                return 'clickEvent';
            if (task_event)
                return 'taskEvent';
            if (custom_event)
                return 'customEvent';
        }
        return 'customEvent';
    };
    return ReportEvent;
}());
// tslint:enable
function logFactory(type, data) {
    var event_id = data.eventId, currentUrlPackage = data.currentUrlPackage, referUrlPackage = data.referUrlPackage, contentPackage = data.contentPackage, name = data.name, params = data.params;
    if (GlobalConfig.isV2 && type !== 'RADAR' && type !== 'CUSTOM') {
        if (currentUrlPackage) {
            // @ts-ignore
            currentUrlPackage.page2 = currentUrlPackage.page;
            delete currentUrlPackage.page;
        }
        if (referUrlPackage) {
            // @ts-ignore
            referUrlPackage.page2 = referUrlPackage.page;
            delete referUrlPackage.page;
        }
    }
    switch (type) {
        case 'PV':
        case 'SHOW':
            return new ReportEvent({
                event_package: ShowEvent({
                    type: type,
                    status: data.status,
                    currentUrlPackage: currentUrlPackage,
                    referUrlPackage: referUrlPackage,
                    action: data.type,
                    beginTime: data.beginTime,
                    name: name,
                    params: params,
                    contentPackage: contentPackage,
                    operationDirection: data.operationDirection,
                    auto: data.auto,
                }),
                event_id: event_id,
            });
        case 'CUSTOM':
            var customData = CustomStatEvent({
                name: name,
                params: params,
                currentUrlPackage: currentUrlPackage,
                referUrlPackage: referUrlPackage,
            });
            return new ReportEvent(GlobalConfig.isV2 ?
                {
                    event_package: {
                        custom_event: customData,
                    },
                    event_id: event_id,
                }
                :
                    {
                        stat_package: {
                            custom_stat_event: customData,
                        },
                        event_id: event_id,
                    });
        case 'RADAR':
            return new ReportEvent({
                stat_package: {
                    custom_stat_event: CustomStatEvent({
                        name: name,
                        params: params,
                        currentUrlPackage: currentUrlPackage,
                        referUrlPackage: referUrlPackage,
                    }),
                },
                event_id: event_id,
            });
        case 'VIDEO':
            if (GlobalConfig.isV2) {
                return new ReportEvent({
                    stat_package: VideoStatEvent({
                        currentUrlPackage: currentUrlPackage,
                        referUrlPackage: referUrlPackage,
                        options: params.params,
                    }),
                });
            }
            return new ReportEvent({
                event_package: TaskEvent({
                    type: type,
                    status: data.status,
                    taskType: data.taskType,
                    sessionId: GlobalConfig.sessionId,
                    currentUrlPackage: currentUrlPackage,
                    referUrlPackage: referUrlPackage,
                    name: name,
                    params: params.params,
                    contentPackage: contentPackage,
                }),
                event_id: event_id,
            });
        default:
            return new ReportEvent({
                event_package: TaskEvent({
                    type: type,
                    status: data.status,
                    taskType: data.taskType,
                    sessionId: GlobalConfig.sessionId,
                    currentUrlPackage: currentUrlPackage,
                    referUrlPackage: referUrlPackage,
                    name: name,
                    params: params,
                    contentPackage: contentPackage,
                }),
                event_id: event_id,
            });
    }
}

var PageType;
(function (PageType) {
    // 未知
    PageType[PageType["UNKNOWN_PAGE_TYPE"] = 0] = "UNKNOWN_PAGE_TYPE";
    // native页面
    PageType[PageType["NATIVE"] = 1] = "NATIVE";
    // h5页面
    PageType[PageType["H5"] = 2] = "H5";
    // 小程序页面
    PageType[PageType["MINA"] = 3] = "MINA";
})(PageType || (PageType = {}));
// tslint:disable variable-name
var UrlPackage = /** @class */ (function () {
    function UrlPackage(url, pageType, urlMap) {
        if (pageType === void 0) { pageType = 'web'; }
        // 一级页面。参考埋点需求填写即可
        this.page = '';
        // 实例的全局唯一标识，使用UUID即可
        this.identity = '';
        switch (pageType) {
            case 'web':
                this.page_type = PageType.H5;
                break;
            case 'native':
                this.page_type = PageType.NATIVE;
                break;
            case 'mina':
                this.page_type = PageType.MINA;
                break;
            default:
                this.page_type = PageType.UNKNOWN_PAGE_TYPE;
        }
        if (typeof url === 'string') {
            // TODO: 避免兼容问题，暂不处理
            // try {
            //     url = window.decodeURIComponent(url);
            // } catch (err) {}
            var obj = getUrlAndQueryFromUrl(url);
            this.page = obj.page;
            this.params = obj.params;
        }
        else {
            this.page = (url || {}).page || '';
            this.params = (url || {}).params || undefined;
        }
        this.identity = uuid(this.page);
        if (urlMap && typeof url === 'string') {
            this.init(url, urlMap);
        }
    }
    UrlPackage.prototype.init = function (url, urlMap) {
        if (urlMap === void 0) { urlMap = {}; }
        var _a = getMappingPage({ url: url, page: this.page, params: this.params }, urlMap), page = _a.page, params = _a.params;
        this.update(page, params);
    };
    UrlPackage.prototype.update = function (page, params) {
        if (page === void 0) { page = ''; }
        if (page && page !== this.page) {
            this.page = page;
            this.identity = uuid(page);
        }
        if (params) {
            if (!this.params)
                this.params = {};
            Object.assign(this.params, params);
        }
    };
    UrlPackage.prototype.toJSON = function () {
        return {
            page: this.page,
            identity: this.identity,
            page_type: this.page_type,
            params: JSON.stringify(this.params)
        };
    };
    /**
     * 获取真实的 url 信息，并与 PV 上报的通过参数做关联
     */
    UrlPackage.prototype.getRealUrlPackage = function () {
        var _a = getUrlAndQueryFromUrl(location.href), page = _a.page, params = _a.params;
        return {
            page: page,
            params: JSON.stringify({
                url: location.href,
                page: this.page,
                query: params
            }),
            page_type: this.page_type,
            identity: this.identity
        };
    };
    return UrlPackage;
}());
// tslint:enable

// 为了减少点代码体积，自己搞一个简易的EventEmitter
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.events = {};
    }
    EventEmitter.prototype.on = function (eventName, callback) {
        if (callback && typeof callback === 'function') {
            this.events[eventName] = this.events[eventName] || [];
            this.events[eventName].push(callback);
        }
    };
    EventEmitter.prototype.off = function (eventName, callback) {
        if (!this.events[eventName]) {
            return;
        }
        if (callback && typeof callback === 'function') {
            deleteArray(this.events[eventName], callback);
        }
        if (!callback) {
            this.events[eventName] = [];
        }
    };
    EventEmitter.prototype.emit = function (eventName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this.events[eventName]) {
            return;
        }
        this.events[eventName].forEach(function (callback) {
            callback.apply(void 0, args);
        });
    };
    return EventEmitter;
}());

var pluginIndex = 0;
// session_id 用来串联在一次打开 App 期间跳转不同页面的用户行为
var getSessionId = function () {
    var sessionId = '';
    var defaultKey = 'session_id';
    // const customKey = 'weblogger_session_id';
    sessionId = getCookie(defaultKey) || getCookie('sid'); // 端内从 cookie 中获取客户端传来的 session_id
    if (sessionId)
        return sessionId;
    var defaultSessionId = "weblogger_" + uuid('weblogger');
    // try {
    //     if (typeof window !== 'undefined' && window.sessionStorage) {
    //         sessionId = window.sessionStorage.getItem(defaultKey) // 尝试获取服务端传来的 session_id
    //             || window.sessionStorage.getItem(customKey) || ''; // 如果都没设置，则获取 weblogger 生成的 session_id;
    //         if (sessionId) return sessionId;
    //         // 如果没有获取到 session_id 则生成一个，并设置到 sessionStorage 中。
    //         window.sessionStorage.setItem(customKey, defaultSessionId);
    //     }
    // } catch (err) { }
    return defaultSessionId;
};
var isWillClosed = false;
var Weblog$1 = /** @class */ (function (_super) {
    __extends(Weblog, _super);
    /**
     * @param {?object} logConfig Logger初始化配置
     * @param {object=} options 额外配置参数
     *                    - base 公参的覆盖
     */
    function Weblog(logConfig, base) {
        var _this = _super.call(this) || this;
        _this.version = '3.8.21';
        _this.yoda = null;
        _this.SampledPageMap = {};
        // 核心日志发送
        _this.logger = new BatchLog();
        // 插件
        _this.plugins = {};
        _this.flush = function () {
            _this.logger.flush();
        };
        _this.beforeUnload = function (event) {
            if (isWillClosed)
                return;
            _this.logger.drain();
            for (var key in _this.plugins) {
                var plugin = _this.plugins[key];
                if (typeof plugin.beforeUnload === 'function') {
                    plugin.beforeUnload(event);
                }
            }
            isWillClosed = true;
            setTimeout(function () {
                isWillClosed = false;
            }, 2000);
        };
        // 设置全局 session_id
        updateConfig('sessionId', base && base.session_id || getSessionId());
        _this.baseOption = _assign(_assign({}, BASE), base);
        _this.logConfig = initConfig(logConfig);
        _this.initUrlPackage();
        // 构建 common_package 信息
        _this.commomPackage = transformCommonPackage(_this.baseOption, _this.logConfig);
        _this.logger.init(_this.logConfig, _this.commomPackage);
        _this.initYoda();
        _this.addPlugins();
        if (typeof _this.initBuildInPlugins === 'function') {
            _this.initBuildInPlugins();
        }
        // 事件绑定
        if (typeof window !== 'undefined') {
            addMonitor(window, 'pagehide', _this.beforeUnload);
            addMonitor(window, 'beforeunload', _this.beforeUnload);
        }
        return _this;
    }
    Object.defineProperty(Weblog.prototype, "Utils", {
        get: function () {
            return {
                yoda: this.yoda && yodaUtils,
                cookie: cookieUtils,
                ua: uaUtils,
                io: {
                    sendData: sendData,
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weblog.prototype, "sessionId", {
        get: function () {
            return GlobalConfig.sessionId;
        },
        enumerable: false,
        configurable: true
    });
    Weblog.prototype.initYoda = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.logConfig.yoda && !this.yoda) {
                            this.yoda = checkYoda(this.logConfig.yoda);
                        }
                        _a = this.yoda;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, initYoda()];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        getKSwitchSampling().then(function () {
                            // yoda 初始化后更新采样配置
                            if (_this.currentUrlPackage)
                                _this.currentUrlPackage.sampled = _this.getPageSampled();
                        });
                        this.commomPackage.initYodaDeviceInfo();
                        this.commomPackage.initYodaAppInfo();
                        return [2 /*return*/];
                }
            });
        });
    };
    // tslint:disable-next-line:no-empty
    Weblog.prototype.initBuildInPlugins = function (option) { };
    // 初始化 url 信息
    Weblog.prototype.initUrlPackage = function () {
        // 初始化 url 信息
        this.updateCurrentUrlPackage();
        var referer = this.logConfig.referer;
        var referUrl = '';
        var referType = 'web';
        if (referer) {
            referUrl = referer.value;
            referType = referer.type && referer.type || referType;
        }
        else if (typeof document !== 'undefined' && document.referrer) {
            referUrl = document.referrer;
        }
        if (referUrl) {
            this.referUrlPackage = new UrlPackage(referUrl, referType, this.logConfig.urlMap);
        }
    };
    Object.defineProperty(Weblog.prototype, "isKSwitchSampled", {
        /**
         * 是否已获取到 kswitch 采样配置
         */
        get: function () {
            return typeof KSwitchSampling !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 获取页面级配置
     */
    Weblog.prototype.getPageSampled = function () {
        // 如果不是 yoda 环境，或者没从 kswitch 中获取到采样结果
        if (!this.yoda || !KSwitchSampling) {
            return typeof GlobalConfig.sampled === 'boolean' ? GlobalConfig.sampled : true;
        }
        var currentUrl = typeof location !== 'undefined' ? location.href.replace(/https?:\/\//, '').split('?')[0] : '*';
        if (typeof this.SampledPageMap[currentUrl] !== 'undefined') {
            return this.SampledPageMap[currentUrl];
        }
        if (KSwitchSampling) {
            var matchedOverAll = void 0;
            var level = 0;
            var radar_1 = null;
            var radarConfigs = [];
            // 找出当前页面的采样配置
            for (var path in KSwitchSampling) {
                if (KSwitchSampling.hasOwnProperty(path)) {
                    var curLevel = 0;
                    if (path === '*') {
                        // * 权重为 1
                        curLevel = 1;
                    }
                    else if (currentUrl.indexOf(path) === 0) {
                        if (path === currentUrl) {
                            // 相等的权重为 100
                            curLevel = 100;
                        }
                        else if (path[path.length - 1] === '/') {
                            // 包含的权重为 10
                            curLevel = 10 + 1 - 1 / path.length;
                        }
                    }
                    if (!curLevel)
                        continue;
                    var _a = KSwitchSampling[path], radar_2 = _a.radar, overwrite = _a.overwrite, overall = _a.overall;
                    curLevel = curLevel + (overwrite ? 1000 : 0);
                    if (radar_2) {
                        radarConfigs.push({
                            radar: radar_2,
                            level: curLevel,
                        });
                    }
                    if (curLevel > level) {
                        level = curLevel;
                        matchedOverAll = overall;
                    }
                }
            }
            // 先判定整体采样
            if (level) {
                radar_1 = {};
                radarConfigs.sort(function (r1, r2) { return r1.level - r2.level; }).forEach(function (r) {
                    Object.assign(radar_1, r.radar);
                });
            }
            var sampled = void 0;
            // 有 overwrite 或业务方没有配置采样时，使用 kswitch 采样配置
            if (level > 1000 || typeof GlobalConfig.sampled === 'undefined') {
                sampled = Math.random() < Number(matchedOverAll) && (radar_1 ? { radar: radar_1 } : true);
            }
            else {
                sampled = typeof GlobalConfig.sampled === 'boolean' ? GlobalConfig.sampled : true;
            }
            this.SampledPageMap[currentUrl] = sampled;
        }
        return this.SampledPageMap[currentUrl];
    };
    Object.defineProperty(Weblog.prototype, "currentUrl", {
        get: function () {
            var _a = this.currentUrlPackage, page = _a.page, params = _a.params;
            return params && typeof params === 'object'
                ? page + "?" + stringifyQuery(params)
                : page;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weblog.prototype, "referUrl", {
        get: function () {
            if (!this.referUrlPackage) {
                return '';
            }
            var _a = this.referUrlPackage, page = _a.page, params = _a.params;
            return params && typeof params === 'object'
                ? page + "?" + stringifyQuery(params)
                : page;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 更新当前 url 信息
     * @param url
     * @param type
     */
    Weblog.prototype.updateCurrentUrlPackage = function (url, type) {
        if (url === void 0) { url = typeof location !== 'undefined' ? location.href : ''; }
        if (type === void 0) { type = 'web'; }
        // 该接口不改变 refer 信息
        // this.referUrlPackage = this.currentUrlPackage;
        if (typeof url === 'object' && url.page) {
            if (this.currentUrlPackage && url.page === this.currentUrlPackage.page) {
                return this.currentUrlPackage.update(url.page, url.params);
            }
        }
        this.currentUrlPackage = new UrlPackage(url, type, this.logConfig.urlMap);
        this.currentUrlPackage.sampled = this.getPageSampled();
    };
    /**
     * 更新 refer url 信息
     * @param url
     * @param type
     */
    Weblog.prototype.updateReferUrlPackage = function (url, type) {
        if (url === void 0) { url = this.currentUrlPackage; }
        if (type === void 0) { type = 'web'; }
        if (url instanceof UrlPackage) {
            this.referUrlPackage = url;
        }
        else {
            this.referUrlPackage = new UrlPackage(url, type, this.logConfig.urlMap);
        }
    };
    /**
     * 重设 common_package 信息
     * @param base
     */
    Weblog.prototype.updateBase = function (base) {
        this.logger.updateBase(transformCommonPackage(_assign(_assign({}, this.baseOption), base), this.logConfig));
    };
    /**
     * 更新现有 common_package 信息
     */
    Weblog.prototype.updateCommonPackage = function (options) {
        if (typeof options !== 'object')
            return;
        if (!this.commomPackage)
            return;
        this.commomPackage.update(options);
    };
    /**
     * 初始化插件
     * @param plugins
     */
    Weblog.prototype.addPlugins = function () {
        var _this = this;
        if (!this.logConfig.plugins || !this.logConfig.plugins.length)
            return;
        // 类似 webpack plugins 的实例数组
        this.logConfig.plugins.forEach(function (plugin) {
            if (typeof plugin === 'object' && typeof plugin.apply === 'function') {
                _this.addPluginInstance(plugin);
            }
        });
    };
    /**
     * 加载插件实例
     */
    Weblog.prototype.addPluginInstance = function (pluginInstance) {
        if (pluginInstance) {
            var key = pluginInstance.key || pluginInstance.constructor && pluginInstance.constructor.key || "plugin_auto_key_" + pluginIndex++;
            if (typeof pluginInstance.apply === 'function'
                && (!pluginInstance.weblog || pluginInstance.weblog !== this)) {
                pluginInstance.apply(this);
            }
            this.plugins[key] = pluginInstance;
        }
    };
    /**
     * 加载插件构造函数
     * @param plugin
     * @param pluginOptions
     */
    Weblog.prototype.plug = function (plugin, pluginOptions) {
        if (this.plugins[plugin.key]) {
            throw new Error("There is a duplex plugin called " + plugin.key);
        }
        this.addPluginInstance(new plugin(this, pluginOptions));
    };
    Weblog.prototype.unplug = function (name) {
        var plugin = this.plugins[name];
        if (plugin) {
            plugin.destroy();
            delete this.plugins[name];
        }
    };
    Weblog.prototype.unplugAll = function () {
        for (var key in this.plugins) {
            if (this.plugins[key]) {
                this.unplug(key);
            }
        }
    };
    Weblog.prototype.generateLog = function (type, name, params, contentPackage, factory) {
        var _this = this;
        if (type === void 0) { type = TaskOperations.CLICK; }
        if (factory === void 0) { factory = logFactory; }
        if (typeof type !== 'string') {
            type = type.type;
        }
        type = type.toUpperCase();
        var generateLogName = name;
        var getCommonProps = function (name) {
            var currentUrlPackage = null;
            if (typeof generateLogName === 'object') {
                currentUrlPackage = generateLogName.currentUrlPackage;
                contentPackage =
                    generateLogName.contentPackage
                        || contentPackage;
            }
            if (currentUrlPackage) {
                var page = currentUrlPackage.page, identity = currentUrlPackage.identity, params_1 = currentUrlPackage.params;
                currentUrlPackage = {
                    identity: identity || uuid(page || ''),
                    page: page,
                    params: typeof params_1 === 'object' ? JSON.stringify(params_1) : params_1,
                };
            }
            else {
                currentUrlPackage = _this.currentUrlPackage.toJSON();
            }
            if (contentPackage) {
                contentPackage = typeof contentPackage === 'string' ? contentPackage : JSON.stringify(contentPackage);
            }
            return {
                name: name,
                // 传入的 url_package 信息不应该是可变的对象，会导致延时的 log page 信息变更
                currentUrlPackage: currentUrlPackage,
                referUrlPackage: _this.referUrlPackage ? _this.referUrlPackage.toJSON() : undefined,
                contentPackage: contentPackage,
            };
        };
        if (typeof name === 'object') {
            if (type === 'PV') {
                // PV 类型
                var _a = name, type_1 = _a.type, page = _a.page, pageParams = _a.params;
                this.currentUrlPackage.update(page, pageParams);
                return factory(EventTypes.PV, _assign(_assign(_assign({}, name), { type: type_1 }), getCommonProps('PV')));
            }
            // 如果参数中带有 urlPage 则更新 page 信息
            var urlPage = name.urlPage;
            urlPage && this.currentUrlPackage.update(urlPage.page);
            if (type === EventTypes.SHOW) {
                // SHOW 类型
                var action_1 = name.action;
                return factory(type, _assign(_assign({}, name), getCommonProps(action_1)));
            }
            // Radar 日志特殊处理
            if (type === 'RADAR') {
                return factory(type, name);
            }
            if (type === EventTypes.CUSTOM) {
                // CUSTOM 类型
                var _b = name, key = _b.key, value = _b.value, eventId_1 = _b.eventId;
                return factory(type, _assign({ params: value, eventId: eventId_1 }, getCommonProps(key)));
            }
            if (type === 'VIDEO') {
                return factory(type, _assign({ params: name }, getCommonProps('video')));
            }
            // TASK 类型
            var _c = name, action = _c.action, taskParams = _c.params, status_1 = _c.status, taskType = _c.type, eventId = _c.eventId;
            return factory(type, _assign(_assign(_assign({}, name), { params: taskParams, status: status_1,
                taskType: taskType,
                eventId: eventId }), getCommonProps(action)));
        }
        if (type === 'PV') {
            this.currentUrlPackage.update(name, params);
        }
        return factory(type, _assign({ params: params }, getCommonProps(name)));
    };
    Object.defineProperty(Weblog.prototype, "isSendSampled", {
        get: function () {
            return this.currentUrlPackage && this.currentUrlPackage.sampled || GlobalConfig.isDebug;
        },
        enumerable: false,
        configurable: true
    });
    Weblog.prototype.send = function (type, name, params, contentPackage, immediately) {
        if (type === void 0) { type = TaskOperations.CLICK; }
        // 如果该用户不被采样，则所有日志都不会上报
        if (!this.isSendSampled) {
            return;
        }
        var log = this.generateLog(type, name, params, contentPackage);
        // 雷达日志单独处理
        if (type === 'RADAR') {
            return this.logger.sendRadar(log);
        }
        if (type === 'PV') {
            if (GlobalConfig.isV2) {
                // 对于上报到v2，page为url的埋点，给予警告
                pageUrlWarnForV2(this.currentUrlPackage.page);
            }
        }
        var callback = typeof name === 'object' && name.callback || undefined;
        return this.logger.send(log, !!immediately, callback);
    };
    Weblog.prototype.collect = function (type, name, params, contentPackage) {
        if (type === void 0) { type = TaskOperations.CLICK; }
        return this.send(type, name, params, contentPackage, false);
    };
    Weblog.prototype.sendImmediately = function (type, name, params, contentPackage) {
        if (type === void 0) { type = TaskOperations.CLICK; }
        return this.send(type, name, params, contentPackage, true);
    };
    Weblog.prototype.sendPackage = function (data, callback) {
        this.logger.sendPackage(data, callback);
    };
    Weblog.prototype.destroy = function () {
        this.unplugAll();
        if (typeof window !== 'undefined') {
            removeMonitor(window, 'pagehide', this.beforeUnload);
            removeMonitor(window, 'beforeunload', this.beforeUnload);
        }
    };
    return Weblog;
}(EventEmitter));

var BasePlugin = /** @class */ (function (_super) {
    __extends(BasePlugin, _super);
    function BasePlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // @ts-ignore
        _this.weblog = typeof window !== 'undefined' && window._GLOBAL_KS_WEBLOGGER_ && window._GLOBAL_KS_WEBLOGGER_.weblog;
        return _this;
    }
    BasePlugin.prototype.apply = function (weblog) {
        this.weblog = weblog;
    };
    return BasePlugin;
}(EventEmitter));
/**
 * 在 bootstrap 环境下自动注册插件
 * @param Plugin
 * @param optionKey
 */
var autoRegister = function (Plugin, optionKey, PluginPlaceholder) {
    if (typeof window === 'undefined' ||
        typeof window._GLOBAL_KS_WEBLOGGER_ === 'undefined' ||
        typeof Plugin !== 'function')
        return;
    var _a = window._GLOBAL_KS_WEBLOGGER_, weblog = _a.weblog, config = _a.config;
    var option = optionKey && config.plugins[optionKey] ? config.plugins[optionKey].options : undefined;
    if (optionKey === 'radar') {
        // 雷达插件采样特殊处理
        var radarOptions = option || weblog.logConfig[optionKey];
        if (!radarOptions)
            return;
        if (!radarOptions.sampling || !Plugin.samplingControl(radarOptions)) {
            return weblog.plug(PluginPlaceholder);
        }
    }
    weblog.addPluginInstance(new Plugin(option));
};

/**
 * @file crash-monitor.js
 * @author kevin (lanlazy@163.com)
 * beforeunload触发条件:正常关闭标签,刷新,关闭浏览器
 * @created 2018-08-08
 */
var defaultOptions$1 = {
    updateInterval: 20 * 1000,
    crashThreshold: 10 * 1000,
};
var CrashMonitor = /** @class */ (function (_super) {
    __extends(CrashMonitor, _super);
    /**
     * 兼容写法，如果在 Weblog 初始化设置 plugins 时，不需要设置 weblog
     * @param weblog
     */
    function CrashMonitor(weblog) {
        var _this = _super.call(this) || this;
        _this.eventName = 'onpagehide' in window ? 'pagehide' : 'beforeunload';
        _this.options = _assign({}, defaultOptions$1);
        _this.monitorId = '@ks.monitor.crash_' + origin;
        _this.historyMoniorInfo = null;
        /**
         * 停止监控过程
         * 1.在页面正常卸载时自动调用
         * 2.需要手动卸载时手动调用
         */
        _this.stop = function () {
            clearInterval(_this.updateIntervalId);
            try {
                localStorage.removeItem(_this.monitorId);
            }
            catch (e) {
                // nothing
            }
        };
        try {
            var historyMoniorString = localStorage.getItem(_this.monitorId);
            _this.historyMoniorInfo = JSON.parse(historyMoniorString) || {};
        }
        catch (e) {
            // nothing
        }
        if (weblog && weblog.logger) {
            _this.apply(weblog);
        }
        addMonitor(window, _this.eventName, _this.stop);
        return _this;
    }
    CrashMonitor.prototype.apply = function (weblog) {
        var _this = this;
        if (!weblog)
            return;
        this.weblog = weblog;
        this.on('crash', function (info) {
            _this.weblog.sendImmediately('CUSTOM', 'crash', info);
        });
        this.start();
    };
    CrashMonitor.prototype.destroy = function () {
        this.stop();
        this.off('crash');
        removeMonitor(window, this.eventName, this.stop);
    };
    CrashMonitor.prototype.checkHistoryCrash = function () {
        var now = new Date().valueOf();
        if (this.historyMoniorInfo
            && this.historyMoniorInfo.time
            && now - this.historyMoniorInfo.time > this.options.crashThreshold) {
            this.emit('crash', this.historyMoniorInfo);
        }
    };
    /**
     * 开始定时更新快照
     */
    CrashMonitor.prototype.start = function () {
        var _this = this;
        this.checkHistoryCrash();
        this.updateIntervalId = window.setInterval(function () {
            _this.update();
        }, this.options.updateInterval);
        this.update();
    };
    /**
     * 更新监控快照
     * @param {*} data 外部追加额外的快照信息
     */
    CrashMonitor.prototype.update = function () {
        // TODO，非标准api后续可能会需要更新
        if (!window.performance || !window.performance.memory) {
            return;
        }
        // TODO后面看看需要补其他什么信息
        var monitorInfo = {
            time: new Date().valueOf(),
            memory: {
                limit: window.performance.memory.jsHeapSizeLimit / 1024,
                total: window.performance.memory.totalJSHeapSize / 1024,
                used: window.performance.memory.usedJSHeapSize / 1024,
            },
        };
        try {
            localStorage.setItem(this.monitorId, JSON.stringify(monitorInfo));
        }
        catch (e) {
            // nothing
        }
    };
    CrashMonitor.key = 'crachMonitor';
    return CrashMonitor;
}(BasePlugin));

/**
 * @file fps.js
 * @author kevin (lanlazy@163.com)
 * @created 2018-08-25
 */
var defaultOptions = {
    // 更新间隔
    interval: 10 * 1000,
    // 浮点精度 0 取整
    decimals: 2,
};
var FPSMonitor = /** @class */ (function (_super) {
    __extends(FPSMonitor, _super);
    function FPSMonitor(weblog, options) {
        var _this = _super.call(this) || this;
        _this.options = _assign({}, defaultOptions);
        _this.count = 0;
        if (options) ;
        else if (weblog) {
            if (weblog.logger) {
                _this.apply(weblog);
            }
        }
        Object.assign(_this.options, options);
        _this.on('performance', function (fps) {
            _this.weblog.collect('CUSTOM', 'fps', { fps: fps });
        });
        _this.start();
        return _this;
    }
    FPSMonitor.prototype.destroy = function () {
        this.off('performance');
        this.stop();
    };
    FPSMonitor.prototype.start = function () {
        this.loop();
        this.fpsTick();
    };
    FPSMonitor.prototype.fpsTick = function () {
        var _this = this;
        this.fpsTickId = raf(function () {
            _this.count++;
            _this.fpsTick();
        });
    };
    FPSMonitor.prototype.loop = function () {
        var _this = this;
        this.loopBeginTime = new Date().valueOf();
        this.loopId = window.setTimeout(function () {
            _this.loopEndTime = new Date().valueOf();
            var fps = _this.calculate();
            _this.emit('performance', fps);
            _this.count = 0;
            _this.loop();
        }, this.options.interval);
    };
    FPSMonitor.prototype.stop = function () {
        caf(this.fpsTickId);
        window.clearTimeout(this.loopId);
    };
    FPSMonitor.prototype.calculate = function () {
        var during = this.loopEndTime - this.loopBeginTime;
        // raf执行次数
        var runCount = during / this.count;
        return +(1000 / runCount).toFixed(this.options.decimals);
    };
    FPSMonitor.key = 'fpsMonitor';
    return FPSMonitor;
}(BasePlugin));

var perf = typeof window !== 'undefined'
    ? window.performance
    : null;
var performanceTiming = perf && perf.timing || null;
perf
    && perf.getEntriesByType
    && perf.getEntriesByType('navigation')[0]
    || null;

function warn(message) {
    if (console && console.warn) {
        console.warn(message);
    }
}
function error(message) {
    if (console && console.error) {
        console.error(message);
    }
}

// TODO页面停留时间先依赖一个全局副作用来搞，毕竟要侵入SPA模式下比较蛋疼……
var perfMap = {
    // DNS查找时间
    dnsLookup: {
        end: 'domainLookupEnd',
        start: 'domainLookupStart',
    },
    // TCP建连时间
    tcpConnection: {
        end: 'connectEnd',
        start: 'connectStart',
    },
    // 静态资源加载时间
    resourceLoad: {
        end: 'responseEnd',
        start: 'requestStart',
    },
    // 首屏JS耗时……暂时先这么对付了，具体JS的耗时后面再提供吧
    // 计算的时候以第一个script开始时间点为起始，一直到DOM Complete完成
    // 这样看起来应该是可被定义为JS耗时了……
    jsCost: {
        custom: function () {
            if (typeof performance.getEntries !== 'function') {
                return 0;
            }
            var entries = performance.getEntries();
            var pageTimeInfo = entries[0];
            var firstJSTimeInfo = entries
                .filter(function (item) { return item.initiatorType === 'script'; })[0];
            if (firstJSTimeInfo) {
                return pageTimeInfo.domComplete - firstJSTimeInfo.fetchStart;
            }
            return 0;
        },
    },
    // DOM加载完毕时间
    documentContentLoaded: {
        end: 'domComplete',
        start: 'fetchStart',
    },
    // 页面加载完毕时间
    load: {
        end: 'loadEventEnd',
        start: 'fetchStart',
    },
    timeToFirstByte: {
        end: 'loadEventEnd',
        start: 'fetchStart',
    },
    // 首屏时间，依靠主动打点
    firstScreen: {
        custom: function (key, options) {
            var endPoint = (options || {}).endPoint;
            var end = typeof endPoint !== 'undefined' ? endPoint : new Date().valueOf();
            return performanceTiming && (end - performanceTiming.fetchStart) || 0;
        },
    },
    // 白屏时间，依靠主动打点
    whiteScreen: {
        custom: function (key, options) {
            var endPoint = (options || {}).endPoint;
            var end = typeof endPoint !== 'undefined' ? endPoint : new Date().valueOf();
            return performanceTiming && (end - performanceTiming.fetchStart) || 0;
        },
    },
};
var TimingMonitor = /** @class */ (function (_super) {
    __extends(TimingMonitor, _super);
    /**
     * 兼容写法，如果在 Weblog 初始化设置 plugins 时，不需要设置 weblog
     * @param weblog
     */
    function TimingMonitor(weblog) {
        var _this = _super.call(this) || this;
        _this.load = function () {
            // 严格意义上来说类似的时间对于onload计算，都是等到window.onload执行完毕才开始计算
            // 所以页面加载完毕时间使用的是loadEventEnd事件，所以手动进入下一个event loop
            // 确保获取loadEventEnd事件
            setTimeout(function () {
                var perfInfo = _this.collect();
                if (!perfInfo) {
                    return;
                }
                [
                    'load',
                    'documentContentLoaded',
                    'dnsLookup',
                    'tcpConnection',
                    'jsCost',
                    'timeToFirstByte',
                ].forEach(function (key) {
                    var _a;
                    // TODO后面做一个支持度list来维护，现在先手动过滤一下
                    if (key === 'jsCost' && perfInfo[key] === 0) {
                        return;
                    }
                    _this.weblog.collect('CUSTOM', costMap[key], (_a = {},
                        _a[costMap[key]] = perfInfo[key],
                        _a));
                });
            });
        };
        if (!performanceTiming) {
            error('The Timing Monitor need performance APIs to Support!');
            return _this;
        }
        if (weblog) {
            _this.apply(weblog);
        }
        return _this;
    }
    TimingMonitor.prototype.apply = function (weblog) {
        var _this = this;
        this.weblog = weblog;
        addMonitor(window, 'load', this.load);
        this.on('perf', function (_a) {
            var _b;
            var key = _a.key, data = _a.data;
            _this.weblog.collect('CUSTOM', costMap[key], (_b = {},
                _b[costMap[key]] = data[key],
                _b));
        });
    };
    TimingMonitor.prototype.destroy = function () {
        removeMonitor(window, 'load', this.load);
        this.off('perf');
    };
    TimingMonitor.prototype.calculate = function (key, options) {
        var perf = perfMap[key];
        if (!perf) {
            throw new Error('The perf key is not correct!');
        }
        if (typeof perf.custom === 'function') {
            return perf.custom(key, options);
        }
        var endPoint = performanceTiming[perfMap[key].end];
        var startPoint = performanceTiming[perfMap[key].start];
        return endPoint - startPoint;
    };
    // 目前只针对这两个需要手动打点;
    TimingMonitor.prototype.mark = function (key, options) {
        var data = this.collect(key, options);
        this.emit('perf', {
            key: key,
            data: data,
        });
    };
    TimingMonitor.prototype.collect = function (key, options) {
        var _a;
        var _this = this;
        // 如果不支持timing api的话，就直接不上报了，免得数据污染
        if (!performanceTiming) {
            return;
        }
        if (key) {
            return _a = {},
                _a[key] = this.calculate(key, options),
                _a;
        }
        var allPerf = {};
        return Object.keys(perfMap).reduce(function (map, key) {
            map[key] = _this.calculate(key, options);
            return map;
        }, allPerf);
    };
    TimingMonitor.key = 'timingMonitor';
    return TimingMonitor;
}(BasePlugin));
// 优先使用pagehide 其次使用beforeunload;
var costMap = {
    load: 'total_download_cost',
    documentContentLoaded: 'operational_cost',
    dnsLookup: 'dns_query_cost',
    tcpConnection: 'tcp_cost',
    jsCost: 'js_cost',
    whiteScreen: 'white_screen_cost',
    firstScreen: 'first_screen_cost',
    timeToFirstByte: 'ttfb_cost',
};
/**
 * 如果使用了 bootstrap 则自动注册插件
 */
autoRegister(TimingMonitor);

// TODO下面这个暂时不能这么用，因为计量方式和perfirmanceTiming不一样
// export default performanceNavigationTiming || performanceTiming || null;
var navigationTiming = (function () {
    var perf = typeof window !== 'undefined'
        ? window.performance
        : null;
    if (perf && perf.timing) {
        if (typeof perf.timing.toJSON === 'function') {
            var performanceTiming = perf.timing.toJSON();
            if (performanceTiming && !performanceTiming.redirectStart) {
                performanceTiming.redirectStart = performanceTiming.navigationStart;
            }
            return performanceTiming;
        }
        return perf.timing;
    }
    return null;
});
function perfNow(time) {
    var perf = typeof window !== 'undefined'
        ? window.performance
        : null;
    if (!perf)
        return { value: null };
    // 用户传入时间戳则使用用户的传入
    if (time != null) {
        return {
            value: time - perf.timing.navigationStart,
            detail: {
                start: 'navigationStart',
                startPoint: perf.timing.navigationStart,
                end: 'customTime',
                endPoint: time,
            },
        };
    }
    if (typeof perf.now === 'function') {
        return {
            value: perf.now(),
            detail: {
                start: 'navigationStart',
                startPoint: perf.timing.navigationStart,
                end: 'perfNowAPI',
                endPoint: perf.now(),
            },
        };
    }
    var now = Date.now();
    return {
        value: now - perf.timing.navigationStart,
        detail: {
            start: 'navigationStart',
            startPoint: perf.timing.navigationStart,
            end: 'dateNow',
            endPoint: now,
        },
    };
}

// 统一的 custom_key
var KEY = 'radar_log';
var RADAR_KEY;
(function (RADAR_KEY) {
    // 页面加载监控
    RADAR_KEY["LOAD"] = "load";
    // 静态资源监控
    RADAR_KEY["RES"] = "resource";
    // API 性能监控
    RADAR_KEY["API"] = "api";
    // 异常
    RADAR_KEY["ERROR"] = "error";
    // 脚本自身上报异常
    RADAR_KEY["SDK_ERROR"] = "sdk_error";
    // 用户自定义性能监控
    RADAR_KEY["CUSTOM"] = "custom";
    // 批量日志，用于处理批量情况
    RADAR_KEY["BATCH"] = "batch";
    // 事件
    RADAR_KEY["EVENT"] = "event";
})(RADAR_KEY || (RADAR_KEY = {}));
var LEGACY_RADAR_KEY;
(function (LEGACY_RADAR_KEY) {
    // 页面加载监控
    LEGACY_RADAR_KEY["LOAD"] = "load_statistics";
    // 静态资源监控
    LEGACY_RADAR_KEY["RES"] = "resource_statistics";
    // API 性能监控
    LEGACY_RADAR_KEY["API"] = "api_statistics";
    // 异常
    LEGACY_RADAR_KEY["ERROR"] = "error_statistics";
    // 脚本自身上报异常
    LEGACY_RADAR_KEY["SDK_ERROR"] = "sdk_error";
    // 用户自定义性能监控
    LEGACY_RADAR_KEY["CUSTOM"] = "custom_statistics";
})(LEGACY_RADAR_KEY || (LEGACY_RADAR_KEY = {}));
var ERROR_KEY;
(function (ERROR_KEY) {
    // 脚本异常
    ERROR_KEY["SCRIPT"] = "script";
    // 资源加载异常
    ERROR_KEY["RES"] = "res";
    // 接口请求异常
    ERROR_KEY["API"] = "api";
    // 视频异常
    ERROR_KEY["VIDEO"] = "video";
})(ERROR_KEY || (ERROR_KEY = {}));
var domPerfMap = {
    redirect: {
        end: 'fetchStart',
        start: 'navigationStart',
    },
    // DNS查找时间
    dns: {
        end: 'domainLookupEnd',
        start: 'domainLookupStart',
    },
    dns_start: {
        end: 'domainLookupEnd',
        start: 'navigationStart',
    },
    // TCP建连时间
    tcp: {
        end: 'connectEnd',
        start: 'connectStart',
    },
    // TCP建连时间
    tcp_start: {
        end: 'connectEnd',
        start: 'navigationStart',
    },
    redirect_count: {
        custom: function (key, perf) {
            // @ts-ignore
            return perf.redirectCount;
        },
    },
    // ssl 安全连接耗时
    ssl: {
        // 有可能不是 https，导致这里上报异常
        custom: function (key, perf) {
            if (perf.secureConnectionStart === 0)
                return 0;
            return perf.connectEnd - perf.secureConnectionStart;
        },
    },
    ssl_start: {
        // 有可能不是 https，导致这里上报异常
        custom: function (key, perf) {
            if (perf.secureConnectionStart === 0)
                return 0;
            return perf.secureConnectionStart - perf.redirectStart;
        },
    },
    // 首字节事件，Time to First Byte
    ttfb: {
        end: 'responseStart',
        start: 'requestStart',
    },
    // 数据传输耗时
    trans: {
        end: 'responseEnd',
        start: 'responseStart',
    },
    // DOM 解析耗时
    dom_parse: {
        end: 'domInteractive',
        start: 'responseEnd',
    },
    dom_parse_start: {
        end: 'domInteractive',
        start: 'navigationStart',
    },
    // 白屏耗时
    // （(domInteractive || domLoading) - fetchStart）
    blank: {
        end: 'domLoading',
        start: 'navigationStart',
    },
    // 首字节
    fb: {
        end: 'responseStart',
        start: 'navigationStart',
    },
    // DOM-ready
    dom_ready: {
        end: 'domContentLoadedEventEnd',
        start: 'navigationStart',
    },
    // 完整 loading 时间
    total: {
        end: 'loadEventStart',
        start: 'navigationStart',
    },
    // 页面中的同步加载耗时
    resource: {
        end: 'loadEventStart',
        start: 'domContentLoadedEventEnd',
    },
    // 首次渲染，可以用 entries 里面的 first_paint
    fp: {
        custom: function () {
            if (typeof performance.getEntries !== 'function') {
                return null;
            }
            var entries = performance.getEntries();
            var firstPaintInfo = entries
                .filter(function (item) { return item.name === 'first-paint'; })[0];
            if (firstPaintInfo) {
                return Math.ceil(firstPaintInfo.startTime + firstPaintInfo.duration);
            }
            return null;
        },
    },
    // 首屏JS耗时……暂时先这么对付了，具体JS的耗时后面再提供吧
    // 计算的时候以第一个script开始时间点为起始，一直到DOM Complete完成
    // 这样看起来应该是可被定义为JS耗时了……
    js_cost: {
        custom: function () {
            if (typeof performance.getEntries !== 'function') {
                return null;
            }
            var timing = navigationTiming();
            var entries = performance.getEntries();
            var pageTimeInfo = performance.getEntries()
                .filter(function (item) { return item.initiatorType === 'navigation'; })[0];
            var firstJSTimeInfo = entries
                .filter(function (item) { return item.initiatorType === 'script'; })[0];
            // 有的浏览器 getEntries 里没有 navigation
            var domComplete = pageTimeInfo ? pageTimeInfo.domComplete :
                timing.domComplete - timing.navigationStart;
            if (firstJSTimeInfo && domComplete) {
                return domComplete - firstJSTimeInfo.fetchStart;
            }
            return null;
        },
    },
    // 可交互时间，这个不确定，粗略加个默认的，让用户可以自定义
    tti: {
        end: 'domInteractive',
        start: 'navigationStart',
    },
    // 这里 load performance 如果可以的话也能拿到
    protocol: {
        custom: function (key, perf) {
            return perf.nextHopProtocol;
        },
    },
    dom_num: {
        custom: function () {
            return typeof document !== 'undefined' ? document.all.length : null;
        }
    }
};
var apiPerfMap = {
    // fetchStart，记录资源的 fetchStart，记录其跟页面加载的偏移量
    fetch_start: {
        custom: function (key, perf) {
            return Math.round(perf.fetchStart);
        },
    },
    // DNS查找时间
    dns: {
        end: 'domainLookupEnd',
        start: 'domainLookupStart',
        cachedSkip: true,
    },
    // TCP建连时间
    tcp: {
        end: 'connectEnd',
        start: 'connectStart',
        cachedSkip: true,
    },
    // ssl 安全连接耗时
    ssl: {
        cachedSkip: true,
        // 有可能不是 https，导致这里上报异常
        custom: function (key, perf) {
            if (perf.secureConnectionStart === 0)
                return 0;
            return perf.connectEnd - perf.secureConnectionStart;
        },
    },
    // 首字节事件，Time to First Byte
    ttfb: {
        end: 'responseStart',
        start: 'requestStart',
        cachedSkip: true,
    },
    // 数据传输耗时
    trans: {
        end: 'responseEnd',
        start: 'responseStart',
        cachedSkip: true,
    },
    // 首字节
    fb: {
        end: 'responseStart',
        start: 'fetchStart',
        cachedSkip: true,
    },
    total: {
        end: 'responseEnd',
        start: 'fetchStart',
    },
    // 计算逻辑与total一致
    duration: {
        end: 'responseEnd',
        start: 'fetchStart',
    },
    // 体积
    size: {
        cachedSkip: true,
        custom: function (key, perf) {
            return perf.encodedBodySize;
        },
        noThrottle: true,
    },
    // 首次渲染，可以用 entries 里面的 first_paint
    protocol: {
        custom: function (key, perf) {
            return perf.nextHopProtocol;
        },
    },
    // file 静态资源地址
    file: {
        custom: function (key, perf) {
            return perf.name;
        },
        noThrottle: true,
    },
    res_type: {
        custom: function (key, perf) {
            return perf.initiatorType;
        },
    },
    // 是否缓存
    cached: {
        custom: function (key, perf) {
            if (perf.transferSize === 0)
                return true;
            // safari 没有实现 transferSize，因此用 domainLookupStart 来判断
            if (perf.transferSize == null && perf.domainLookupStart === 0)
                return true;
            return false;
        },
        noThrottle: true,
    }
};
var resPerfMap = {
    // fetchStart，记录资源的 fetchStart，记录其跟页面加载的偏移量
    fetch_start: {
        custom: function (key, perf) {
            return Math.round(perf.fetchStart);
        },
        noThrottle: true,
    },
    // DNS查找时间
    dns: {
        end: 'domainLookupEnd',
        start: 'domainLookupStart',
        cachedSkip: true,
    },
    // TCP建连时间
    tcp: {
        end: 'connectEnd',
        start: 'connectStart',
        cachedSkip: true,
    },
    // ssl 安全连接耗时
    ssl: {
        cachedSkip: true,
        // 有可能不是 https，导致这里上报异常
        custom: function (key, perf) {
            if (perf.secureConnectionStart === 0)
                return 0;
            return perf.connectEnd - perf.secureConnectionStart;
        },
    },
    // 首字节事件，Time to First Byte
    ttfb: {
        end: 'responseStart',
        start: 'requestStart',
        cachedSkip: true,
    },
    // 数据传输耗时
    trans: {
        end: 'responseEnd',
        start: 'responseStart',
        cachedSkip: true,
    },
    // 首字节
    fb: {
        end: 'responseStart',
        start: 'fetchStart',
        cachedSkip: true,
    },
    total: {
        end: 'responseEnd',
        start: 'fetchStart',
    },
    // 计算逻辑与total一致
    duration: {
        end: 'responseEnd',
        start: 'fetchStart',
    },
    // 体积
    size: {
        cachedSkip: true,
        custom: function (key, perf) {
            return perf.encodedBodySize;
        },
        noThrottle: true,
    },
    // 首次渲染，可以用 entries 里面的 first_paint
    protocol: {
        custom: function (key, perf) {
            return perf.nextHopProtocol;
        },
    },
    // file 静态资源地址
    file: {
        custom: function (key, perf) {
            return perf.name;
        },
        noThrottle: true,
    },
    res_type: {
        custom: function (key, perf) {
            return perf.initiatorType;
        },
    },
    // 是否缓存
    cached: {
        custom: function (key, perf) {
            if (perf.transferSize === 0)
                return true;
            // safari 没有实现 transferSize，因此用 domainLookupStart 来判断
            if (perf.transferSize == null && perf.domainLookupStart === 0)
                return true;
            return false;
        },
        noThrottle: true,
    }
};
var DEFAULT_IGNORE_LIST = [
    '//wlog.kuaishou.com/rest/n/log/web/collect',
    // v3
    '/rest/wd/common/log/collect/misc2',
    // v3 radar
    '/rest/wd/common/log/collect/radar',
    // v2
    '/rest/kd/log/collect',
];
// userStart: 1603074007776, // 外部传入打点WebView初始时间戳，比如调用JSBridge时间戳，客户端入口点击时间戳等。
// 	pageStart: 1603074007776, // Yoda收到任务的起始时间戳
// 	pageShow: 1603074007776, // Loading图显示时间
// 	preCreate: 1603074007776, // Yoda即将启动创建WebView实例的时间戳
// 	created: 1603074007776, // WebView对象创建完毕时间戳
// 	startLoad: 1603074007776, // WebView开始加载URL时间戳
// 	didStartLoad: 1603074007776, // WebView 加载URL后首个回调时间戳
// 	didEndLoad: 1603074007776, // WebView加载完毕时间戳
var webviewPerfMap = {
    to_webview_page_start: {
        end: 'pageStart',
        start: 'userStart',
    },
    to_webview_page_show: {
        end: 'pageShow',
        start: 'userStart',
    },
    to_webview_pre_create: {
        end: 'preCreate',
        start: 'userStart',
    },
    to_webview_created: {
        end: 'created',
        start: 'userStart',
    },
    to_webview_start_load: {
        end: 'startLoad',
        start: 'userStart',
    },
    to_webview_did_start_load: {
        end: 'didStartLoad',
        start: 'userStart',
    },
    to_webview_did_end_load: {
        end: 'didEndLoad',
        start: 'userStart',
    },
    to_navigation_start: {
        end: 'navigationStart',
        start: 'userStart',
    },
    to_fetch_start: {
        end: 'fetchStart',
        start: 'userStart',
    },
    to_connect_start: {
        end: 'connectStart',
        start: 'userStart',
    },
    to_dom_ready: {
        end: 'domContentLoadedEventEnd',
        start: 'userStart',
    },
    to_total: {
        end: 'loadEventStart',
        start: 'userStart',
    },
    to_fmp: {
        end: 'radarFmp',
        start: 'userStart'
    }
};
// load信息也需要上报时间戳了 这里提供一个rename的map
var loadTimestamp = {
    navigation_start_time: 'navigationStart',
    fetch_start_time: 'fetchStart',
    dns_start_time: 'domainLookupStart',
    dns_end_time: 'domainLookupEnd',
    connect_start_time: 'connect_start',
    ssl_start_time: 'secureConnectionStart',
    request_start_time: 'requestStart',
    response_start_time: 'responseStart',
    response_end_time: 'responseEnd',
    dom_interactive_time: 'domInteractive',
    dom_loading_time: 'domLoading',
    dom_ready_time: 'domContentLoadedEventEnd',
    load_event_time: 'loadEventStart',
    fmp_time: 'radarFmp'
};

/**
 * bridge实现方法
 */
var PAGELOG_API = 'sendRadarLog';

var t,
    n,
    e = function e() {
  return "".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12);
},
    i = function i(t) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1;
  return {
    name: t,
    value: n,
    delta: 0,
    entries: [],
    id: e(),
    isFinal: !1
  };
},
    a = function a(t, n) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(t)) {
      var e = new PerformanceObserver(function (t) {
        return t.getEntries().map(n);
      });
      return e.observe({
        type: t,
        buffered: !0
      }), e;
    }
  } catch (t) {}
},
    r = !1,
    o = !1,
    s = function s(t) {
  r = !t.persisted;
},
    u = function u() {
  addEventListener("pagehide", s), addEventListener("beforeunload", function () {});
},
    c = function c(t) {
  var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
  o || (u(), o = !0), addEventListener("visibilitychange", function (n) {
    var e = n.timeStamp;
    "hidden" === document.visibilityState && t({
      timeStamp: e,
      isUnloading: r
    });
  }, {
    capture: !0,
    once: n
  });
},
    l = function l(t, n, e, i) {
  var a;
  return function () {
    e && n.isFinal && e.disconnect(), n.value >= 0 && (i || n.isFinal || "hidden" === document.visibilityState) && (n.delta = n.value - (a || 0), (n.delta || n.isFinal || void 0 === a) && (t(n), a = n.value));
  };
},
    p = function p(t) {
  var n,
      e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
      r = i("CLS", 0),
      o = function o(t) {
    t.hadRecentInput || (r.value += t.value, r.entries.push(t), n());
  },
      s = a("layout-shift", o);

  s && (n = l(t, r, s, e), c(function (t) {
    var e = t.isUnloading;
    s.takeRecords().map(o), e && (r.isFinal = !0), n();
  }));
},
    d = function d() {
  return void 0 === t && (t = "hidden" === document.visibilityState ? 0 : 1 / 0, c(function (n) {
    var e = n.timeStamp;
    return t = e;
  }, !0)), {
    get timeStamp() {
      return t;
    }

  };
},
    f = function f(t) {
  var n = i("FID"),
      e = d(),
      r = function r(t) {
    t.startTime < e.timeStamp && (n.value = t.processingStart - t.startTime, n.entries.push(t), n.isFinal = !0, s());
  },
      o = a("first-input", r),
      s = l(t, n, o);

  o ? c(function () {
    o.takeRecords().map(r), o.disconnect();
  }, !0) : window.perfMetrics && window.perfMetrics.onFirstInputDelay && window.perfMetrics.onFirstInputDelay(function (t, i) {
    i.timeStamp < e.timeStamp && (n.value = t, n.isFinal = !0, n.entries = [{
      entryType: "first-input",
      name: i.type,
      target: i.target,
      cancelable: i.cancelable,
      startTime: i.timeStamp,
      processingStart: i.timeStamp + t
    }], s());
  });
},
    m = function m() {
  return n || (n = new Promise(function (t) {
    return ["scroll", "keydown", "pointerdown"].map(function (n) {
      addEventListener(n, t, {
        once: !0,
        passive: !0,
        capture: !0
      });
    });
  })), n;
},
    g = function g(t) {
  var n,
      e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
      r = i("LCP"),
      o = d(),
      s = function s(t) {
    var e = t.startTime;
    e < o.timeStamp ? (r.value = e, r.entries.push(t)) : r.isFinal = !0, n();
  },
      u = a("largest-contentful-paint", s);

  if (u) {
    n = l(t, r, u, e);

    var p = function p() {
      r.isFinal || (u.takeRecords().map(s), r.isFinal = !0, n());
    };

    m().then(p), c(p, !0);
  }
};

var reProtocol = /^(https?:)?\/\//;
function normalizeURL(ignoreList) {
    if (ignoreList === void 0) { ignoreList = []; }
    var list = ignoreList.concat(DEFAULT_IGNORE_LIST);
    // 把协议头剃掉，防止出现协议头不一致
    return list.map(function (url) { return url.replace(reProtocol, ''); });
}
function isInURLWhiteList(url, ignoreList) {
    if (!url)
        return false;
    var domainPath = url.replace(reProtocol, '');
    return ignoreList.some(function (whiteURL) {
        return domainPath.indexOf(whiteURL) >= 0;
    });
}
// 计算雷达自身耗时
var radarCost = {};
// 保留拓展能力
function radarPoint(name, open) {
    // if (!open) {
    //     // 默认关闭 需要业务方手动开启
    //     return
    // }
    var costName = radarCost[name];
    if (!costName) {
        radarCost[name] = { startTime: new Date().getTime() };
    }
    else if (!costName.endTime) {
        costName.endTime = new Date().getTime();
        costName.duration = costName.endTime - costName.startTime;
        delete costName.startTime;
        delete costName.endTime;
    }
}
/**
    * 收集chrome指标 比如lcp cls fid等
    * 会在unload事件里统一合并上报
    */
function collectChromeMetrics(opt) {
    Object.assign(chromeMetric, opt);
}
var chromeMetric = {};
var chromeMetricConfig = [
    { name: 'fid', collectFn: f },
    { name: 'lcp', collectFn: g },
    { name: 'cls', collectFn: p }
];
// 取消通过客户端注入脚本来收集错误
var removeBridgeJsErrorCollect = function () {
    if (typeof window !== 'undefined') {
        window.yodaCollectErrorDataDestroy && window.yodaCollectErrorDataDestroy();
    }
};
// 雷达通用debug函数
var radarWarnLog = function (type, value) {
    var query = parseQueryString(location.search.slice(1));
    if (+getCookie('debug') === 1 || +query.debug === 1) {
        console.warn("[radar] " + type + ": ", value);
    }
};
/**
 * @file 对 radar 的数据进行预处理
 */
function squashData(data) {
    var loadLog = null;
    var j = 0;
    var i = 0;
    // @ts-ignore
    for (; i < data.length; i++) {
        if (data[i].key === 'load') {
            loadLog = data[i];
        }
        else {
            data[j++] = data[i];
        }
    }
    data.length = j;
    return loadLog;
}
function formatYodaRadarData(options) {
    if (!options.value)
        return options;
    var params = options.value;
    // 过滤出最后一条load数据
    var loadLog = squashData(params.data);
    var commomParams = {
        project_id: params.project_id,
        app_version_name: params.app_version_name,
        url_package: params.url_package,
        // 统一传下划线格式
        h5_extra_attr: options.h5ExtraAttr,
    };
    return {
        loadLog: loadLog ? {
            removeStashedLog: [],
            sendImmediate: loadLog.dimension.sendImmediate,
            customData: _assign({ data: [loadLog] }, commomParams),
        } : null,
        commonLog: {
            removeStashedLog: [],
            sendImmediate: true,
            customData: _assign({ data: params.data }, commomParams),
        },
    };
}
var getUAList = function () {
    var ua = window.navigator.userAgent;
    var uaList = {};
    ua.split(' ').map(function (item) {
        var arr = item.split('/');
        uaList[arr[0]] = arr[1];
    });
    return uaList;
};
// 获取webview_type
var getWebViewType = function () {
    var ua = window.navigator.userAgent;
    if (ua.indexOf('Android') !== -1) {
        return 'WebView';
    }
    if (ua.indexOf('iPhone') !== -1) {
        var uaList = getUAList();
        if (uaList.Yoda && uaList.WebViewType === 'WK') {
            return 'YodaWKWebView';
        }
        if (!uaList.Yoda && uaList.WebView === 'WKWebView') {
            return 'WKWebView';
        }
        return 'UIWebView';
    }
    return '';
};
var formatLoadTime = function (timing, entry) {
    var res = {};
    Object.keys(entry).forEach(function (item) {
        if (timing[entry[item]] > 0) {
            res[item] = timing[entry[item]];
        }
    });
    return res;
};
// 判断是否在第四tab环境下
var check4Tab = function () {
    var ua = window.navigator.userAgent;
    // tbht不等于0
    var reg = /tbht\/([\w]+)/i;
    var res = ua.match(reg);
    return res && res[1] !== '0';
};
// 处理 DOM 路径，获取可读性强的列表
function composedPath(path) {
    // 兼容下低版本安卓机报错问题。。
    if (!Array.isArray(path))
        return '';
    var eleList = path.map(function (ele) {
        var _a = ele.tagName, tagName = _a === void 0 ? '' : _a, id = ele.id;
        // className在不同的dom中获取的方式不同
        var className = ele.getAttribute ?
            ele.getAttribute('class') :
            ele.className || '';
        var item = tagName.toLowerCase();
        if (id)
            item += "#" + id;
        if (className)
            item += className.split(/\s+/g).map(function (v) { return "." + v; }).join('');
        return item;
    });
    // window 取不出来，感觉意义不大，直接过滤掉吧
    return eleList.filter(function (v) { return v; }).join(',');
}

var KWAI_KPN = ['KUAISHOU', 'THANOS', 'NEBULA'];
var REPORT_THRESSHOLD = 60 * 1000;
var RadarRoot = /** @class */ (function (_super) {
    __extends(RadarRoot, _super);
    function RadarRoot(weblog, options) {
        var _this = _super.call(this) || this;
        _this.kpn = getDefaultKpn();
        _this.plugins = [];
        _this.logQueue = [];
        _this.queueConfig = {
            // 每1s清空一次queue
            wait: 1000,
            maxBatchLength: 200,
        };
        _this.eventName = 'onpagehide' in window ? 'pagehide' : 'beforeunload';
        _this.batchTimer = 0;
        _this.startedLoadReport = false;
        _this.radarSessionId = '';
        _this.chromeMetric = chromeMetricConfig;
        _this.isInKwai = KWAI_KPN.indexOf(_this.kpn) >= 0;
        _this.isUsingBridge = null;
        _this.isUsingLegacy = null;
        _this.isUsingDetachedReport = null;
        _this.isSupportedYodaConcat = null;
        _this.customDimension = {};
        // 默认忽略列表
        _this.ignoreList = ['https://web-trace.ksapisrv.com/ktrace/collect'];
        _this.lastRadarLogId = '';
        // 当初始化时没获取到kswitch数据时 为true 表示需要在flush时重新计算采样率
        _this.computedSamplingAgain = true;
        _this.realSampledList = [];
        _this.observeResource = function (perf) {
            perf.getEntriesByType('resource')
                .forEach(function (v) { return _this.reportPerformance(v); });
        };
        _this.asyncReportTiming = function () {
            // onload之后的调用会影响该时间戳
            radarPoint('radarCreatedToOnload');
            radarPoint('onloadToFirstReport');
            setTimeout(function () {
                // 雷达自身的时间戳 不受影响
                radarPoint('asyncReportTiming');
                _this.reportPerformance(navigationTiming());
                _this.startedLoadReport = true;
                try {
                    // 先上报一部分已经生成的 entries 数据
                    _this.observeResource(performance);
                    // 收集lcp等数据信息
                    _this.observeChromeMetrics(_this.chromeMetric);
                    new PerformanceObserver(_this.observeResource)
                        .observe({ entryTypes: ['resource'] });
                }
                catch (e) {
                    warn('[Radar] 由于不支持 Performance API Level 2，只进行请求监控和异常监控');
                }
                // 注册radar-第一次上报的时间
                // created-firstReport = async-report + register-1
                // new weblog之后 至 onload + unload 至 firstReport
                radarPoint('radarCreatedToFirstReport');
                radarPoint('onloadToFirstReport');
                radarPoint('asyncReportTiming');
            }, 1000); // 延迟一秒上报，确保不阻塞 fmp 和 total 等性能数据
        };
        _this.chromeMetricCallback = function (opt) {
            var _a, _b;
            var name = opt.name, value = opt.value;
            name = name.toLocaleLowerCase();
            _this.logCollect({
                key: RADAR_KEY.CUSTOM,
                value: (_a = {},
                    _a[name] = value,
                    _a)
            });
            radarPoint(name + "Collect");
            collectChromeMetrics((_b = {}, _b[name] = value, _b));
        };
        _this.observeChromeMetrics = function (arr) {
            // 默认配置几项可收集指标
            var options = _this.options;
            // 判断默认不主动上报，由业务进行配置
            arr.forEach(function (metric) {
                // 收集数据
                var name = metric.name;
                if (!options || options[name]) {
                    radarPoint(name + "Collect");
                    metric.collectFn(_this.chromeMetricCallback);
                }
            });
        };
        // 监听异步指标耗时上报情况，确保耗时数据完善
        // 通过unload事件上报
        _this.asyncMetricCollectDone = function () {
            // 格式 key:duration⬇️
            var radarCostResult = {};
            Object.keys(radarCost).forEach(function (radar) {
                var costItem = radarCost[radar];
                if (!costItem.duration && costItem.startTime) {
                    // 防止有部分指标在unload的时候未收集完毕，默认置0
                    costItem.duration = 0;
                    delete costItem.startTime;
                }
                radarCostResult[radar] = costItem.duration;
            });
            _this.logCollect({
                key: RADAR_KEY.CUSTOM,
                value: radarCostResult
            });
            _this.flush();
            _this.weblog.flush();
            // 上报完毕删除监听
            removeMonitor(window, _this.eventName, _this.asyncMetricCollectDone);
        };
        _this.flush = function () {
            _this.beforeFlush();
            if (!_this.options) {
                return;
            }
            if (_this.logQueue.length <= 0) {
                return;
            }
            // 初次上报之前都暂时存一下比较稳妥
            if (!_this.startedLoadReport) {
                return;
            }
            var h5_extra_attr = JSON.stringify(_assign(_assign({}, _this.weblog.commomPackage.getH5ExtraAttr()), { 
                // radar自定义新增非value字段可以加在这里
                // 获取客户端版本
                app_version_name: _this.weblog.commomPackage.getVersionName(), url: location.href }));
            // 判断端环境
            // 数据侧在业务设置了pagename的时候无法获取到真实的url，雷达这块重新写一次忽略pagename的逻辑比较复杂 故提供一个新的字段
            // radar_h5_extra_attr和radar_custom_extra_attr 共有字段app_version_name
            // 上报位置 custom_stat_event.value和h5_extra_attr
            var commonLogData = {
                project_id: _this.options.projectId,
                radar_session_id: _this.radarSessionId,
                h5_extra_attr: h5_extra_attr
            };
            var _a = _this.weblog.commomPackage, service_name = _a.service_name, sub_biz = _a.sub_biz, need_encrypt = _a.need_encrypt, app_package = _a.app_package;
            // @ts-ignore
            var currentUrlPackage = _this.currentUrlPackage && _this.currentUrlPackage.toJSON();
            // const key = this.isUsingLegacy ? LEGACY_KEY : KEY;
            // 尝试先直接桥接上报
            var sended = null;
            // 如果配置了优先http上报则不使用bridge上报数据
            if (!_this.options.httpReportFirst) {
                sended = _this.addRadarStatEvent({
                    key: KEY,
                    value: _assign(_assign({}, commonLogData), { data: _this.logQueue, 
                        // @ts-ignore
                        url_package: currentUrlPackage, app_version_name: app_package.version_name }),
                    serviceName: service_name || '',
                    subBiz: sub_biz || '',
                    needEncrypt: need_encrypt || false,
                    container: app_package.container,
                    realtime: false,
                    // 统一改成下划线格式
                    h5ExtraAttr: h5_extra_attr
                });
            }
            // 桥接上报失败使用 weblogger 自定义事件上报
            if (!sended || _this.options.httpReportFirst) {
                _this.weblog.collect('RADAR', {
                    name: KEY,
                    params: _assign(_assign({}, commonLogData), { data: _this.logQueue }),
                    currentUrlPackage: currentUrlPackage,
                    // @ts-ignore
                    referUrlPackage: _this.referUrlPackage && _this.referUrlPackage.toJSON(),
                });
            }
            _this.logQueue = [];
        };
        // 兼容处理
        var opts;
        if (options) {
            opts = options;
        }
        if (weblog) {
            if (weblog.logger) {
                _this.apply(weblog);
            }
            else {
                opts = weblog;
            }
        }
        radarPoint('radarCreatedToFirstReport');
        radarPoint('radarCreatedToOnload');
        _this.options = opts;
        _this.queueConfig = _assign(_assign({}, _this.queueConfig), (_this.options ? _this.options.queue : {}));
        // FIXME
        _this.ignoreList = _this.ignoreList.concat(normalizeURL(_this.options && _this.options.ignoreList));
        return _this;
    }
    Object.defineProperty(RadarRoot.prototype, "KSwitchSampled", {
        get: function () {
            // @ts-ignore
            return this.weblog.currentUrlPackage.sampled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RadarRoot.prototype, "isKSwitchSampled", {
        get: function () {
            // @ts-ignore
            return this.weblog.isKSwitchSampled;
        },
        enumerable: false,
        configurable: true
    });
    // 采样控制 迁移自radar.ts 子类重写该方法
    RadarRoot.prototype.samplingControl = function (options) {
        if (!options) {
            return false;
        }
        // 计算随机数
        var rand = Math.random();
        if (typeof options === 'number') {
            // 传入的是单一模块采样率 无需从options中取值
            return rand < options;
        }
        // radar整体采样率逻辑
        var sampling = options.sampling;
        return rand < sampling;
    };
    RadarRoot.prototype.use = function (plugin, ctx) {
        var usedPlugin = new plugin(ctx, this.options);
        this.plugins.push(usedPlugin);
        // 如果是旧式引用，use 是在 apply 之后调用。
        if (this.weblog) {
            usedPlugin.created();
        }
    };
    RadarRoot.prototype.apply = function (weblog) {
        this.weblog = weblog;
        this.upadteUrlPackage();
        this.register();
        this.ignoreList.push(this.weblog.logger.url);
        // 业务侧new Radar时 是不会传入weblog对象的 apply方法在weblogger插件内调用 并传入weblogger对象
        // 业务侧传入radar时，weblogger通过plug方法实例化radar并传入weblogger对象 此时由雷达自身调用apply方法
        // 结论：在调用apply方法时一定会存在weblogger对象
        this.created();
    };
    RadarRoot.prototype.created = function () {
        // 通过apply调用created，旧式引用时 plugins 为空
        this.plugins.forEach(function (plugin) {
            plugin.created();
        });
    };
    RadarRoot.prototype.destroy = function () {
        removeMonitor(window, 'load', this.asyncReportTiming);
        this.plugins.forEach(function (plugin) {
            plugin.destroy();
        });
    };
    RadarRoot.prototype.computedRealSampled = function (sampling, type) {
        // 请求kswitch后｜通过h5上报
        if (this.isKSwitchSampled) {
            var KSwitchSampling = void 0;
            if (typeof this.KSwitchSampled === 'object' && this.KSwitchSampled['radar']) {
                var allSample = this.KSwitchSampled['radar']['all'];
                allSample = typeof allSample !== 'number' ? 1 : allSample;
                var theSample = this.KSwitchSampled['radar'][type];
                // load等采样率和all是相乘关系
                KSwitchSampling = typeof theSample !== 'number' ? allSample : (theSample * allSample);
            }
            else {
                // if (typeof this.KSwitchSampled === 'boolean') 只有这两种情况
                KSwitchSampling = this.KSwitchSampled ? 1 : 0;
            }
            return KSwitchSampling * sampling;
        }
        else {
            return 1;
            // bridge没有返回 先按全量收集，flush的时候在重新检测
        }
    };
    /**
     * 通过 perf level 2 注册监听事件
     * 实际测试需要处理几个 case：
     * 1. 部分浏览器只支持 level 1
     * 2. 部分浏览器在 PerformanceObserver 时没有 navigation 事件
     */
    RadarRoot.prototype.register = function () {
        return __awaiter(this, void 0, void 0, function () {
            var yoda, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        // 不支持 level 1
                        if (!navigationTiming()) {
                            warn('[Radar] 由于不支持 Performance API，只进行请求监控和异常监控');
                            return [2 /*return*/];
                        }
                        // 鉴于部分浏览器虽然支持 level2，但 observer 时没有 navigation 事件
                        // 因此这里直接上报 level1 的数据（反正不需要高精度数据）
                        // remove js注入的 error事件 后续会通过radar收集上报
                        removeBridgeJsErrorCollect();
                        // 兼容业务在onload之后实例化雷达 所以手动调用一次上报方法
                        if (performance.timing.loadEventEnd > 0) {
                            this.asyncReportTiming();
                        }
                        else {
                            addMonitor(window, 'load', this.asyncReportTiming);
                        }
                        if (this.options && this.options.radarCost) {
                            // 默认不上报雷达自身耗时
                            addMonitor(window, this.eventName, this.asyncMetricCollectDone);
                        }
                        // beforeunload时清空当前logqueue
                        addMonitor(window, this.eventName, this.flush);
                        yoda = this.weblog.Utils.yoda;
                        if (!!yoda) return [3 /*break*/, 1];
                        this.isUsingBridge = false;
                        this.isSupportedYodaConcat = false;
                        this.isUsingLegacy = false;
                        return [3 /*break*/, 6];
                    case 1:
                        if (!(this.isUsingBridge == null)) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, yoda.isSupportBridge()];
                    case 2:
                        _a.isUsingBridge = _c.sent();
                        _c.label = 3;
                    case 3:
                        if (!(this.isSupportedYodaConcat == null)) return [3 /*break*/, 5];
                        _b = this;
                        return [4 /*yield*/, yoda.isSupportBridge(PAGELOG_API)];
                    case 4:
                        _b.isSupportedYodaConcat = _c.sent();
                        _c.label = 5;
                    case 5:
                        this.isUsingLegacy = this.isUsingBridge && !this.isSupportedYodaConcat;
                        _c.label = 6;
                    case 6:
                        //  生成唯一sessionid
                        this.radarSessionId = this.nanoId();
                        // 这里需要注意：在客户端内，而且不支持 bridge，或者支持 bridge 但不支持 yodaConcat
                        this.isUsingDetachedReport = (this.isInKwai && !this.isUsingBridge) || this.isUsingLegacy;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 处理上报超出阈值的情况
     */
    RadarRoot.prototype.throttle = function (value, perf, key, detail) {
        if (detail === void 0) { detail = {}; }
        if (perf.noThrottle || typeof value !== 'number')
            return value;
        var startPoint = detail.startPoint, endPoint = detail.endPoint;
        // 间隔超过一定阈值，认为上报的有问题，不上报并记录日志
        // NaN数据也算作一种异常情况 不上报
        // 雷达的异常数据采样10%
        if (value > REPORT_THRESSHOLD || value < 0 || isNaN(value)) {
            if ((Math.random() < 0.1)) {
                var msg = "[" + key + " \u5F02\u5E38]: " + value + "\uFF0C\u539F\u59CB\u6570\u636E\u4E3A\uFF1A" + perf.end + ": " + endPoint + " - " + perf.start + ": " + startPoint;
                this.logCollect({
                    key: RADAR_KEY.EVENT,
                    value: null,
                    dimension: {
                        name: '雷达数据异常',
                        event_type: 'radar_error',
                        message: msg,
                        src: location.href,
                        webViewType: getWebViewType(),
                        yoda_version: getUAList().yoda_version || '',
                    }
                });
            }
            return null;
        }
        return Math.round(value);
    };
    RadarRoot.prototype.reportPerformance = function (entry) {
        this.plugins.forEach(function (plugin) {
            if (!plugin.when(entry)) {
                return;
            }
            plugin.onPerfReport(entry);
        });
    };
    // 处理上报计算逻辑
    RadarRoot.prototype.calculate = function (key, perfMap, timing) {
        var perf = perfMap[key];
        if (!perf) {
            error("perf key " + key + " is unexpected!");
            return;
        }
        // 当资源有缓存时，好多数据为 0，不进行无意义的上报
        if (perf.cachedSkip) {
            var cached = this.calculate('cached', perfMap, timing);
            if (cached)
                return;
        }
        if (typeof perf.custom === 'function') {
            var value_1 = perf.custom(key, timing);
            return this.throttle(value_1, perf, key);
        }
        var end = perf.end, start = perf.start;
        // 由于webview数据上报的时候 不会带上performance.time导致timing['fmp']之类的数据为NaN无法计算
        //计算webview指标时 timing[end as keyof PerfTime] 可能为undefined 故兼容一下
        // @ts-ignore
        var endPoint = +timing[end] || performance.timing[end];
        // @ts-ignore
        var startPoint = +timing[start] || performance.timing[start];
        // console.log(`[info] ${key} –> ${end}: ${endPoint} - ${start}: ${startPoint} = ${endPoint - startPoint}`);
        var value = endPoint - startPoint;
        // 间隔超过一定阈值，认为上报的有问题，不上报并记录日志
        return this.throttle(value, perf, key, { startPoint: startPoint, endPoint: endPoint });
    };
    // FIXME
    RadarRoot.prototype.generateLog = function (perfMap, timing) {
        var _this = this;
        var allPerf = {};
        // 批量处理日志生成
        Object.keys(perfMap).forEach(function (k) {
            var key = k;
            var value = _this.calculate(key, perfMap, timing);
            // 可能存在一些值取不到的情况，取不到的话就不上报
            if (value != null) {
                // @ts-ignore
                allPerf[key] = value;
            }
        });
        return allPerf;
    };
    RadarRoot.prototype.subDimension = function (logData) {
        if (this.customDimension) {
            if (!logData.dimension) {
                logData.dimension = {};
            }
            Object.assign(logData.dimension, this.customDimension);
        }
    };
    /**
     * 生成nano id
     * 目前radarsessionid生成逻辑与weblog相同，防止weblog修改，雷达自身保存一份
     * @return {string} 16长度的字符串
     */
    RadarRoot.prototype.nanoId = function () {
        var ts = ((Math.random() * 1e9) >>> 0);
        var randomer = [];
        var seed = '0123456789ABCDEF';
        for (var i = 0; i < 7; i++) {
            randomer.push(seed.charAt(Math.random() * 16));
        }
        return ts + randomer.join('');
    };
    // flush上报之前重新探测一下采样率的问题
    RadarRoot.prototype.beforeFlush = function () {
        // 这里不关心weblogger的采样率
        var _this = this;
        if (this.computedSamplingAgain) {
            // 第一次flush
            var samplingList_1 = {
                radarLoadSampling: { sampling: 1, type: 'load' },
                radarApiSampling: { sampling: this.options && this.options.apiSampling || 1, type: 'api' },
                radarErrorSampling: { sampling: this.options && this.options.errorSampling || 1, type: 'error' },
                radarResourceSampling: { sampling: this.options && this.options.resourceSampling || 0.1, type: 'resource' },
                radarCustomSampling: { sampling: this.options && this.options.customSampling || 1, type: 'custom' },
                radarEventSampling: { sampling: this.options && this.options.eventSampling || 1, type: 'event' },
            };
            this.realSampledList = [];
            Object.keys(samplingList_1).forEach(function (item) {
                // 计算出每个模块的采样率
                var sampling = _this.isKSwitchSampled ?
                    // 初始化的时候 kswitch没有返回且 flush时 发现kswitch有返回了 重新计算
                    // load默认为1 其他根据业务配置取值
                    _this.samplingControl(_this.computedRealSampled(samplingList_1[item]['sampling'], samplingList_1[item]['type']))
                    // 采样率为用户配置的采样率
                    : _this.samplingControl(samplingList_1[item]);
                if (sampling) {
                    _this.realSampledList.push(samplingList_1[item]['type']);
                }
            });
            if (this.isKSwitchSampled) {
                this.computedSamplingAgain = false;
            }
        }
        // 把没采样的数据从logqueue中洗出来。。。。。
        this.logQueue = this.logQueue.filter(function (log) { return _this.realSampledList.indexOf(log.key) !== -1; });
    };
    RadarRoot.prototype.upadteUrlPackage = function () {
        if (!this.weblog)
            return;
        this.computedSamplingAgain = true;
        // 通过 toJSON 确保 page 和 params 是日志产生时的信息
        // @ts-ignore
        this.currentUrlPackage = this.weblog.currentUrlPackage;
        // @ts-ignore
        this.referUrlPackage = this.weblog.referUrlPackage;
    };
    RadarRoot.prototype.decorateLog = function (kv) {
        if (!this.currentUrlPackage) {
            this.upadteUrlPackage();
        }
        if (this.customDimension) {
            this.subDimension(kv);
        }
        // if (this.isUsingLegacy) {
        //     // @ts-ignore
        //     kv.key = kv.key + '_statistics';
        // }
        // 由于 url 是日志公参，因此 url 发生变化时直接冲刷日志
        if (this.currentUrlPackage && this.currentUrlPackage.page !== this.weblog.currentUrlPackage.page) {
            this.flush();
            this.upadteUrlPackage();
        }
    };
    RadarRoot.prototype.logCollect = function (kv) {
        var _this = this;
        radarWarnLog('radarLog', kv);
        if (!this.options) {
            return;
        }
        // 不再防抖 改为节流
        // if (this.batchTimer) {
        //     clearTimeout(this.batchTimer);
        // }
        this.decorateLog(kv);
        window.dispatchEvent(new CustomEvent('get-radar-data', {
            detail: {
                kv: kv,
            },
        }));
        // 当已经收集到load数据时 不会继续push 防止同时收集到多条load数据 适用于bridge和http上报
        var needPush = true;
        if (kv.key === 'load') {
            for (var i = 0; i < this.logQueue.length; i++) {
                var item = this.logQueue[i];
                if (item.key === 'load') {
                    Object.assign(item, kv);
                    needPush = false;
                    break;
                }
            }
        }
        needPush && this.logQueue.push(kv);
        // 上报窗口期内 不再创建定时器 只压入队列
        // flush判断当前情况是否可上报 包括采样，空队列等情况
        if (this.batchTimer) {
            return;
        }
        if (this.logQueue.length > this.queueConfig.maxBatchLength) {
            this.flush();
            return;
        }
        // 每隔wait秒上报一次数据 并在pagehide时上报所有logqueue里的数据
        this.batchTimer = window.setTimeout(function () {
            _this.flush();
            clearTimeout(_this.batchTimer);
            _this.batchTimer = 0;
        }, this.queueConfig.wait);
    };
    RadarRoot.prototype.addRadarStatEvent = function (log) {
        var _this = this;
        try {
            var yoda = this.weblog.Utils.yoda;
            if (!yoda) {
                return false;
            }
            var _a = formatYodaRadarData(log), loadLog = _a.loadLog, commonLog = _a.commonLog;
            if (loadLog) {
                if (this.lastRadarLogId) {
                    loadLog.removeStashedLog = [this.lastRadarLogId];
                    // 如果报进来的是一条sendImmediate为true的数据 且在之前已经上报过一条 load数据
                    // 则需要覆盖掉上一条load 保证客户端在destory的时候只上报一次load数据
                    if (loadLog.sendImmediate) {
                        // 当本条load数据是sendImmediate = true时 清除上一条false的数据
                        var empytLoadData = {
                            removeStashedLog: [this.lastRadarLogId],
                            sendImmediate: false,
                            custom: { "": "" }
                        };
                        yoda.sendRadarLog(empytLoadData).then(function (res) {
                            if (res && res.logId) {
                                _this.lastRadarLogId = res.logId;
                            }
                        });
                    }
                }
                yoda.sendRadarLog(loadLog).then(function (res) {
                    if (res && res.logId) {
                        _this.lastRadarLogId = res.logId;
                    }
                });
            }
            if (commonLog) {
                yoda.sendRadarLog(commonLog);
            }
            return true;
        }
        catch (err) {
            return false;
        }
    };
    return RadarRoot;
}(BasePlugin));

/**
 * @file 对于每个 Plugin 的共性，使用一个抽象类来描述
 */
var RadarPlugin = /** @class */ (function () {
    function RadarPlugin(radar, options) {
        this.radar = radar;
        this.options = options;
    }
    return RadarPlugin;
}());

var Navigation = /** @class */ (function (_super) {
    __extends(Navigation, _super);
    function Navigation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.key = 'navigation';
        _this.eventName = 'onpagehide' in window ? 'pagehide' : 'beforeunload';
        _this.logData = {};
        _this.logSended = false;
        _this.saveWebviewEntry = {};
        _this.hasReportBase = false;
        _this.record = {
            fmp: false,
            base: false,
            webviewPerf: false
        };
        // 端外延迟2s的timeout
        _this.loadTimeout = null;
        // 按照苗老师处理页面离开行为的思路来进行页面性能上报
        _this.reportOnUnload = function (flush) {
            // 走 yoda 通道的不额外上报
            if (_this.logSended || _this.radar.isSupportedYodaConcat)
                return;
            _this.logSended = true;
            // FIXME: 上报差值，有点丑
            _this.reportFirstScreen(Object.assign(_this.logData, chromeMetric));
            _this.radar.logCollect(_this.data);
            if (flush !== 'noflash') {
                _this.radar.flush();
                _this.radar.weblog.flush();
            }
        };
        return _this;
    }
    Object.defineProperty(Navigation.prototype, "sendImmediate", {
        // 立即上报
        get: function () {
            return this.record.fmp && this.record.base && this.record.webviewPerf && !!check4Tab();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Navigation.prototype, "data", {
        get: function () {
            return this.sepDimension({
                key: RADAR_KEY.LOAD,
                value: this.logData,
            });
        },
        enumerable: false,
        configurable: true
    });
    Navigation.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    Navigation.prototype.when = function (entry) {
        // 接受 fmp/play_clicked/play_idr 三个自定义指标
        if (entry.custom) {
            var key = (entry.entry || {}).key;
            if (['fmp', 'play_clicked', 'play_idr', 'webViewPerf'].indexOf(key) > -1) {
                return true;
            }
            return false;
        }
        // 接受 level1 和 level2
        return !entry.entryType
            || entry.entryType === 'navigation';
    };
    Navigation.prototype.getWebviewLoadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var yoda, webviewPerf, _a, _b, userStart, pageStart;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.record.webviewPerf) {
                            // 禁止重复获取
                            return [2 /*return*/];
                        }
                        yoda = this.radar.weblog.Utils.yoda;
                        _a = yoda;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, yoda.getWebviewLoadPerf()];
                    case 1:
                        _a = (_c.sent());
                        _c.label = 2;
                    case 2:
                        webviewPerf = _a;
                        // 调用成功后更改状态 如果第一次调用失败 会在unload之前再调用一次
                        // 兼容旧版本客户端webviewPerf是一个空对象的问题
                        if (webviewPerf && webviewPerf.timeData) {
                            // 没有获取到就不上报
                            this.record.webviewPerf = true;
                            _b = webviewPerf.timeData, userStart = _b.userStart, pageStart = _b.pageStart;
                            if (!userStart) {
                                webviewPerf.timeData.userStart = pageStart;
                            }
                            this.onPerfReport({
                                custom: true,
                                entry: {
                                    key: 'webViewPerf',
                                    // 客户端返回数据为
                                    /**
                                      {
                                      result:number
                                      timeData:{string:number}
                                      }
                                     */
                                    value: webviewPerf.timeData,
                                },
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Navigation.prototype.onPerfReport = function (entry) {
        return __awaiter(this, void 0, void 0, function () {
            var data, key, value, renderTime, loadTime, webviewTiming, webviewEntry, webviewTiming, logData, loadTime;
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                if (entry.custom) {
                    data = entry.entry;
                    if (data) {
                        key = data.key, value = data.value;
                        renderTime = entry.renderTime;
                        if (key === 'fmp') {
                            //  fmp晚于load上报时 为了得到fmo_time数据 需要重新计算一次loadtime，随着fmp上报
                            performance.timing.radarFmp = renderTime;
                            this.record.fmp = true;
                            loadTime = formatLoadTime(performance.timing, loadTimestamp);
                            Object.assign(this.logData, (_a = {}, _a[key] = value, _a), loadTime);
                            this.getWebviewLoadData();
                            if (this.record.webviewPerf) {
                                webviewTiming = this.radar.generateLog(webviewPerfMap, this.saveWebviewEntry);
                                Object.assign(this.logData, webviewTiming);
                            }
                        }
                        if (key === 'webViewPerf') {
                            webviewEntry = data.value;
                            if (!webviewEntry) {
                                // 说明没有收集到webview指标
                                return [2 /*return*/];
                            }
                            this.saveWebviewEntry = webviewEntry;
                            webviewTiming = this.radar.generateLog(webviewPerfMap, webviewEntry);
                            Object.assign(this.logData, webviewTiming);
                        }
                    }
                }
                else {
                    logData = this.radar.generateLog(domPerfMap, entry);
                    loadTime = formatLoadTime(performance.timing, loadTimestamp);
                    // 无重复字段 不会覆盖
                    Object.assign(this.logData, logData, loadTime);
                    this.record.base = true;
                }
                // yoda 通道每次收到自定义数据都合并上报一次
                // yodaAlready用于兼容radar.bridge  使用非桥接上报版本优先通过桥接上报 如果fmp上报先于yodaready,需要在这里做一个兜底,否则会丢数据
                if (this.radar.isSupportedYodaConcat) {
                    /**
                     * 目前有三个位置可以调用此方法
                     * 1。onload事件
                     * 2。fmp上报
                     * 3. webviewPerf
                     * 端内分几种情况：
                     * 1. onload +webviewPerf = to_fmp为NaN 客户端侧上报为Null 清洗侧为0 其他正常
                     * 2. onload +fmp 不会上报to_fmp等字段  清洗侧为null
                     * 3. onload +fmp+webviewperf 正常上报
                     */
                    // 防止上报的fmp上报之后 yoda没有ready 所以每次上报都会调用一次 如果bridge之前调用成功过，则不会继续调用bridge
                    this.getWebviewLoadData();
                    this.radar.logCollect(this.data);
                }
                else if (this.radar.isUsingDetachedReport && this.record.webviewPerf && this.record.fmp && this.record.base) {
                    // 这里是为了覆盖客户端版本过低 对bridge支持不好的情况
                    // 端内对 unload 支持很差，先弄成三个信息都有就强制上报（可能无需上报webviewperf 由数据侧根据时间戳计算）
                    // 没有yoda 无法获取webview信息 
                    // 上报之前需要合并webviewtiming
                    this.reportOnUnload('noflash');
                }
                else if (this.record.fmp && this.record.base && !this.hasReportBase) {
                    // 端外有这两个数据就立即上报
                    // 这里应用于fmp先于load被收集的场景  或
                    // load被收集2s内收集到fmp的场景 此时hasReportBase为false
                    /**
                     * 端外有两种情况
                     * 1.fmp先于load
                     * 2.load先于fmp
                     */
                    clearTimeout(this.loadTimeout);
                    this.loadTimeout = null;
                    this.loadReport();
                }
                else if (!this.hasReportBase && this.record.base) {
                    // 端外收集到load数据后延迟2s上报等待fmp数据 
                    // 这里应用于load先于fmp被收集的场景
                    this.loadTimeout = setTimeout(function () {
                        _this.loadReport();
                        _this.hasReportBase = true;
                    }, 2000);
                }
                return [2 /*return*/];
            });
        });
    };
    Navigation.prototype.destroy = function () {
        clearTimeout(this.delay);
        removeMonitor(window, this.eventName, this.reportOnUnload);
    };
    Navigation.prototype.sepDimension = function (kv) {
        var key = kv.key;
        var _a = kv.value, protocol = _a.protocol, value = __rest(_a, ["protocol"]);
        var dimension = { protocol: protocol, sendImmediate: this.sendImmediate };
        return { key: key, value: value, dimension: dimension };
    };
    // FIXME：处理一下上报差值
    Navigation.prototype.reportFirstScreen = function (data) {
        if (data.play_clicked && data.play_idr) {
            var firstScreen = data.play_idr - data.play_clicked;
            if (firstScreen > 0 && firstScreen < 60000) {
                this.logData.play_first_screen = firstScreen;
            }
        }
    };
    // 强制上报当前收集到的数据
    Navigation.prototype.loadReport = function () {
        // 加入lcp数据
        Object.assign(this.logData, chromeMetric);
        this.radar.logCollect(this.data);
        this.radar.flush();
        this.radar.weblog.flush();
    };
    return Navigation;
}(RadarPlugin));

// const LOAD_REPORT_DELAY = 15 * 1000; // 加载上报日志
var Resource = /** @class */ (function (_super) {
    __extends(Resource, _super);
    function Resource() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.key = 'resource';
        // 劫持 window.addEventListener('error')
        _this.onResError = function (e) {
            var isScriptError = _this.isScriptError(e);
            if (!isScriptError) {
                // resource报错 需要遵循resource插件的采样逻辑
                // 非脚本报错
                _this.radar.logCollect(_this.sepDimension({
                    key: RADAR_KEY.RES,
                    value: {
                        failed: true,
                        file: e.target.src,
                        // cached: false,
                        // @ts-ignore
                        res_path: composedPath(e.path || (e.composedPath && e.composedPath())),
                    },
                }));
            }
        };
        return _this;
    }
    Resource.prototype.created = function () {
        // Nothing
        addMonitor(window, 'error', this.onResError, true);
    };
    Resource.prototype.when = function (entry) {
        if (isInURLWhiteList(entry.name, this.radar.ignoreList)) {
            return false;
        }
        // load 这里可以接受自定义指标
        return entry.entryType === 'resource' && (entry.initiatorType !== 'fetch' && entry.initiatorType !== 'xmlhttprequest');
    };
    // 劫持 window onerror
    Resource.prototype.isScriptError = function (e) {
        // 有 message 基本上认为是脚本异常了
        return e.message || e.lineno != null;
    };
    Resource.prototype.onPerfReport = function (entry) {
        var logData = this.radar.generateLog(resPerfMap, entry);
        this.radar.logCollect(this.sepDimension({
            key: RADAR_KEY.RES,
            value: logData,
        }));
    };
    Resource.prototype.destroy = function () {
        // Nothing
        removeMonitor(window, 'error', this.onResError, true);
    };
    Resource.prototype.sepDimension = function (kv) {
        var key = kv.key;
        var _a = kv.value, protocol = _a.protocol, file = _a.file, cached = _a.cached, res_path = _a.res_path, failed = _a.failed, res_type = _a.res_type, value = __rest(_a, ["protocol", "file", "cached", "res_path", "failed", "res_type"]);
        var dimension = { protocol: protocol, file: file, cached: cached, failed: failed, res_path: res_path, res_type: res_type };
        return { key: key, value: value, dimension: dimension };
    };
    return Resource;
}(RadarPlugin));

var xhook = createCommonjsModule(function (module) {
  // XHook - v1.4.9 - https://github.com/jpillora/xhook
  // Jaime Pillora <dev@jpillora.com> - MIT Copyright 2021
  (function (window, undefined$1) {
    var AFTER,
        BEFORE,
        COMMON_EVENTS,
        EventEmitter,
        FETCH,
        FIRE,
        FormData,
        NativeFetch,
        NativeFormData,
        NativeXMLHttp,
        OFF,
        ON,
        READY_STATE,
        UPLOAD_EVENTS,
        WINDOW,
        XHookFetchRequest,
        XHookFormData,
        XHookHttpRequest,
        XMLHTTP,
        convertHeaders,
        depricatedProp,
        document,
        fakeEvent,
        mergeObjects,
        msie,
        nullify,
        proxyEvents,
        slice,
        useragent,
        xhook,
        _base,
        __indexOf = [].indexOf || function (item) {
      for (var i = 0, l = this.length; i < l; i++) {
        if (i in this && this[i] === item) return i;
      }

      return -1;
    };

    WINDOW = null;

    if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope) {
      WINDOW = self;
    } else if (typeof commonjsGlobal !== 'undefined') {
      WINDOW = commonjsGlobal;
    } else {
      WINDOW = window;
    }

    document = WINDOW.document;
    BEFORE = 'before';
    AFTER = 'after';
    READY_STATE = 'readyState';
    ON = 'addEventListener';
    OFF = 'removeEventListener';
    FIRE = 'dispatchEvent';
    XMLHTTP = 'XMLHttpRequest';
    FETCH = 'fetch';
    FormData = 'FormData';
    UPLOAD_EVENTS = ['load', 'loadend', 'loadstart'];
    COMMON_EVENTS = ['progress', 'abort', 'error', 'timeout'];
    useragent = typeof navigator !== 'undefined' && navigator['useragent'] ? navigator.userAgent : '';
    msie = parseInt((/msie (\d+)/.exec(useragent.toLowerCase()) || [])[1]);

    if (isNaN(msie)) {
      msie = parseInt((/trident\/.*; rv:(\d+)/.exec(useragent.toLowerCase()) || [])[1]);
    }

    (_base = Array.prototype).indexOf || (_base.indexOf = function (item) {
      var i, x, _i, _len;

      for (i = _i = 0, _len = this.length; _i < _len; i = ++_i) {
        x = this[i];

        if (x === item) {
          return i;
        }
      }

      return -1;
    });

    slice = function slice(o, n) {
      return Array.prototype.slice.call(o, n);
    };

    depricatedProp = function depricatedProp(p) {
      return p === "returnValue" || p === "totalSize" || p === "position";
    };

    mergeObjects = function mergeObjects(src, dst) {
      var k;

      for (k in src) {
        src[k];

        if (depricatedProp(k)) {
          continue;
        }

        try {
          dst[k] = src[k];
        } catch (_error) {}
      }

      return dst;
    };

    nullify = function nullify(res) {
      if (res === void 0) {
        return null;
      }

      return res;
    };

    proxyEvents = function proxyEvents(events, src, dst) {
      var event, p, _i, _len;

      p = function p(event) {
        return function (e) {
          var clone, k, val;
          clone = {};

          for (k in e) {
            if (depricatedProp(k)) {
              continue;
            }

            val = e[k];
            clone[k] = val === src ? dst : val;
          }

          return dst[FIRE](event, clone);
        };
      };

      for (_i = 0, _len = events.length; _i < _len; _i++) {
        event = events[_i];

        if (dst._has(event)) {
          src["on" + event] = p(event);
        }
      }
    };

    fakeEvent = function fakeEvent(type) {
      var msieEventObject;

      if (document && document.createEventObject != null) {
        msieEventObject = document.createEventObject();
        msieEventObject.type = type;
        return msieEventObject;
      } else {
        try {
          return new Event(type);
        } catch (_error) {
          return {
            type: type
          };
        }
      }
    };

    EventEmitter = function EventEmitter(nodeStyle) {
      var emitter, events, listeners;
      events = {};

      listeners = function listeners(event) {
        return events[event] || [];
      };

      emitter = {};

      emitter[ON] = function (event, callback, i) {
        events[event] = listeners(event);

        if (events[event].indexOf(callback) >= 0) {
          return;
        }

        i = i === undefined$1 ? events[event].length : i;
        events[event].splice(i, 0, callback);
      };

      emitter[OFF] = function (event, callback) {
        var i;

        if (event === undefined$1) {
          events = {};
          return;
        }

        if (callback === undefined$1) {
          events[event] = [];
        }

        i = listeners(event).indexOf(callback);

        if (i === -1) {
          return;
        }

        listeners(event).splice(i, 1);
      };

      emitter[FIRE] = function () {
        var args, event, i, legacylistener, listener, _i, _len, _ref;

        args = slice(arguments);
        event = args.shift();

        if (!nodeStyle) {
          args[0] = mergeObjects(args[0], fakeEvent(event));
        }

        legacylistener = emitter["on" + event];

        if (legacylistener) {
          legacylistener.apply(emitter, args);
        }

        _ref = listeners(event).concat(listeners("*"));

        for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
          listener = _ref[i];
          listener.apply(emitter, args);
        }
      };

      emitter._has = function (event) {
        return !!(events[event] || emitter["on" + event]);
      };

      if (nodeStyle) {
        emitter.listeners = function (event) {
          return slice(listeners(event));
        };

        emitter.on = emitter[ON];
        emitter.off = emitter[OFF];
        emitter.fire = emitter[FIRE];

        emitter.once = function (e, fn) {
          var _fire;

          _fire = function fire() {
            emitter.off(e, _fire);
            return fn.apply(null, arguments);
          };

          return emitter.on(e, _fire);
        };

        emitter.destroy = function () {
          return events = {};
        };
      }

      return emitter;
    };

    xhook = EventEmitter(true);
    xhook.EventEmitter = EventEmitter;

    xhook[BEFORE] = function (handler, i) {
      if (handler.length < 1 || handler.length > 2) {
        throw "invalid hook";
      }

      return xhook[ON](BEFORE, handler, i);
    };

    xhook[AFTER] = function (handler, i) {
      if (handler.length < 2 || handler.length > 3) {
        throw "invalid hook";
      }

      return xhook[ON](AFTER, handler, i);
    };

    xhook.enable = function () {
      WINDOW[XMLHTTP] = XHookHttpRequest;

      if (typeof XHookFetchRequest === "function") {
        WINDOW[FETCH] = XHookFetchRequest;
      }

      if (NativeFormData) {
        WINDOW[FormData] = XHookFormData;
      }
    };

    xhook.disable = function () {
      WINDOW[XMLHTTP] = xhook[XMLHTTP];
      WINDOW[FETCH] = xhook[FETCH];

      if (NativeFormData) {
        WINDOW[FormData] = NativeFormData;
      }
    };

    convertHeaders = xhook.headers = function (h, dest) {
      var header, headers, k, name, v, value, _i, _len, _ref;

      if (dest == null) {
        dest = {};
      }

      switch (_typeof(h)) {
        case "object":
          headers = [];

          for (k in h) {
            v = h[k];
            name = k.toLowerCase();
            headers.push("" + name + ":\t" + v);
          }

          return headers.join('\n') + '\n';

        case "string":
          headers = h.split('\n');

          for (_i = 0, _len = headers.length; _i < _len; _i++) {
            header = headers[_i];

            if (/([^:]+):\s*(.+)/.test(header)) {
              name = (_ref = RegExp.$1) != null ? _ref.toLowerCase() : void 0;
              value = RegExp.$2;

              if (dest[name] == null) {
                dest[name] = value;
              }
            }
          }

          return dest;
      }
    };

    NativeFormData = WINDOW[FormData];

    XHookFormData = function XHookFormData(form) {
      var entries;
      this.fd = form ? new NativeFormData(form) : new NativeFormData();
      this.form = form;
      entries = [];
      Object.defineProperty(this, 'entries', {
        get: function get() {
          var fentries;
          fentries = !form ? [] : slice(form.querySelectorAll("input,select")).filter(function (e) {
            var _ref;

            return (_ref = e.type) !== 'checkbox' && _ref !== 'radio' || e.checked;
          }).map(function (e) {
            return [e.name, e.type === "file" ? e.files : e.value];
          });
          return fentries.concat(entries);
        }
      });

      this.append = function (_this) {
        return function () {
          var args;
          args = slice(arguments);
          entries.push(args);
          return _this.fd.append.apply(_this.fd, args);
        };
      }(this);
    };

    if (NativeFormData) {
      xhook[FormData] = NativeFormData;
      WINDOW[FormData] = XHookFormData;
    }

    NativeXMLHttp = WINDOW[XMLHTTP];
    xhook[XMLHTTP] = NativeXMLHttp;

    XHookHttpRequest = WINDOW[XMLHTTP] = function () {
      var ABORTED, currentState, emitFinal, emitReadyState, event, facade, hasError, hasErrorHandler, readBody, readHead, request, response, setReadyState, status, transiting, writeBody, writeHead, xhr, _i, _len, _ref;

      ABORTED = -1;
      xhr = new xhook[XMLHTTP]();
      request = {};
      status = null;
      hasError = void 0;
      transiting = void 0;
      response = void 0;

      readHead = function readHead() {
        var key, name, val, _ref;

        response.status = status || xhr.status;

        if (!(status === ABORTED && msie < 10)) {
          response.statusText = xhr.statusText;
        }

        if (status !== ABORTED) {
          _ref = convertHeaders(xhr.getAllResponseHeaders());

          for (key in _ref) {
            val = _ref[key];

            if (!response.headers[key]) {
              name = key.toLowerCase();
              response.headers[name] = val;
            }
          }
        }
      };

      readBody = function readBody() {
        if (!xhr.responseType || xhr.responseType === "text") {
          response.text = xhr.responseText;
          response.data = xhr.responseText;

          try {
            response.xml = xhr.responseXML;
          } catch (_error) {}
        } else if (xhr.responseType === "document") {
          response.xml = xhr.responseXML;
          response.data = xhr.responseXML;
        } else {
          response.data = xhr.response;
        }

        if ("responseURL" in xhr) {
          response.finalUrl = xhr.responseURL;
        }
      };

      writeHead = function writeHead() {
        facade.status = response.status;
        facade.statusText = response.statusText;
      };

      writeBody = function writeBody() {
        if ('text' in response) {
          facade.responseText = response.text;
        }

        if ('xml' in response) {
          facade.responseXML = response.xml;
        }

        if ('data' in response) {
          facade.response = response.data;
        }

        if ('finalUrl' in response) {
          facade.responseURL = response.finalUrl;
        }
      };

      emitReadyState = function emitReadyState(n, event) {
        while (n > currentState && currentState < 4) {
          facade[READY_STATE] = ++currentState;

          if (currentState === 1) {
            facade[FIRE]("loadstart", {});
          }

          if (currentState === 2) {
            writeHead();
          }

          if (currentState === 4) {
            writeHead();
            writeBody();
          }

          facade[FIRE]("readystatechange", event || {});

          if (currentState === 4) {
            if (request.async === false) {
              emitFinal();
            } else {
              setTimeout(emitFinal, 0);
            }
          }
        }
      };

      emitFinal = function emitFinal() {
        if (!hasError) {
          facade[FIRE]("load", {});
        }

        facade[FIRE]("loadend", {});

        if (hasError) {
          facade[READY_STATE] = 0;
        }
      };

      currentState = 0;

      setReadyState = function setReadyState(n, event) {
        var hooks, _process;

        if (n !== 4) {
          emitReadyState(n, event);
          return;
        }

        hooks = xhook.listeners(AFTER);

        _process = function process() {
          var hook;

          if (!hooks.length) {
            return emitReadyState(4, event);
          }

          hook = hooks.shift();

          if (hook.length === 2) {
            hook(request, response);
            return _process();
          } else if (hook.length === 3 && request.async) {
            return hook(request, response, _process);
          } else {
            return _process();
          }
        };

        _process();
      };

      facade = request.xhr = EventEmitter();

      xhr.onreadystatechange = function (event) {
        try {
          if (xhr[READY_STATE] === 2) {
            readHead();
          }
        } catch (_error) {}

        if (xhr[READY_STATE] === 4) {
          transiting = false;
          readHead();
          readBody();
        }

        setReadyState(xhr[READY_STATE], event);
      };

      hasErrorHandler = function hasErrorHandler() {
        hasError = true;
      };

      facade[ON]('error', hasErrorHandler);
      facade[ON]('timeout', hasErrorHandler);
      facade[ON]('abort', hasErrorHandler);
      facade[ON]('progress', function () {
        if (currentState < 3) {
          setReadyState(3);
        } else {
          facade[FIRE]("readystatechange", {});
        }
      });

      if ('withCredentials' in xhr || xhook.addWithCredentials) {
        facade.withCredentials = false;
      }

      facade.status = 0;
      _ref = COMMON_EVENTS.concat(UPLOAD_EVENTS);

      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        event = _ref[_i];
        facade["on" + event] = null;
      }

      facade.open = function (method, url, async, user, pass) {
        currentState = 0;
        hasError = false;
        transiting = false;
        request.headers = {};
        request.headerNames = {};
        request.status = 0;
        response = {};
        response.headers = {};
        request.method = method;
        request.url = url;
        request.async = async !== false;
        request.user = user;
        request.pass = pass;
        setReadyState(1);
      };

      facade.send = function (body) {
        var hooks, k, modk, _process2, send, _j, _len1, _ref1;

        _ref1 = ['type', 'timeout', 'withCredentials'];

        for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
          k = _ref1[_j];
          modk = k === "type" ? "responseType" : k;

          if (modk in facade) {
            request[k] = facade[modk];
          }
        }

        request.body = body;

        send = function send() {
          var header, value, _k, _len2, _ref2, _ref3;

          proxyEvents(COMMON_EVENTS, xhr, facade);

          if (facade.upload) {
            proxyEvents(COMMON_EVENTS.concat(UPLOAD_EVENTS), xhr.upload, facade.upload);
          }

          transiting = true;
          xhr.open(request.method, request.url, request.async, request.user, request.pass);
          _ref2 = ['type', 'timeout', 'withCredentials'];

          for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
            k = _ref2[_k];
            modk = k === "type" ? "responseType" : k;

            if (k in request) {
              xhr[modk] = request[k];
            }
          }

          _ref3 = request.headers;

          for (header in _ref3) {
            value = _ref3[header];

            if (header) {
              xhr.setRequestHeader(header, value);
            }
          }

          if (request.body instanceof XHookFormData) {
            request.body = request.body.fd;
          }

          xhr.send(request.body);
        };

        hooks = xhook.listeners(BEFORE);

        _process2 = function process() {
          var done, hook;

          if (!hooks.length) {
            return send();
          }

          done = function done(userResponse) {
            if (_typeof(userResponse) === 'object' && (typeof userResponse.status === 'number' || typeof response.status === 'number')) {
              mergeObjects(userResponse, response);

              if (__indexOf.call(userResponse, 'data') < 0) {
                userResponse.data = userResponse.response || userResponse.text;
              }

              setReadyState(4);
              return;
            }

            _process2();
          };

          done.head = function (userResponse) {
            mergeObjects(userResponse, response);
            return setReadyState(2);
          };

          done.progress = function (userResponse) {
            mergeObjects(userResponse, response);
            return setReadyState(3);
          };

          hook = hooks.shift();

          if (hook.length === 1) {
            return done(hook(request));
          } else if (hook.length === 2 && request.async) {
            return hook(request, done);
          } else {
            return done();
          }
        };

        _process2();
      };

      facade.abort = function () {
        status = ABORTED;

        if (transiting) {
          xhr.abort();
        } else {
          facade[FIRE]('abort', {});
        }
      };

      facade.setRequestHeader = function (header, value) {
        var lName, name;
        lName = header != null ? header.toLowerCase() : void 0;
        name = request.headerNames[lName] = request.headerNames[lName] || header;

        if (request.headers[name]) {
          value = request.headers[name] + ', ' + value;
        }

        request.headers[name] = value;
      };

      facade.getResponseHeader = function (header) {
        var name;
        name = header != null ? header.toLowerCase() : void 0;
        return nullify(response.headers[name]);
      };

      facade.getAllResponseHeaders = function () {
        return nullify(convertHeaders(response.headers));
      };

      if (xhr.overrideMimeType) {
        facade.overrideMimeType = function () {
          return xhr.overrideMimeType.apply(xhr, arguments);
        };
      }

      if (xhr.upload) {
        facade.upload = request.upload = EventEmitter();
      }

      facade.UNSENT = 0;
      facade.OPENED = 1;
      facade.HEADERS_RECEIVED = 2;
      facade.LOADING = 3;
      facade.DONE = 4;
      facade.response = '';
      facade.responseText = '';
      facade.responseXML = null;
      facade.readyState = 0;
      facade.statusText = '';
      return facade;
    };

    if (typeof WINDOW[FETCH] === "function") {
      NativeFetch = WINDOW[FETCH];
      xhook[FETCH] = NativeFetch;

      XHookFetchRequest = WINDOW[FETCH] = function (url, options) {
        var afterHooks, beforeHooks, i, originalOptions, request;

        if (options == null) {
          options = {
            headers: {}
          };
        }

        originalOptions = {};

        for (i in options) {
          originalOptions[i] = options[i];
        }

        options.url = url;
        request = null;

        if (url instanceof Request) {
          request = url;
          options.url = request.url;
          options.headers = request.headers;
        }

        beforeHooks = xhook.listeners(BEFORE);
        afterHooks = xhook.listeners(AFTER);
        return new Promise(function (resolve, reject) {
          var done, getRequest, _processAfter, processBefore, send;

          getRequest = function getRequest() {
            if (options.body instanceof XHookFormData) {
              options.body = options.body.fd;
            }

            if (options.headers) {
              options.headers = new Headers(options.headers);
            }

            if (!request) {
              request = new Request(options.url, options);
            }

            return mergeObjects(options, request);
          };

          _processAfter = function processAfter(response) {
            var hook;

            if (!afterHooks.length) {
              return resolve(response);
            }

            hook = afterHooks.shift();

            if (hook.length === 2) {
              hook(getRequest(), response);
              return _processAfter(response);
            } else if (hook.length === 3) {
              return hook(getRequest(), response, _processAfter);
            } else {
              return _processAfter(response);
            }
          };

          done = function done(userResponse) {
            var response;

            if (userResponse !== void 0) {
              response = new Response(userResponse.body || userResponse.text, userResponse);
              resolve(response);

              _processAfter(response);

              return;
            }

            processBefore();
          };

          processBefore = function processBefore() {
            var hook, param;

            if (!beforeHooks.length) {
              send();
              return;
            }

            hook = beforeHooks.shift();

            if (hook.length === 1) {
              param = options;

              if (url instanceof Request) {
                param = url;
              }

              return done(hook(param));
            } else if (hook.length === 2) {
              return hook(getRequest(), done);
            }
          };

          send = function send() {
            return NativeFetch(url, originalOptions).then(function (response) {
              return _processAfter(response);
            })["catch"](function (err) {
              _processAfter(err);

              return reject(err);
            });
          };

          processBefore();
        });
      };
    }

    XHookHttpRequest.UNSENT = 0;
    XHookHttpRequest.OPENED = 1;
    XHookHttpRequest.HEADERS_RECEIVED = 2;
    XHookHttpRequest.LOADING = 3;
    XHookHttpRequest.DONE = 4;

    if (typeof undefined$1 === "function" && undefined$1.amd) {
      undefined$1("xhook", [], function () {
        return xhook;
      });
    } else if (module.exports) {
      module.exports = {
        xhook: xhook
      };
    } else if (WINDOW) {
      WINDOW.xhook = xhook;
    }
  }).call(commonjsGlobal, window);
});
var xhook_1 = xhook.xhook;

// @ts-nocheck
var interceptors = [];
function interceptor(fetch) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var reversedInterceptors = interceptors.reduce(function (array, interceptor) { return [interceptor].concat(array); }, []);
    var promise = Promise.resolve(args);
    // Register request interceptors
    reversedInterceptors.forEach(function (_a) {
        var request = _a.request, requestError = _a.requestError;
        if (request || requestError) {
            promise = promise.then(function (args) { return request.apply(void 0, args); }, requestError);
        }
    });
    // Register fetch call
    promise = promise.then(function (args) { return fetch.apply(void 0, args); });
    // Register response interceptors
    reversedInterceptors.forEach(function (_a) {
        var response = _a.response, responseError = _a.responseError;
        if (response || responseError) {
            promise = promise.then(response, responseError);
        }
    });
    return promise;
}
function attach(env) {
    // Make sure fetch is available in the given environment
    if (typeof env.fetch !== 'function') {
        return null;
    }
    // replace fetch in env (window)
    env.fetch = (function (fetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return interceptor.apply(void 0, __spreadArrays([fetch], args));
        };
    })(env.fetch);
    return {
        register: function (interceptor) {
            interceptors.push(interceptor);
            // return unregister function
            return function () {
                var index = interceptors.indexOf(interceptor);
                if (index >= 0) {
                    interceptors.splice(index, 1);
                }
            };
        },
        clear: function () {
            interceptors = [];
        },
    };
}

/**
 * @file 劫持 XMLHttpRequest，自动记录请求成功、失败打点
 * @author Malcolm Yu
 * @created 2019-11-16
 *
 * 由于发现了一个好用的 hook，这里就不闷头开发了：https://github.com/jpillora/xhook
 */
var validXhook = xhook_1.xhook || xhook_1;
// 引入后先关闭，默认会替换 FormData
validXhook.disable();
var unregister;
var APIMonitor = /** @class */ (function (_super) {
    __extends(APIMonitor, _super);
    function APIMonitor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.queue = [];
        // private xhrLog: APIPerf[] = [];
        _this.key = 'api';
        _this.logList = [];
        _this.perfList = [];
        _this.beforeHook = function (request) {
            // 禁 止 套 娃
            if (!isInURLWhiteList(request.url, _this.radar.ignoreList)) {
                var info = {
                    api: _this.requestURLCompletion(request.url),
                    method: request.method,
                    request: request,
                    startTime: Date.now(),
                };
                _this.queue.push(info);
            }
        };
        // TODO fetch的改动没问题后删除
        // xhook重写了fetch函数，看起来会导致headers前后不相同
        // https://github.com/jpillora/xhook/blob/gh-pages/src/xhook.coffee#L524
        _this.afterHook = function (request, response) {
            var req = _this.queue.filter(function (v) {
                return v.request === request;
            })[0];
            if (!req)
                return;
            // @ts-ignore
            delete req.request;
            var startTime = req.startTime, rest = __rest(req, ["startTime"]);
            var infoStatus = response.status;
            // 如果用户有配置status，则使用用户配置的，返回为0则为异常
            if (typeof _this.options.customizeRadarStatus === 'function') {
                infoStatus = _this.options.customizeRadarStatus(response);
            }
            var contentLength = getResponseSize(response.headers);
            var info = _assign({ duration: Date.now() - startTime, 
                // 字段兼容
                total: Date.now() - startTime, status: infoStatus, size: +contentLength }, rest);
            if (typeof response.text === 'string') {
                info.responseData = response.text;
            }
            // 重新定义一个response，然后进行错误判断
            var judgedResponse = _assign(_assign({}, response), { status: infoStatus });
            var isError = _this.isResponseError(judgedResponse);
            // TODO: 兼容性处理可以更优秀一点
            if (isError) {
                _this.radar.logCollect(_this.sepDimension({
                    key: RADAR_KEY.API,
                    value: info,
                }));
            }
            else {
                _this.logList.push(info);
                _this.mergeAPIPerf(null, info);
            }
            // 过滤掉这个 request，防止内存堆积
            // 由于req的request删了，所以要判断v.request是否存在
            _this.queue = _this.queue.filter(function (v) { return v.request && v.request !== request; });
        };
        return _this;
    }
    APIMonitor.prototype.when = function (entry) {
        if (isInURLWhiteList(entry.name, this.radar.ignoreList)) {
            return false;
        }
        return entry.entryType === 'resource' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
    };
    APIMonitor.prototype.onPerfReport = function (entry) {
        var logData = this.radar.generateLog(apiPerfMap, entry);
        this.perfList.push(logData);
        this.mergeAPIPerf(_assign(_assign({}, logData), { api: logData.file }));
    };
    APIMonitor.prototype.mergeAPIPerf = function (allPerf, info) {
        var item = allPerf || info;
        var list = allPerf ? this.logList : this.perfList;
        if (!item)
            return;
        var index = -1;
        // TODO fetch的改动没问题后删除
        // 每次只处理一个item且fetch请求不会被xhook获取 所以可以单独处理一下fetch
        // 但是上报的信息没有xhr全面。后续有方案了可以补全
        // if (item.res_type === 'fetch') {
        //     delete item.file;
        //     this.radar.logCollect(this.sepDimension({
        //         key: RADAR_KEY.API,
        //         value: item,
        //     }));
        //     return;
        // }
        // xhr需要沿用原有方案
        for (var i = 0, len = list.length; i < len; i++) {
            var listItem = list[i];
            var itemAPI = (item.api || '').replace(/\?.+$/, '');
            var listItemAPI = (listItem.api || '').replace(/\?.+$/, '');
            var perfSize = item.size;
            if (itemAPI === listItemAPI) {
                Object.assign(item, listItem);
                // 这里 file 与 api 重复了
                delete item.file;
                // perf api 中的 size 更精确一些
                if (perfSize) {
                    item.size = perfSize;
                }
                // 依然没有得到 size，尝试计算 responseText 体积
                if (!item.size && item.responseData) {
                    item.size = getStringBytes(item.responseData);
                }
                delete item.responseData;
                index = i;
            }
        }
        if (index !== -1) {
            list.splice(index, 1);
            // 这里如果找不到匹配 API，还不如不报
            this.radar.logCollect(this.sepDimension({
                key: RADAR_KEY.API,
                value: item,
            }));
        }
    };
    APIMonitor.prototype.sepDimension = function (kv) {
        var key = kv.key;
        var _a = kv.value, protocol = _a.protocol, cached = _a.cached, status = _a.status, api = _a.api, method = _a.method, value = __rest(_a, ["protocol", "cached", "status", "api", "method"]);
        var dimension = { protocol: protocol, api: api, status: status, cached: cached, method: method };
        return { key: key, value: value, dimension: dimension };
    };
    APIMonitor.prototype.requestURLCompletion = function (url) {
        var _a = document.location, protocol = _a.protocol, host = _a.host;
        if (url.indexOf('//') === 0) {
            return protocol + url;
        }
        if (url.indexOf('/') === 0) {
            return protocol + "//" + host + url;
        }
        return url;
    };
    APIMonitor.prototype.isResponseError = function (response) {
        // 在 hook 的加持下，可以拿到异常的返回，这里 status 指定为 0
        return response.status === 0;
    };
    APIMonitor.prototype.created = function () {
        validXhook.disable();
        var NATIVE_FORM_DATA = window.FormData;
        validXhook.before(this.beforeHook);
        validXhook.after(this.afterHook);
        validXhook.enable();
        window.FormData = NATIVE_FORM_DATA;
        // @ts-ignore
        var ENVIRONMENT_IS_WORKER = typeof importScripts === 'function';
        var fetchIntercept = attach(ENVIRONMENT_IS_WORKER ? self : window);
        unregister = fetchIntercept && fetchIntercept.register({
            request: function (url, config) {
                // 在afterHook里面得到的request和beforeHook中的不一致的原因:
                // 如果fetch传入的参数是url+config而不是一个Request对象
                // 那么在beforeHook中，xhook会将url+config的形式转化为Request对象
                // https://github.com/jpillora/xhook/blob/gh-pages/src/xhook.coffee#L552
                // 在这里的解法是在fetch请求传入xhook之前，将url+config的形式转化为Request对象，那么前后对比就一致了
                if (!(url instanceof Request)) {
                    url = new Request(url, config);
                }
                return [url, config];
            },
        });
    };
    APIMonitor.prototype.destroy = function () {
        validXhook.disable();
        unregister && unregister();
    };
    return APIMonitor;
}(RadarPlugin));
function getResponseSize(headers) {
    if (!headers) {
        // fix: 接口504可能导致取不到header 会报错
        return 0;
    }
    if (typeof headers.get === 'function') {
        return +headers.get('Content-Length') || 0;
    }
    return +headers['content-length'] || 0;
}

var ErrorMonitor = /** @class */ (function (_super) {
    __extends(ErrorMonitor, _super);
    function ErrorMonitor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.key = 'error';
        // 用于存储页面报错信息，去重，合并上报
        _this.errorQueue = [];
        _this.errorTimeInterval = 2000;
        // 劫持 window.addEventListener('error')
        _this.onResError = function (e) {
            var isScriptError = _this.isScriptError(e);
            var error = e.error;
            if (isScriptError) {
                // 脚本报错
                var logInfo = {
                    error_type: ERROR_KEY.SCRIPT,
                    error_cons_type: e.type,
                    msg: e.message || e.reason,
                    stack: error ? error.stack : null,
                    file: e.filename,
                    line: e.lineno,
                    col: e.colno,
                };
                _this.isSameErrorAndReport(logInfo);
            }
        };
        _this.onPromiseError = function (e) {
            var msg = e.reason && e.reason.message || '';
            var logInfo = {
                error_type: ERROR_KEY.SCRIPT,
                error_cons_type: e.type,
                msg: msg,
            };
            _this.collect(logInfo);
        };
        return _this;
    }
    // error 监听不响应 performance.observe
    ErrorMonitor.prototype.when = function (entry) {
        // 接受 fmp/play_clicked/play_idr 三个自定义指标
        if (entry.custom) {
            var key = (entry.entry || {}).key;
            if (['play_block', 'play_error'].indexOf(key) > -1) {
                return true;
            }
        }
        return false;
    };
    // error 监听不响应 performance.observe
    ErrorMonitor.prototype.onPerfReport = function (entry) {
        // Nothing
        if (entry.custom) {
            var _a = entry.entry || {}, key = _a.key, value = _a.value;
            this.collect({
                error_type: ERROR_KEY.VIDEO,
                error_cons_type: key,
                msg: value,
            });
        }
    };
    ErrorMonitor.prototype.sepDimension = function (kv) {
        var key = kv.key;
        if (key === 'error') {
            var _a = kv.value, file_1 = _a.file, error_cons_type = _a.error_cons_type, error_type = _a.error_type, msg = _a.msg, col = _a.col, line = _a.line, stack = _a.stack, value_1 = __rest(_a, ["file", "error_cons_type", "error_type", "msg", "col", "line", "stack"]);
            var dimension_1 = { error_cons_type: error_cons_type, file: file_1, error_type: error_type, msg: msg, col: col, line: line, stack: stack };
            return { key: key, value: value_1, dimension: dimension_1 };
        }
        // 资源异常的处理
        var _b = kv.value, protocol = _b.protocol, file = _b.file, cached = _b.cached, res_path = _b.res_path, failed = _b.failed, res_type = _b.res_type, value = __rest(_b, ["protocol", "file", "cached", "res_path", "failed", "res_type"]);
        var dimension = { protocol: protocol, file: file, cached: cached, failed: failed, res_path: res_path, res_type: res_type };
        return { key: key, value: value, dimension: dimension };
    };
    ErrorMonitor.prototype.collect = function (logInfo) {
        this.radar.logCollect(this.sepDimension({
            key: RADAR_KEY.ERROR,
            value: logInfo,
        }));
    };
    // 劫持 window onerror
    ErrorMonitor.prototype.isScriptError = function (e) {
        // 有 message 基本上认为是脚本异常了
        return e.message || e.lineno != null;
    };
    ErrorMonitor.prototype.isSameErrorAndReport = function (error) {
        /**
         * collect之前进行筛选
         * 策略是：相同的错误短时间内多次触发算作一条日志
         * 一般认为 同一文件，同一行，同一列的报错为同一错误 不重复收集
         *
         */
        var _this = this;
        if (this.getSameErrorIndex(error) >= 0) {
            return;
        } // 是同一错误则不进行收集
        this.errorQueue.push(error);
        this.collect(error);
        setTimeout(function () {
            // 超过阙值则重置
            // 重新计算他在队列中的位置
            _this.errorQueue.splice(_this.getSameErrorIndex(error), 1);
        }, this.errorTimeInterval);
    };
    /**
     *
     * @param error 错误信息
     * @returns
     */
    ErrorMonitor.prototype.getSameErrorIndex = function (error) {
        for (var i = 0; i < this.errorQueue.length; i++) {
            var e = this.errorQueue[i];
            if (e.file === error.file && e.line === error.line && e.col === error.col) {
                return i;
            }
        }
        return -1;
    };
    ErrorMonitor.prototype.created = function () {
        // 这里会上报重复，感觉没必要
        // window.onerror = (...args) => {
        //     if (typeof this.preWindowErrorHandler === 'function') {
        //         this.preWindowErrorHandler(...args);
        //     }
        //     this.onError(...args);
        // };
        addMonitor(window, 'error', this.onResError, true);
        addMonitor(window, 'unhandledrejection', this.onPromiseError);
    };
    ErrorMonitor.prototype.destroy = function () {
        // window.onerror = this.preWindowErrorHandler;
        removeMonitor(window, 'error', this.onResError, true);
        removeMonitor(window, 'unhandledrejection', this.onPromiseError);
    };
    return ErrorMonitor;
}(RadarPlugin));

/**
 * @file Radar 核心部件，负责插件组合、上报日志处理
 * @author Malcolm Yu
 */
var MORE_REPORTED = ['play_block', 'play_error'];
var CUSTOM_DIM_KEY = ['c_dimension1', 'c_dimension2', 'c_dimension3'];
var Radar = /** @class */ (function (_super) {
    __extends(Radar, _super);
    function Radar(weblog, options) {
        var _this = 
        // this.currentUrlPackage.sampled 
        //
        _super.call(this, weblog, options) || this;
        _this.radarIgnoreList = ['https://web-trace.ksapisrv.com/ktrace/collect'];
        // public ignoreList: string[];
        _this.radarFmp = 0;
        _this.customReported = [];
        if (!_this.validOption()) {
            return _this;
        }
        _this.use(Navigation, _this);
        if (!_this.options || !_this.options.unuseResourcePlugin) {
            _this.use(Resource, _this);
        }
        if (!_this.options || !_this.options.unuseAPIPlugin) {
            _this.use(APIMonitor, _this);
        }
        if (!_this.options || !_this.options.unuseErrorPlugin) {
            _this.use(ErrorMonitor, _this);
        }
        return _this;
    }
    // 采样控制 对外暴露调用
    Radar.samplingControl = function (options) {
        if (!options) {
            return false;
        }
        // 计算随机数
        var rand = Math.random();
        if (typeof options === 'number') {
            // 传入的是单一模块采样率 无需从options中取值
            return rand < options;
        }
        // radar整体采样率逻辑
        var sampling = options.sampling;
        return rand < sampling;
    };
    Radar.prototype.collect = function (key, duration) {
        if (key.indexOf('c_') !== 0) {
            error("[Radar] \u4F20\u5165\u7684\u81EA\u5B9A\u4E49\u6307\u6807 " + key + " \u5FC5\u987B\u4E3A c_ \u5F00\u5934");
            return;
        }
        // 支持 performance API 的可以直接用 performance now
        this.logCollect({
            key: RADAR_KEY.CUSTOM,
            value: {
                metric_value: duration,
            },
            dimension: {
                metric_name: key,
            },
        });
    };
    Radar.prototype.reportTimePoint = function (key, time) {
        if (this.customReported.indexOf(key) > -1) {
            return null;
        }
        // 这两个是可以上报多次的
        if (MORE_REPORTED.indexOf(key) === -1) {
            this.customReported.push(key);
        }
        var value = time;
        if (typeof time !== 'string') {
            // 支持 performance API 的可以直接用 performance now
            var detail = perfNow(time);
            // 没有 performance API 的暂不记录了
            if (detail.value == null)
                return;
            value = this.throttle(detail.value, detail.detail, 'fmp', detail.detail);
        }
        if (value == null)
            return;
        this.reportPerformance({
            custom: true,
            entry: {
                key: key,
                value: value,
            },
            renderTime: time
        });
        return value;
    };
    // 用户自定义系列指标
    Radar.prototype.fmp = function (time) {
        // 记录一下业务上报的fmp的时间戳
        this.radarFmp = time || Date.now();
        var fmp = this.reportTimePoint('fmp', this.radarFmp);
        if (fmp) {
            try {
                // @ts-ignore
                if (performance.timing) {
                    // 获取fmp的时候 添加时间戳到timing上 方便后续计算
                    performance.timing.fmp = fmp;
                    performance.timing.radarFmp = this.radarFmp;
                }
                ;
            }
            catch (e) {
                // do nothing，防止部分机型报错
            }
            // debug模式下记录log
            radarWarnLog('fmp', fmp);
            this.logCollect({
                key: RADAR_KEY.CUSTOM,
                value: {
                    fmp: fmp,
                    fmp_time: this.radarFmp,
                    // 自定义上报是否合并到load表
                    'merge': true
                },
            });
        }
    };
    // 用户定义的事件
    Radar.prototype.event = function (dimension, value) {
        var uaList = getUAList();
        // 处理extra_info
        if (dimension.extra_info && dimension.extra_info instanceof Object) {
            dimension.extra_info = JSON.stringify(dimension.extra_info);
        }
        // 处理yoda_version
        if (dimension.yoda_version === undefined) {
            dimension.yoda_version = uaList.Yoda || '';
        }
        // 处理webview_type
        if (dimension.webview_type === undefined) {
            dimension.webview_type = getWebViewType();
        }
        this.logCollect({
            key: RADAR_KEY.EVENT,
            value: value,
            dimension: dimension,
        });
    };
    // 用于无头浏览器环境手动模拟onload事件内容进行perf数据收集
    Radar.prototype.headlessTestReport = function () {
        var ua = window.navigator.userAgent;
        if (ua.indexOf('headless')) {
            this.asyncReportTiming();
            return;
        }
        console.warn('[radar] report: ', '禁止在正常浏览器中使用手动上报功能');
    };
    Radar.prototype.playClicked = function (time) {
        this.reportTimePoint('play_clicked', time);
    };
    Radar.prototype.playIDR = function (time) {
        this.reportTimePoint('play_idr', time);
    };
    Radar.prototype.playBlock = function (time) {
        this.reportTimePoint('play_block', time);
    };
    Radar.prototype.playError = function (time) {
        this.reportTimePoint('play_error', time);
    };
    Radar.prototype.setDimensions = function (param) {
        var _this = this;
        var paramKey = Object.keys(param);
        var hasOtherDim = paramKey.some(function (key) { return CUSTOM_DIM_KEY.indexOf(key) === -1; });
        if (hasOtherDim) {
            error("[Radar] \u4F20\u5165\u7684\u81EA\u5B9A\u4E49\u7EF4\u5EA6\u53EA\u80FD\u4E3A " + CUSTOM_DIM_KEY.join('、') + "\uFF0C\u76EE\u524D\u4F20\u5165\u7684\u662F\uFF1A" + paramKey.join('、'));
        }
        paramKey.forEach(function (key) {
            var k = key;
            if (param[k] == null) {
                delete _this.customDimension[k];
            }
            else {
                _this.customDimension[k] = param[k];
            }
        });
    };
    Radar.prototype.validOption = function () {
        if (!this.options) {
            // 未传入参数默认不开启
            return false;
        }
        var _a = this.options, sampling = _a.sampling, projectId = _a.projectId;
        if (typeof projectId !== 'string') {
            error('[Radar] 必须配置 projectId 属性');
            return false;
        }
        if (sampling > 1 || sampling < 0) {
            error('[Radar] 采样率 sampling 必须在 0~1 之间');
            return false;
        }
        return true;
    };
    Radar.key = 'radar';
    return Radar;
}(RadarRoot));

var RadarPlaceHolder = /** @class */ (function (_super) {
    __extends(RadarPlaceHolder, _super);
    function RadarPlaceHolder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadarPlaceHolder.prototype.fmp = function () {
        // do nothing
    };
    RadarPlaceHolder.prototype.event = function () {
        // do nothing
    };
    RadarPlaceHolder.prototype.headlessTestReport = function () {
        // do nothing
    };
    RadarPlaceHolder.prototype.playClicked = function () { };
    RadarPlaceHolder.prototype.playIDR = function () { };
    RadarPlaceHolder.prototype.playBlock = function () { };
    RadarPlaceHolder.prototype.playError = function () { };
    RadarPlaceHolder.prototype.setDimensions = function () { };
    RadarPlaceHolder.prototype.destroy = function () {
        // do nothing
    };
    RadarPlaceHolder.key = 'radar';
    return RadarPlaceHolder;
}(BasePlugin));

if (!performanceTiming) {
    console.warn('Your browser don\'t support performance API, the auto pv duration may not correct');
}
var willunload = false;
var AutoPV = /** @class */ (function (_super) {
    __extends(AutoPV, _super);
    function AutoPV(weblog, options) {
        var _this = _super.call(this) || this;
        _this.oldPushState = history.pushState;
        _this.oldReplaceState = history.replaceState;
        _this.beginTime = performanceTiming && performanceTiming.fetchStart
            || new Date().valueOf();
        _this.visibilityChange = function () {
            var state = document.visibilityState;
            if (state === 'visible') {
                willunload = false;
            }
            // 页面关闭也会触发 hidden 事件，这种情况下不再上报事件
            if (!_this.weblog || willunload)
                return;
            if (_this.autoPVFilter(location.href, null, state)) {
                if (state === 'hidden' || state === 'visible') {
                    if (state === 'visible')
                        _this.beginTime = new Date().valueOf();
                    _this.weblog.collect('PV', {
                        type: state,
                        auto: true,
                        beginTime: _this.beginTime
                    });
                }
            }
        };
        _this.proxyPushState = function (data, title, url) {
            _this.urlChange();
            return _this.oldPushState.call(history, data, title, url);
        };
        _this.proxyReplaceState = function (data, title, url) {
            _this.urlChange();
            return _this.oldReplaceState.call(history, data, title, url);
        };
        _this.urlChange = function () {
            setTimeout(function () {
                if (!_this.weblog)
                    return;
                var _a = getMappingPage({ url: location.href }, _this.weblog.logConfig.urlMap), page = _a.page, params = _a.params;
                if (page && page === _this.weblog.currentUrlPackage.page) {
                    _this.weblog.currentUrlPackage.update(page, params);
                    return;
                }
                if (_this.autoPVFilter(location.href, _this.weblog.currentUrl, 'leave')) {
                    // 触发旧页面离开
                    _this.weblog.collect('PV', {
                        type: 'leave',
                        auto: true,
                        beginTime: _this.beginTime
                    });
                }
                if (_this.autoPVFilter(location.href, _this.weblog.currentUrl, 'enter')) {
                    // 更新当前页面信息
                    _this.weblog.updateReferUrlPackage();
                    _this.weblog.updateCurrentUrlPackage(location.href);
                    // 更新新页面 enter 时间
                    _this.beginTime = new Date().valueOf();
                    _this.weblog.collect('PV', {
                        type: 'enter',
                        auto: true,
                    });
                }
            });
        };
        _this.beforeUnload = function () {
            willunload = true;
            if (!_this.weblog || !_this.autoPVFilter(location.href, null, 'leave')) {
                return;
            }
            _this.weblog.sendImmediately('PV', {
                type: 'leave',
                auto: true,
                beginTime: _this.beginTime
            });
        };
        _this.autoPVFilter = function () { return true; };
        // 兼容处理
        if (weblog) {
            if (typeof weblog === 'function') {
                _this.autoPVFilter = weblog;
            }
            else if ('collect' in weblog && typeof weblog.collect === 'function') {
                if (options === null || options === void 0 ? void 0 : options.autoPVFilter) {
                    _this.autoPVFilter = options.autoPVFilter;
                }
                _this.apply(weblog);
            }
            else if ('autoPVFilter' in weblog && weblog.autoPVFilter) {
                _this.autoPVFilter = weblog.autoPVFilter;
            }
        }
        if (options && typeof options.autoPVFilter === 'function') {
            _this.autoPVFilter = options.autoPVFilter;
        }
        return _this;
    }
    AutoPV.prototype.apply = function (weblog) {
        var _this = this;
        if (!weblog || !weblog.collect)
            return;
        this.weblog = weblog;
        setTimeout(function () {
            if (_this.autoPVFilter(location.href, null, 'enter')) {
                _this.weblog.collect('PV', {
                    type: 'enter',
                    auto: true
                });
            }
        });
        history.pushState = this.proxyPushState;
        history.replaceState = this.proxyReplaceState;
        addMonitor(window, urlChangeEventId, this.urlChange);
        addMonitor(document, 'visibilitychange', this.visibilityChange);
    };
    AutoPV.prototype.destroy = function () {
        removeMonitor(window, urlChangeEventId, this.urlChange);
        removeMonitor(document, 'visibilitychange', this.visibilityChange);
        history.pushState = this.oldPushState;
        history.replaceState = this.oldReplaceState;
    };
    AutoPV.key = 'autoPV';
    return AutoPV;
}(BasePlugin));

/**
 * 浏览器版本，只有 HTTP 上报，兼容旧版本包含了插件
 */
var Weblog = /** @class */ (function (_super) {
    __extends(Weblog, _super);
    function Weblog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Weblog.prototype.initBuildInPlugins = function () {
        var _a = this.logConfig, autoPV = _a.autoPV, radar = _a.radar, fps = _a.fps, timing = _a.timing, crash = _a.crash, autoPVFilter = _a.autoPVFilter;
        // 这三个插件不再默认开启
        fps && this.plug(FPSMonitor);
        timing && this.plug(TimingMonitor);
        crash && this.plug(CrashMonitor);
        if (autoPV || typeof autoPV === 'undefined') {
            this.plug(AutoPV, { autoPVFilter: autoPVFilter });
        }
        if (radar) {
            if (radar.sampling && Radar.samplingControl(radar)) {
                this.plug(Radar, radar);
            }
            else {
                this.plug(RadarPlaceHolder);
            }
        }
    };
    return Weblog;
}(Weblog$1));
// 注册到全局对象
if (typeof window !== 'undefined') {
    if (typeof window._GLOBAL_KS_WEBLOGGER_ !== 'undefined') {
        window._GLOBAL_KS_WEBLOGGER_.Factory = Weblog;
    }
    else {
        // @ts-ignore
        window.Weblog = Weblog;
    }
}

exports.BasePlugin = BasePlugin;
exports.Weblog = Weblog;
exports.default = Weblog;
//# sourceMappingURL=log.common.js.map
